{
  "level": "ho03",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:ho03",
    "objects": "AREAS.E3:ho03.e3",
    "mesh": "TREES.E3:ho03.e3"
  },
  "spawn_point": {
    "position": [
      89.03541347312,
      1185.2037297542001,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      89.03541347312,
      1285.2037297542001,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -1850.0902099609375,
      -2850.33056640625,
      -300.0
    ],
    "bbox_max": [
      6532.3798828125,
      7186.23974609375,
      2025.39453125
    ],
    "vertex_count": 1851,
    "vertices": [
      [
        4547.47998046875,
        5909.91845703125,
        1135.4051513671875
      ],
      [
        3163.701416015625,
        6834.52880859375,
        610.11962890625
      ],
      [
        5764.48095703125,
        5096.74462890625,
        1469.6295166015625
      ],
      [
        4547.47998046875,
        5909.91845703125,
        1135.405029296875
      ],
      [
        5957.56005859375,
        4967.7333984375,
        1590.8251953125
      ],
      [
        5764.48095703125,
        5096.74462890625,
        1469.62939453125
      ],
      [
        6145.49169921875,
        4991.369140625,
        1843.7510986328125
      ],
      [
        6000.23779296875,
        4939.21728515625,
        1686.8756103515625
      ],
      [
        5957.56005859375,
        4967.7333984375,
        1590.8251953125
      ],
      [
        6145.49169921875,
        4991.369140625,
        1843.751220703125
      ],
      [
        6430.5654296875,
        4834.6591796875,
        1974.9913330078125
      ],
      [
        6051.90966796875,
        4904.69091796875,
        1803.1688232421875
      ],
      [
        6532.3798828125,
        4583.6513671875,
        2025.39453125
      ],
      [
        6051.90966796875,
        4904.69091796875,
        1803.1688232421875
      ],
      [
        2637.3291015625,
        7186.23974609375,
        703.6844482421875
      ],
      [
        3017.69189453125,
        6932.08935546875,
        638.5988159179688
      ],
      [
        3017.69189453125,
        6932.08935546875,
        638.5988159179688
      ],
      [
        3163.701416015625,
        6834.52880859375,
        610.11962890625
      ],
      [
        4150.62451171875,
        1343.3211669921875,
        834.5104370117188
      ],
      [
        4137.6171875,
        1715.807373046875,
        911.6276245117188
      ],
      [
        4150.62451171875,
        1343.3211669921875,
        834.5104370117188
      ],
      [
        4150.75,
        1339.7322998046875,
        833.3546142578125
      ],
      [
        6281.5830078125,
        4751.228515625,
        1909.3966064453125
      ],
      [
        5234.20947265625,
        3452.511474609375,
        1461.146240234375
      ],
      [
        4137.6171875,
        2092.76416015625,
        991.8312377929688
      ],
      [
        4137.6171875,
        1715.807373046875,
        911.6276245117188
      ],
      [
        4124.29296875,
        2097.36865234375,
        985.7462768554688
      ],
      [
        4096.705078125,
        2887.374755859375,
        959.0196533203125
      ],
      [
        4089.31982421875,
        3098.861328125,
        938.4326782226562
      ],
      [
        4117.16162109375,
        2301.5830078125,
        1016.0430908203125
      ],
      [
        4118.2841796875,
        2269.442626953125,
        1019.1718139648438
      ],
      [
        4118.24951171875,
        2270.430419921875,
        1019.3637084960938
      ],
      [
        4117.16162109375,
        2301.583251953125,
        1016.0430908203125
      ],
      [
        4118.24951171875,
        2270.430419921875,
        1019.3637084960938
      ],
      [
        4031.279296875,
        4760.92822265625,
        0.0
      ],
      [
        4024.458251953125,
        4956.259765625,
        44.4617919921875
      ],
      [
        4024.458251953125,
        4956.259765625,
        44.461708068847656
      ],
      [
        4021.62939453125,
        5037.267578125,
        101.1990966796875
      ],
      [
        4021.62939453125,
        5037.267578125,
        101.1990737915039
      ],
      [
        3977.8642578125,
        6290.52294921875,
        919.177734375
      ],
      [
        4059.008056640625,
        3966.878662109375,
        0.0
      ],
      [
        4059.62060546875,
        3949.339111328125,
        65.54586791992188
      ],
      [
        4087.392822265625,
        3154.043701171875,
        933.0609741210938
      ],
      [
        4296.39453125,
        -2830.98681640625,
        1946.677734375
      ],
      [
        4278.67626953125,
        -2323.59375,
        1464.79150390625
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      [
        3966.75,
        4947.60009765625,
        -13.693603515625
      ],
      [
        3986.6806640625,
        4979.27001953125,
        32.464378356933594
      ],
      [
        3170.046875,
        6830.2890625,
        612.5284423828125
      ],
      [
        4000.44775390625,
        4954.3212890625,
        24.79583168029785
      ],
      [
        3986.6806640625,
        4979.27001953125,
        32.464378356933594
      ],
      [
        4000.44775390625,
        4954.3212890625,
        24.79587745666504
      ],
      [
        3999.89697265625,
        4949.3115234375,
        23.07600212097168
      ],
      [
        3992.506103515625,
        4882.0908203125,
        0.0
      ],
      [
        3956.206787109375,
        5048.34375,
        54.11029052734375
      ],
      [
        4020.44775390625,
        5071.1044921875,
        123.28400421142578
      ],
      [
        2200.0,
        -2834.78271484375,
        1830.86083984375
      ],
      [
        2200.0,
        -2087.5,
        1121.050048828125
      ],
      [
        3317.77783203125,
        3319.888916015625,
        100.00000762939453
      ],
      [
        3966.056884765625,
        3861.65869140625,
        100.0
      ],
      [
        2923.153076171875,
        1830.0,
        239.58474731445312
      ],
      [
        2917.732666015625,
        1985.22265625,
        228.48062133789062
      ],
      [
        2878.090087890625,
        3120.435546875,
        137.21926879882812
      ],
      [
        2889.345947265625,
        2798.10986328125,
        170.32931518554688
      ],
      [
        2889.345947265625,
        2798.10986328125,
        170.32931518554688
      ],
      [
        2780.0,
        2676.666748046875,
        100.0
      ],
      [
        2804.21044921875,
        3033.157958984375,
        100.0
      ],
      [
        2814.28564453125,
        3107.142822265625,
        100.0
      ],
      [
        2804.21044921875,
        3033.157958984375,
        100.0
      ],
      [
        -1739.068359375,
        -2556.84375,
        -300.0
      ],
      [
        -1791.9246826171875,
        -2599.128662109375,
        -300.0
      ],
      [
        -1502.348388671875,
        -2413.1201171875,
        0.0
      ],
      [
        -1074.7418212890625,
        -2798.138916015625,
        1382.2545166015625
      ],
      [
        -1502.348388671875,
        -2413.1201171875,
        0.0
      ],
      [
        -1576.8857421875,
        -2346.006103515625,
        -300.0
      ],
      [
        -1806.8819580078125,
        -2604.802001953125,
        -300.0
      ],
      [
        -1850.0902099609375,
        -2621.19140625,
        -300.0
      ],
      [
        -1074.7418212890625,
        -2798.138916015625,
        1382.2545166015625
      ],
      [
        -1016.7769165039062,
        -2850.33056640625,
        1659.98291015625
      ],
      [
        -1181.6776123046875,
        -1476.3109130859375,
        -285.9705505371094
      ],
      [
        -279.618896484375,
        -1127.742431640625,
        -300.0
      ],
      [
        64.31683349609375,
        -1071.06201171875,
        0.0
      ],
      [
        571.793701171875,
        -1133.334716796875,
        96.11875915527344
      ],
      [
        64.31683349609375,
        -1071.06201171875,
        0.0
      ],
      [
        502.19775390625,
        -759.136474609375,
        -264.3855895996094
      ],
      [
        -280.0,
        566.3043212890625,
        100.0
      ],
      [
        -280.0,
        423.6956481933594,
        100.0
      ],
      [
        -280.0,
        470.0,
        60.0
      ],
      [
        -280.0,
        249.4182586669922,
        60.0
      ],
      [
        -280.0,
        520.0,
        60.0
      ],
      [
        -280.0,
        470.0,
        60.0
      ],
      [
        -355.0,
        419.3478088378906,
        80.0
      ],
      [
        -355.0,
        460.0,
        80.0
      ],
      [
        -390.0,
        460.0,
        80.0
      ],
      [
        -355.0,
        460.0,
        80.0
      ],
      [
        -355.0,
        423.6956481933594,
        100.0
      ],
      [
        -355.0,
        460.0,
        100.0
      ],
      [
        -390.0,
        460.0,
        100.0
      ],
      [
        -355.0,
        460.0,
        100.0
      ],
      [
        -305.0,
        435.0,
        100.0
      ],
      [
        -290.0,
        435.0,
        100.0
      ],
      [
        -355.0,
        570.6521606445312,
        80.0
      ],
      [
        -355.0,
        530.0,
        80.0
      ],
      [
        -355.0,
        570.6521606445312,
        80.0
      ],
      [
        -355.0,
        570.6521606445312,
        80.0
      ],
      [
        -390.0,
        570.6521606445312,
        80.0
      ],
      [
        -280.0,
        570.6521606445312,
        80.0
      ],
      [
        -315.0,
        570.6521606445312,
        80.0
      ],
      [
        -355.0,
        566.3043212890625,
        100.0
      ],
      [
        -355.0,
        530.0,
        100.0
      ],
      [
        -355.0,
        566.3043212890625,
        100.0
      ],
      [
        -355.0,
        566.3043212890625,
        100.0
      ],
      [
        -390.0,
        566.3043212890625,
        100.0
      ],
      [
        -280.0,
        566.3043212890625,
        100.0
      ],
      [
        -315.0,
        566.3043212890625,
        100.0
      ],
      [
        -200.0,
        470.0,
        120.0
      ],
      [
        -200.0,
        470.0,
        140.0
      ],
      [
        -200.0,
        455.0,
        140.0
      ],
      [
        -200.0,
        280.0,
        140.0
      ],
      [
        -200.0,
        470.0,
        140.0
      ],
      [
        -200.0,
        455.0,
        140.0
      ],
      [
        -200.0,
        470.0,
        120.0
      ],
      [
        -200.0,
        460.0,
        110.0
      ],
      [
        137.4235076904297,
        690.0,
        160.0
      ],
      [
        228.09024047851562,
        690.0,
        160.0
      ],
      [
        228.09024047851562,
        690.0,
        160.0
      ],
      [
        250.98464965820312,
        690.0,
        160.0
      ],
      [
        137.42349243164062,
        690.0,
        160.0
      ],
      [
        250.98464965820312,
        690.0,
        160.0
      ],
      [
        254.0325927734375,
        690.0,
        160.0
      ],
      [
        228.09024047851562,
        690.0,
        280.0
      ],
      [
        137.42349243164062,
        690.0,
        280.0
      ],
      [
        250.98464965820312,
        690.0,
        280.0
      ],
      [
        228.09024047851562,
        690.0,
        280.0
      ],
      [
        137.4235076904297,
        690.0,
        280.0
      ],
      [
        228.09024047851562,
        690.0,
        350.0
      ],
      [
        137.42349243164062,
        690.0,
        350.0
      ],
      [
        250.98464965820312,
        690.0,
        350.0
      ],
      [
        228.09024047851562,
        690.0,
        350.0
      ],
      [
        137.4235076904297,
        690.0,
        350.0
      ],
      [
        254.0325927734375,
        690.0,
        350.0
      ],
      [
        250.98464965820312,
        690.0,
        350.0
      ],
      [
        254.0325927734375,
        690.0,
        350.0
      ],
      [
        254.0325927734375,
        690.0,
        420.0
      ],
      [
        254.0325927734375,
        650.0,
        350.0
      ],
      [
        254.0325927734375,
        690.0,
        280.0
      ],
      [
        254.0325927734375,
        650.0,
        280.0
      ],
      [
        137.4235076904297,
        690.0,
        230.0
      ],
      [
        228.09024047851562,
        690.0,
        230.0
      ],
      [
        228.09024047851562,
        690.0,
        230.0
      ],
      [
        250.98464965820312,
        690.0,
        230.0
      ],
      [
        137.42349243164062,
        690.0,
        230.0
      ],
      [
        250.98464965820312,
        690.0,
        230.0
      ],
      [
        254.0325927734375,
        690.0,
        230.0
      ],
      [
        254.0325927734375,
        690.0,
        160.0
      ],
      [
        254.0325927734375,
        690.0,
        230.0
      ],
      [
        254.0325927734375,
        650.0,
        230.0
      ],
      [
        -390.0,
        460.0,
        116.0
      ],
      [
        -305.0,
        435.0,
        116.0
      ],
      [
        -290.0,
        435.0,
        116.0
      ],
      [
        -355.0,
        565.0,
        100.0
      ],
      [
        -355.0,
        565.0,
        100.0
      ],
      [
        -305.0,
        435.0,
        140.0
      ],
      [
        -290.0,
        435.0,
        140.0
      ],
      [
        1645.0,
        1469.9998779296875,
        500.0
      ],
      [
        1645.0,
        1469.9998779296875,
        1180.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1130.0
      ],
      [
        1910.0,
        1881.243408203125,
        1130.0
      ],
      [
        1910.0,
        1876.693359375,
        1060.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1060.0
      ],
      [
        1910.0,
        1812.9427490234375,
        1106.0
      ],
      [
        1645.0,
        1830.0,
        370.0
      ],
      [
        1645.0,
        1830.0,
        500.0
      ],
      [
        1645.0,
        1830.0,
        500.0
      ],
      [
        1645.0,
        1830.0,
        1180.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1910.0,
        1831.2440185546875,
        1130.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1892.9427490234375,
        1830.0,
        1106.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1910.0,
        1830.0,
        1130.0
      ],
      [
        1706.639892578125,
        1830.0,
        1130.0
      ],
      [
        1675.58154296875,
        1830.0,
        1130.0
      ],
      [
        1704.19970703125,
        1830.0,
        1060.0
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      [
        1660.0,
        1767.4713134765625,
        1130.0
      ],
      [
        190.0,
        1715.052978515625,
        0.0
      ],
      [
        190.0,
        1693.45361328125,
        60.0
      ],
      [
        1350.0,
        1390.0,
        579.8990478515625
      ],
      [
        1350.0,
        1390.0,
        490.0
      ],
      [
        1520.0,
        1390.0,
        700.1072387695312
      ],
      [
        1630.0,
        1390.0,
        777.8890380859375
      ],
      [
        1350.0,
        1390.0,
        579.8990478515625
      ],
      [
        1420.0,
        1390.0,
        629.3965454101562
      ],
      [
        1520.0,
        1390.0,
        700.1072387695312
      ],
      [
        1520.0,
        1390.0,
        490.0
      ],
      [
        1350.0,
        960.7692260742188,
        80.0
      ],
      [
        1350.0,
        910.7692260742188,
        80.0
      ],
      [
        1174.9146728515625,
        1300.0,
        515.0
      ],
      [
        1030.0,
        1300.0,
        370.085205078125
      ],
      [
        1174.9146728515625,
        1310.0,
        515.0
      ],
      [
        1175.0,
        1310.0,
        515.0852661132812
      ],
      [
        1029.5869140625,
        1100.4130859375,
        369.672119140625
      ],
      [
        1029.5869140625,
        949.5869140625,
        369.672119140625
      ],
      [
        1039.9146728515625,
        979.9147338867188,
        380.0
      ],
      [
        1029.5867919921875,
        970.0,
        369.672119140625
      ],
      [
        1018.0,
        880.0,
        80.0
      ],
      [
        1018.0,
        930.0,
        80.0
      ],
      [
        1029.1378173828125,
        969.5689086914062,
        369.22308349609375
      ],
      [
        1029.1378173828125,
        949.1378173828125,
        369.22308349609375
      ],
      [
        1029.1378173828125,
        969.5689086914062,
        369.22308349609375
      ],
      [
        1034.7249755859375,
        1300.0,
        515.0
      ],
      [
        1030.0,
        1300.0,
        379.9999084472656
      ],
      [
        1045.0,
        1072.0,
        795.8037719726562
      ],
      [
        1045.0,
        1072.0,
        750.0
      ],
      [
        1045.0,
        978.0140380859375,
        750.0
      ],
      [
        1045.0,
        978.013916015625,
        795.7902221679688
      ],
      [
        1044.56787109375,
        1072.43212890625,
        796.2268676757812
      ],
      [
        1042.949951171875,
        1074.050048828125,
        750.0
      ],
      [
        1042.949951171875,
        975.9603881835938,
        750.0
      ],
      [
        1044.5675048828125,
        977.5806884765625,
        796.2144165039062
      ],
      [
        1029.640380859375,
        970.0513305664062,
        369.7255859375
      ],
      [
        1029.5867919921875,
        969.9998779296875,
        369.6720275878906
      ],
      [
        1549.9998779296875,
        1550.0,
        500.0
      ],
      [
        1549.9998779296875,
        1550.0,
        1180.0
      ],
      [
        1549.9998779296875,
        1400.0,
        728.3914184570312
      ],
      [
        1549.9998779296875,
        1390.0,
        721.3203735351562
      ],
      [
        1010.0,
        1520.0,
        350.0852355957031
      ],
      [
        1010.0,
        1540.0,
        350.0852355957031
      ],
      [
        1174.9146728515625,
        1470.0,
        515.0
      ],
      [
        1175.0,
        1470.0,
        515.0852661132812
      ],
      [
        1550.0,
        1910.0,
        370.0
      ],
      [
        1550.0,
        1910.0,
        500.0
      ],
      [
        1550.0,
        1910.0,
        370.0
      ],
      [
        1550.0,
        1910.0,
        140.0
      ],
      [
        1550.0,
        1910.0,
        500.0
      ],
      [
        1550.0,
        1910.0,
        1180.0
      ],
      [
        254.03260803222656,
        820.0,
        160.0
      ],
      [
        254.03260803222656,
        820.0,
        420.0
      ],
      [
        760.0,
        820.0,
        118.0
      ],
      [
        760.0,
        820.0,
        120.0
      ],
      [
        760.0,
        820.0,
        140.0
      ],
      [
        760.0,
        820.0,
        220.0
      ],
      [
        780.0,
        820.0,
        120.0
      ],
      [
        800.0,
        820.0,
        120.0
      ],
      [
        760.0,
        820.0,
        120.0
      ],
      [
        780.0,
        820.0,
        120.0
      ],
      [
        780.0,
        820.0,
        80.0
      ],
      [
        780.0,
        820.0,
        60.0
      ],
      [
        780.0,
        820.0,
        120.0
      ],
      [
        780.0,
        820.0,
        80.0
      ],
      [
        760.0,
        820.0,
        80.0
      ],
      [
        740.0,
        820.0,
        80.0
      ],
      [
        740.0,
        820.0,
        80.0
      ],
      [
        740.0,
        820.0,
        78.0
      ],
      [
        195.3977813720703,
        820.0,
        230.0
      ],
      [
        241.07882690429688,
        820.0,
        230.0
      ],
      [
        241.07882690429688,
        820.0,
        230.0
      ],
      [
        254.03260803222656,
        820.0,
        230.0
      ],
      [
        195.3977813720703,
        820.0,
        160.0
      ],
      [
        241.07882690429688,
        820.0,
        160.0
      ],
      [
        241.07882690429688,
        820.0,
        160.0
      ],
      [
        254.03260803222656,
        820.0,
        160.0
      ],
      [
        195.3977813720703,
        820.0,
        140.0
      ],
      [
        183.3708953857422,
        820.0,
        140.0
      ],
      [
        183.72076416015625,
        802.5241088867188,
        120.0
      ],
      [
        183.72076416015625,
        802.5241088867188,
        140.0
      ],
      [
        169.20310974121094,
        780.796875,
        140.0
      ],
      [
        183.3708953857422,
        820.0,
        120.0
      ],
      [
        183.3708953857422,
        820.0,
        140.0
      ],
      [
        195.3977813720703,
        820.0,
        120.0
      ],
      [
        195.3977813720703,
        820.0,
        140.0
      ],
      [
        195.3977813720703,
        820.0,
        160.0
      ],
      [
        195.3977813720703,
        820.0,
        230.0
      ],
      [
        195.3977813720703,
        820.0,
        210.0
      ],
      [
        241.07882690429688,
        820.0,
        350.0
      ],
      [
        195.3977813720703,
        820.0,
        350.0
      ],
      [
        254.03260803222656,
        820.0,
        350.0
      ],
      [
        241.07882690429688,
        820.0,
        350.0
      ],
      [
        195.3977813720703,
        820.0,
        370.0
      ],
      [
        195.3977813720703,
        820.0,
        350.0
      ],
      [
        241.07882690429688,
        820.0,
        280.0
      ],
      [
        195.3977813720703,
        820.0,
        280.0
      ],
      [
        195.3977813720703,
        820.0,
        300.0
      ],
      [
        195.3977813720703,
        820.0,
        280.0
      ],
      [
        739.914794921875,
        1420.0,
        80.0
      ],
      [
        739.914794921875,
        1439.90625,
        80.0
      ],
      [
        739.914794921875,
        960.0,
        80.0
      ],
      [
        739.914794921875,
        940.0,
        80.0
      ],
      [
        739.914794921875,
        1439.90625,
        80.0
      ],
      [
        739.914794921875,
        1550.085205078125,
        80.0
      ],
      [
        820.0,
        1540.0,
        64.44444274902344
      ],
      [
        820.0,
        1450.0,
        64.44444274902344
      ],
      [
        740.0,
        930.0,
        80.0
      ],
      [
        740.0,
        930.0,
        78.0
      ],
      [
        720.0,
        930.0,
        60.0
      ],
      [
        726.6382446289062,
        926.6382446289062,
        66.72349548339844
      ],
      [
        720.0,
        929.9573974609375,
        60.0851936340332
      ],
      [
        780.0,
        970.0,
        80.0
      ],
      [
        780.0,
        1120.0,
        80.0
      ],
      [
        820.0,
        1540.0,
        80.0
      ],
      [
        820.0,
        1450.0,
        80.0
      ],
      [
        720.0,
        1450.0,
        60.0
      ],
      [
        720.0,
        1450.0426025390625,
        60.08519744873047
      ],
      [
        726.6382446289062,
        1453.3616943359375,
        66.72349548339844
      ],
      [
        737.914794921875,
        960.0,
        78.0
      ],
      [
        739.914794921875,
        960.0,
        80.0
      ],
      [
        780.0,
        930.0,
        110.0
      ],
      [
        960.0,
        930.0,
        110.0
      ],
      [
        780.0,
        820.0,
        110.0
      ],
      [
        780.0,
        930.0,
        110.0
      ],
      [
        820.0,
        1540.0,
        110.0
      ],
      [
        820.0,
        1450.0,
        110.0
      ],
      [
        836.0,
        930.0,
        110.0
      ],
      [
        836.0,
        950.0,
        110.0
      ],
      [
        836.0,
        950.0,
        110.0
      ],
      [
        779.914794921875,
        950.0,
        120.0
      ],
      [
        777.914794921875,
        950.0,
        118.0
      ],
      [
        799.914794921875,
        950.0,
        140.0
      ],
      [
        819.914794921875,
        950.0,
        160.0
      ],
      [
        839.914794921875,
        950.0,
        180.0
      ],
      [
        859.914794921875,
        950.0,
        200.0
      ],
      [
        799.914794921875,
        950.0,
        140.0
      ],
      [
        879.9147338867188,
        950.0,
        220.0
      ],
      [
        986.2361450195312,
        930.0,
        120.0
      ],
      [
        980.0,
        930.0,
        120.0
      ],
      [
        960.0,
        930.0,
        120.0
      ],
      [
        980.0,
        930.0,
        120.0
      ],
      [
        779.9147338867188,
        820.0,
        120.0
      ],
      [
        779.9147338867188,
        930.0,
        120.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        960.0,
        930.0,
        120.0
      ],
      [
        960.0,
        930.0,
        160.0
      ],
      [
        819.914794921875,
        910.0,
        160.0
      ],
      [
        819.914794921875,
        930.0,
        160.0
      ],
      [
        960.0,
        930.0,
        200.0
      ],
      [
        859.914794921875,
        910.0,
        200.0
      ],
      [
        859.914794921875,
        930.0,
        200.0
      ],
      [
        819.914794921875,
        950.0,
        160.0
      ],
      [
        1000.0,
        950.0,
        120.0
      ],
      [
        779.9147338867188,
        930.0852661132812,
        120.0
      ],
      [
        779.914794921875,
        950.0,
        120.0
      ],
      [
        779.9147338867188,
        930.0852661132812,
        120.0
      ],
      [
        859.914794921875,
        950.0,
        200.0
      ],
      [
        860.0,
        980.5,
        120.0
      ],
      [
        860.0,
        970.5,
        120.0
      ],
      [
        860.0,
        970.5,
        120.0
      ],
      [
        870.0,
        970.5,
        120.0
      ],
      [
        849.914794921875,
        974.3346557617188,
        190.0
      ],
      [
        849.914794921875,
        985.03125,
        190.0
      ],
      [
        860.0,
        1119.4947509765625,
        170.0
      ],
      [
        865.0,
        1121.3931884765625,
        190.0
      ],
      [
        860.0,
        1119.4947509765625,
        190.0
      ],
      [
        860.0140991210938,
        970.5,
        170.0
      ],
      [
        860.0,
        970.50537109375,
        170.0
      ],
      [
        860.0,
        970.50537109375,
        190.0
      ],
      [
        860.0140991210938,
        970.5,
        190.0
      ],
      [
        860.0140991210938,
        970.5,
        170.0
      ],
      [
        860.0,
        970.50537109375,
        170.0
      ],
      [
        860.0,
        970.50537109375,
        190.0
      ],
      [
        860.0140991210938,
        970.5,
        190.0
      ],
      [
        829.914794921875,
        981.9285278320312,
        170.0
      ],
      [
        849.914794921875,
        974.3346557617188,
        190.0
      ],
      [
        829.914794921875,
        981.9285278320312,
        170.0
      ],
      [
        849.914794921875,
        974.3346557617188,
        190.0
      ],
      [
        829.914794921875,
        1108.071533203125,
        170.0
      ],
      [
        849.914794921875,
        1115.6654052734375,
        190.0
      ],
      [
        865.0,
        968.6068725585938,
        190.0
      ],
      [
        849.914794921875,
        985.03125,
        190.0
      ],
      [
        865.0,
        979.303466796875,
        205.08523559570312
      ],
      [
        865.0,
        1121.3931884765625,
        205.085205078125
      ],
      [
        865.0,
        968.6068725585938,
        205.085205078125
      ],
      [
        825.9805908203125,
        950.0,
        180.0
      ],
      [
        825.9806518554688,
        950.0,
        200.0
      ],
      [
        825.9805908203125,
        950.0,
        166.0657958984375
      ],
      [
        825.9805908203125,
        950.0,
        220.0
      ],
      [
        825.9806518554688,
        950.0,
        200.0
      ],
      [
        844.055419921875,
        910.0,
        200.0
      ],
      [
        739.914794921875,
        949.5344848632812,
        80.0
      ],
      [
        735.6064453125,
        940.0,
        80.0
      ],
      [
        720.0,
        1420.0,
        80.0
      ],
      [
        720.0,
        1420.0,
        78.0
      ],
      [
        720.0,
        1420.0,
        80.0
      ],
      [
        720.0,
        2350.0,
        240.0
      ],
      [
        720.0,
        2260.0,
        240.0
      ],
      [
        680.0,
        1420.0,
        78.0
      ],
      [
        631.7507934570312,
        1420.0,
        78.0
      ],
      [
        631.7508544921875,
        1420.0,
        80.0
      ],
      [
        680.0,
        1420.0,
        80.0
      ],
      [
        680.0,
        1420.0,
        80.0
      ],
      [
        631.7507934570312,
        1420.0,
        80.0
      ],
      [
        659.2786254882812,
        1440.0,
        80.0
      ],
      [
        680.0,
        1440.0,
        80.0
      ],
      [
        680.0,
        1450.0,
        60.0
      ],
      [
        673.0423583984375,
        1450.0,
        60.0
      ],
      [
        680.0,
        1455.0550537109375,
        70.11000061035156
      ],
      [
        564.12646484375,
        1450.0,
        60.0
      ],
      [
        567.3756713867188,
        1460.0,
        80.0
      ],
      [
        680.0,
        1460.0,
        80.0
      ],
      [
        535.7269287109375,
        1362.5953369140625,
        80.0
      ],
      [
        547.8804931640625,
        1400.0,
        80.0
      ],
      [
        554.3788452148438,
        1420.0,
        78.0
      ],
      [
        554.3788452148438,
        1420.0,
        80.0
      ],
      [
        509.28570556640625,
        1450.0,
        60.0
      ],
      [
        510.0,
        1460.0,
        80.0
      ],
      [
        509.9285583496094,
        1420.0,
        78.0
      ],
      [
        510.0,
        1420.0,
        80.0
      ],
      [
        511.5827331542969,
        1375.0001220703125,
        80.0
      ],
      [
        510.0,
        1378.416259765625,
        80.0
      ],
      [
        510.0,
        1400.0,
        80.0
      ],
      [
        539.7575073242188,
        1375.0,
        80.0
      ],
      [
        505.25732421875,
        1301.1802978515625,
        80.0
      ],
      [
        529.2427978515625,
        1375.0,
        80.0
      ],
      [
        450.0,
        1310.0,
        100.0
      ],
      [
        450.0,
        1415.0,
        100.0
      ],
      [
        450.0,
        1040.0,
        120.0
      ],
      [
        450.0,
        1110.0,
        120.0
      ],
      [
        680.0,
        1110.0,
        120.0
      ],
      [
        680.0,
        1040.0,
        120.0
      ],
      [
        450.0,
        1040.0,
        190.0
      ],
      [
        450.0,
        1110.0,
        190.0
      ],
      [
        680.0,
        1110.0,
        190.0
      ],
      [
        680.0,
        1040.0,
        190.0
      ],
      [
        680.0,
        980.0,
        190.0
      ],
      [
        450.0,
        980.0,
        190.0
      ],
      [
        680.0,
        980.0,
        120.0
      ],
      [
        450.0,
        980.0,
        120.0
      ],
      [
        450.0,
        1000.0,
        120.0
      ],
      [
        680.0,
        1000.0,
        120.0
      ],
      [
        680.0,
        980.0,
        120.0
      ],
      [
        450.0,
        980.0,
        120.0
      ],
      [
        680.0,
        940.0,
        80.0
      ],
      [
        450.0,
        940.0,
        80.0
      ],
      [
        450.0,
        980.0,
        80.0
      ],
      [
        680.0,
        980.0,
        80.0
      ],
      [
        450.0,
        930.0,
        60.0
      ],
      [
        680.0,
        930.0,
        60.0
      ],
      [
        680.0,
        920.0,
        80.0
      ],
      [
        450.0,
        920.0,
        80.0
      ],
      [
        680.0,
        980.0,
        80.0
      ],
      [
        450.0,
        980.0,
        80.0
      ],
      [
        450.0,
        980.0,
        120.0
      ],
      [
        680.0,
        980.0,
        120.0
      ],
      [
        680.0,
        920.0,
        80.0
      ],
      [
        680.0,
        920.0,
        120.0
      ],
      [
        600.1320190429688,
        920.0,
        120.0
      ],
      [
        450.0,
        980.0,
        190.0
      ],
      [
        450.0,
        980.0,
        170.0
      ],
      [
        680.0,
        980.0,
        160.0
      ],
      [
        450.0,
        980.0,
        160.0
      ],
      [
        450.0,
        980.0,
        190.0
      ],
      [
        680.0,
        980.0,
        190.0
      ],
      [
        680.0,
        920.0,
        140.0
      ],
      [
        450.0,
        980.0,
        330.0
      ],
      [
        450.0,
        980.0,
        190.0
      ],
      [
        700.0,
        1040.0,
        120.0
      ],
      [
        720.0,
        1040.0,
        120.0
      ],
      [
        680.0,
        1040.0,
        120.0
      ],
      [
        720.0,
        1040.0,
        120.0
      ],
      [
        680.0,
        1040.0,
        190.0
      ],
      [
        720.0,
        1040.0,
        190.0
      ],
      [
        720.0,
        920.0,
        120.0
      ],
      [
        680.0,
        920.0,
        120.0
      ],
      [
        0.0,
        1490.0,
        60.0
      ],
      [
        0.0,
        1490.0,
        214.0
      ],
      [
        -595.0115356445312,
        1430.0,
        60.0
      ],
      [
        -595.0115356445312,
        1430.0,
        214.0
      ],
      [
        -50.843994140625,
        1250.0,
        60.0
      ],
      [
        -50.843994140625,
        1250.0,
        120.0
      ],
      [
        -50.0,
        1250.4873046875,
        120.0
      ],
      [
        -50.843994140625,
        1250.0,
        120.0
      ],
      [
        -134.50001525878906,
        1201.701171875,
        250.0
      ],
      [
        -161.91433715820312,
        1185.87353515625,
        250.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        250.0
      ],
      [
        -173.94740295410156,
        1178.92626953125,
        250.0
      ],
      [
        -161.91433715820312,
        1185.87353515625,
        250.0
      ],
      [
        -173.94740295410156,
        1178.92626953125,
        250.0
      ],
      [
        -309.5,
        971.800048828125,
        249.99998474121094
      ],
      [
        -309.5,
        1051.800048828125,
        250.0
      ],
      [
        -339.5,
        1051.800048828125,
        250.00003051757812
      ],
      [
        -339.5,
        971.800048828125,
        250.0
      ],
      [
        -339.5,
        830.0,
        120.0
      ],
      [
        -309.5,
        830.0,
        120.0
      ],
      [
        -309.5,
        830.0,
        140.0
      ],
      [
        -339.5,
        830.0,
        140.0
      ],
      [
        -339.5,
        830.0,
        60.0
      ],
      [
        -309.5,
        830.0,
        60.0
      ],
      [
        -309.5,
        830.0,
        120.0
      ],
      [
        -339.5,
        830.0,
        120.0
      ],
      [
        -309.5,
        820.0,
        140.0
      ],
      [
        -339.5,
        820.0,
        140.0
      ],
      [
        -339.5,
        830.0,
        140.0
      ],
      [
        -309.5,
        830.0,
        140.0
      ],
      [
        -339.5,
        850.556396484375,
        80.00611877441406
      ],
      [
        -309.5,
        850.556396484375,
        80.00611877441406
      ],
      [
        -309.5,
        830.556396484375,
        60.00611877441406
      ],
      [
        -339.5,
        830.556396484375,
        60.00611877441406
      ],
      [
        -309.5,
        1100.6649169921875,
        120.0
      ],
      [
        -339.5,
        1083.344482421875,
        120.0
      ],
      [
        -339.5,
        1083.344482421875,
        205.0
      ],
      [
        -309.5,
        1100.6649169921875,
        205.0
      ],
      [
        -309.5,
        1100.6649169921875,
        225.0
      ],
      [
        -339.5,
        1083.344482421875,
        225.0
      ],
      [
        -339.5,
        1083.344482421875,
        75.0
      ],
      [
        -309.5,
        1100.6649169921875,
        75.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        85.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        76.0
      ],
      [
        -313.5,
        1098.3555908203125,
        75.0
      ],
      [
        -313.5,
        1098.3555908203125,
        78.33777618408203
      ],
      [
        -314.5,
        1097.7783203125,
        78.04911804199219
      ],
      [
        -314.5,
        1097.7783203125,
        75.0
      ],
      [
        -313.5,
        1098.3555908203125,
        78.33777618408203
      ],
      [
        -314.5,
        1097.7783203125,
        78.04911804199219
      ],
      [
        -309.53204345703125,
        1100.646484375,
        78.0
      ],
      [
        -309.5,
        1100.646484375,
        78.0
      ],
      [
        -309.5,
        1100.646484375,
        75.0
      ],
      [
        -309.53204345703125,
        1100.646484375,
        75.0
      ],
      [
        -309.5,
        1100.646484375,
        78.0
      ],
      [
        -309.53204345703125,
        1100.646484375,
        78.0
      ],
      [
        -309.5,
        1100.6650390625,
        78.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        76.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        85.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        95.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        75.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        225.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        205.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        95.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        120.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        120.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        205.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        225.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        75.0
      ],
      [
        -160.0,
        942.0,
        250.00001525878906
      ],
      [
        -160.0,
        830.0,
        250.00001525878906
      ],
      [
        -100.0,
        1050.0,
        155.0
      ],
      [
        -160.0,
        1050.0,
        155.0
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        80.0
      ],
      [
        -117.17955017089844,
        1211.7012939453125,
        60.00611877441406
      ],
      [
        -128.13587951660156,
        1160.6689453125,
        95.0
      ],
      [
        -129.64987182617188,
        1153.508544921875,
        95.0
      ],
      [
        -130.14283752441406,
        1152.6546630859375,
        95.0
      ],
      [
        -160.0,
        1133.2198486328125,
        95.0
      ],
      [
        -160.0,
        1186.9788818359375,
        95.0
      ],
      [
        -147.494384765625,
        1194.198974609375,
        95.0
      ],
      [
        -160.0,
        1097.7781982421875,
        80.0
      ],
      [
        -160.0,
        1077.7781982421875,
        60.00611877441406
      ],
      [
        -160.0,
        1097.7781982421875,
        80.0
      ],
      [
        -160.0,
        1097.7781982421875,
        93.41925811767578
      ],
      [
        -160.0,
        1133.2198486328125,
        95.0
      ],
      [
        -130.14283752441406,
        1152.6546630859375,
        95.0
      ],
      [
        -160.0,
        1133.2198486328125,
        111.13467407226562
      ],
      [
        -157.92892456054688,
        1162.928955078125,
        119.66398620605469
      ],
      [
        -160.0,
        1162.071044921875,
        95.0
      ],
      [
        -160.0,
        1162.071044921875,
        121.88594818115234
      ],
      [
        -160.0,
        1162.071044921875,
        95.0
      ],
      [
        -157.92892456054688,
        1162.928955078125,
        119.66397857666016
      ],
      [
        -160.0,
        1162.071044921875,
        121.88594818115234
      ],
      [
        -157.92892456054688,
        1162.928955078125,
        119.66398620605469
      ],
      [
        -155.0,
        1170.0,
        113.59385681152344
      ],
      [
        -155.0,
        1170.0,
        113.59385681152344
      ],
      [
        -157.92892456054688,
        1162.928955078125,
        119.66397857666016
      ],
      [
        -154.45880126953125,
        1171.3065185546875,
        105.0
      ],
      [
        -154.45880126953125,
        1171.3065185546875,
        106.0
      ],
      [
        -154.07611083984375,
        1170.3826904296875,
        106.0
      ],
      [
        -154.45880126953125,
        1171.3065185546875,
        106.0
      ],
      [
        -154.45880126953125,
        1171.3065185546875,
        105.0
      ],
      [
        -157.92892456054688,
        1177.071044921875,
        112.59515380859375
      ],
      [
        -160.0,
        1177.928955078125,
        95.0
      ],
      [
        -160.0,
        1177.928955078125,
        113.95943450927734
      ],
      [
        -160.0,
        1177.928955078125,
        113.95943450927734
      ],
      [
        -160.0,
        1177.928955078125,
        95.0
      ],
      [
        -157.92892456054688,
        1177.071044921875,
        112.59515380859375
      ],
      [
        -156.62240600585938,
        1176.5299072265625,
        105.0
      ],
      [
        -156.62240600585938,
        1176.5299072265625,
        106.0
      ],
      [
        -157.00506591796875,
        1177.4537353515625,
        106.0
      ],
      [
        -156.62240600585938,
        1176.5299072265625,
        105.0
      ],
      [
        -156.62240600585938,
        1176.5299072265625,
        106.0
      ],
      [
        -157.92892456054688,
        1177.071044921875,
        112.59514617919922
      ],
      [
        -155.0,
        1170.0,
        113.59385681152344
      ],
      [
        -155.0,
        1170.0,
        113.59383392333984
      ],
      [
        -157.92892456054688,
        1177.071044921875,
        112.59515380859375
      ],
      [
        -129.64987182617188,
        1153.508544921875,
        95.0
      ],
      [
        -128.13587951660156,
        1160.6689453125,
        95.0
      ],
      [
        -128.6156463623047,
        1158.39990234375,
        96.54955291748047
      ],
      [
        -136.8179473876953,
        1200.363037109375,
        95.0
      ],
      [
        -136.8179473876953,
        1200.363037109375,
        95.0
      ],
      [
        -136.8179473876953,
        1200.363037109375,
        120.0
      ],
      [
        -133.98631286621094,
        1196.012939453125,
        120.0
      ],
      [
        -123.92950439453125,
        1180.56298828125,
        103.57067108154297
      ],
      [
        -133.98631286621094,
        1196.012939453125,
        120.0
      ],
      [
        -136.8179473876953,
        1200.363037109375,
        120.0
      ],
      [
        -154.16317749023438,
        1190.3486328125,
        131.0
      ],
      [
        -151.9368133544922,
        1186.9283447265625,
        131.0
      ],
      [
        -123.92950439453125,
        1180.56298828125,
        103.57066345214844
      ],
      [
        -160.0,
        1177.928955078125,
        131.0
      ],
      [
        -160.0,
        1177.928955078125,
        131.0
      ],
      [
        -160.0,
        1177.928955078125,
        131.0
      ],
      [
        -160.0,
        1177.928955078125,
        133.48248291015625
      ],
      [
        -157.92892456054688,
        1177.071044921875,
        131.26058959960938
      ],
      [
        -160.0,
        1177.928955078125,
        131.0
      ],
      [
        -157.3835906982422,
        1188.4893798828125,
        131.0
      ],
      [
        -160.0,
        1186.978759765625,
        131.0
      ],
      [
        -151.9368133544922,
        1186.9283447265625,
        131.0
      ],
      [
        -154.16317749023438,
        1190.3486328125,
        131.0
      ],
      [
        -157.3835906982422,
        1188.4893798828125,
        131.0
      ],
      [
        -157.68597412109375,
        1176.970458984375,
        131.0
      ],
      [
        -157.80319213867188,
        1176.7674560546875,
        131.0
      ],
      [
        -155.0,
        1170.0,
        125.19038391113281
      ],
      [
        -155.0,
        1170.0,
        125.19038391113281
      ],
      [
        -157.80319213867188,
        1176.7674560546875,
        131.0
      ],
      [
        -157.80319213867188,
        1176.7674560546875,
        131.0
      ],
      [
        -157.92892456054688,
        1177.071044921875,
        131.26058959960938
      ],
      [
        -157.80319213867188,
        1176.7674560546875,
        131.0
      ],
      [
        -157.92892456054688,
        1162.928955078125,
        124.19163513183594
      ],
      [
        -155.0,
        1170.0,
        125.19039154052734
      ],
      [
        -155.0,
        1170.0,
        125.19039154052734
      ],
      [
        -157.92892456054688,
        1162.928955078125,
        124.19163513183594
      ],
      [
        -157.92892456054688,
        1162.928955078125,
        124.19163513183594
      ],
      [
        -160.0,
        1162.071044921875,
        125.55592346191406
      ],
      [
        -157.92892456054688,
        1162.928955078125,
        124.19163513183594
      ],
      [
        -160.0,
        1162.071044921875,
        125.55592346191406
      ],
      [
        -144.5,
        1097.7781982421875,
        155.0
      ],
      [
        -109.5,
        1158.39990234375,
        155.0
      ],
      [
        -160.0,
        1133.2198486328125,
        120.0
      ],
      [
        -160.0,
        1097.7781982421875,
        100.00611877441406
      ],
      [
        -160.0,
        1097.7781982421875,
        120.00611877441406
      ],
      [
        -160.0,
        1097.7781982421875,
        100.00611877441406
      ],
      [
        -160.0,
        1097.7781982421875,
        120.00611877441406
      ],
      [
        -160.0,
        1097.7781982421875,
        155.0
      ],
      [
        -144.5,
        1097.7781982421875,
        155.0
      ],
      [
        -160.0,
        1133.2198486328125,
        120.0
      ],
      [
        -160.0,
        1157.0836181640625,
        131.0
      ],
      [
        -155.0,
        1170.0,
        135.45352172851562
      ],
      [
        -155.0,
        1170.0,
        155.0
      ],
      [
        -157.92892456054688,
        1162.928955078125,
        155.0
      ],
      [
        -157.92892456054688,
        1162.928955078125,
        133.07298278808594
      ],
      [
        -157.92892456054688,
        1162.928955078125,
        133.07298278808594
      ],
      [
        -157.92892456054688,
        1162.928955078125,
        155.0
      ],
      [
        -160.0,
        1162.071044921875,
        155.0
      ],
      [
        -160.0,
        1162.071044921875,
        133.2989501953125
      ],
      [
        -157.92892456054688,
        1177.071044921875,
        139.5917510986328
      ],
      [
        -157.92892456054688,
        1177.071044921875,
        155.0
      ],
      [
        -155.0,
        1170.0,
        155.0
      ],
      [
        -155.0,
        1170.0,
        135.45352172851562
      ],
      [
        -160.0,
        1177.928955078125,
        140.60861206054688
      ],
      [
        -160.0,
        1177.928955078125,
        155.0
      ],
      [
        -157.92892456054688,
        1177.071044921875,
        155.0
      ],
      [
        -157.92892456054688,
        1177.071044921875,
        139.5917510986328
      ],
      [
        -157.92892456054688,
        1177.071044921875,
        136.71971130371094
      ],
      [
        -156.21560668945312,
        1172.9346923828125,
        137.17103576660156
      ],
      [
        -160.0,
        1177.928955078125,
        137.4169464111328
      ],
      [
        -157.92892456054688,
        1177.071044921875,
        136.71969604492188
      ],
      [
        -160.0,
        1162.071044921875,
        131.0
      ],
      [
        -160.0,
        1157.0836181640625,
        131.0
      ],
      [
        -160.0,
        1162.071044921875,
        131.0
      ],
      [
        -160.0,
        1162.071044921875,
        131.0
      ],
      [
        -160.0,
        1162.071044921875,
        131.0
      ],
      [
        -144.5,
        1097.7781982421875,
        230.0
      ],
      [
        -109.5,
        1158.39990234375,
        230.0
      ],
      [
        -160.0,
        1097.7781982421875,
        230.0
      ],
      [
        -144.5,
        1097.7781982421875,
        230.0
      ],
      [
        -157.92892456054688,
        1177.071044921875,
        230.0
      ],
      [
        -155.0,
        1170.0,
        230.0
      ],
      [
        -155.0,
        1170.0,
        230.0
      ],
      [
        -157.92892456054688,
        1162.928955078125,
        230.0
      ],
      [
        -160.0,
        1177.928955078125,
        230.0
      ],
      [
        -157.92892456054688,
        1177.071044921875,
        230.0
      ],
      [
        -157.92892456054688,
        1162.928955078125,
        230.0
      ],
      [
        -160.0,
        1162.071044921875,
        230.0
      ],
      [
        -110.0,
        980.0,
        250.00001525878906
      ],
      [
        -110.0,
        840.0,
        250.00001525878906
      ],
      [
        -100.0,
        980.0,
        250.00001525878906
      ],
      [
        -110.0,
        980.0,
        250.00001525878906
      ],
      [
        -100.0,
        920.0,
        250.00001525878906
      ],
      [
        -110.0,
        920.0,
        250.00001525878906
      ],
      [
        -110.0,
        1157.533935546875,
        250.0
      ],
      [
        -109.5,
        1158.39990234375,
        250.0
      ],
      [
        -110.0,
        1157.533935546875,
        230.0
      ],
      [
        -144.5,
        1097.7781982421875,
        249.99998474121094
      ],
      [
        -160.0,
        1097.7781982421875,
        250.0
      ],
      [
        -144.5,
        1097.7781982421875,
        250.0
      ],
      [
        -160.0,
        1177.928955078125,
        250.0
      ],
      [
        -160.0,
        1162.071044921875,
        250.0
      ],
      [
        -110.0,
        840.0,
        240.0
      ],
      [
        -150.0,
        840.0,
        240.0
      ],
      [
        -150.0,
        942.0,
        240.0
      ],
      [
        -160.0,
        942.0,
        240.0
      ],
      [
        -110.0,
        840.0,
        250.00001525878906
      ],
      [
        -150.0,
        840.0,
        250.00001525878906
      ],
      [
        -150.0,
        942.0,
        250.00001525878906
      ],
      [
        -160.0,
        942.0,
        250.00001525878906
      ],
      [
        -293.78204345703125,
        1075.0986328125,
        250.00003051757812
      ],
      [
        -224.5,
        1115.0986328125,
        250.0
      ],
      [
        -169.12681579589844,
        1181.70947265625,
        95.0
      ],
      [
        -160.0,
        1177.928955078125,
        95.0
      ],
      [
        -161.8411102294922,
        1185.915771484375,
        131.0
      ],
      [
        -161.8411102294922,
        1185.915771484375,
        131.0
      ],
      [
        -169.12673950195312,
        1181.70947265625,
        131.0
      ],
      [
        -214.8716278076172,
        1155.2987060546875,
        120.0
      ],
      [
        -309.5,
        1066.0238037109375,
        120.0
      ],
      [
        -214.8716278076172,
        1155.2987060546875,
        120.0
      ],
      [
        -197.52635192871094,
        1165.31298828125,
        131.0
      ],
      [
        -309.5,
        1066.0238037109375,
        225.0
      ],
      [
        -309.5,
        1066.0238037109375,
        205.0
      ],
      [
        -189.29701232910156,
        1170.064208984375,
        131.0
      ],
      [
        -197.52635192871094,
        1165.31298828125,
        131.0
      ],
      [
        -160.0,
        1157.928955078125,
        131.0
      ],
      [
        -160.0,
        1152.337646484375,
        128.81236267089844
      ],
      [
        -181.13681030273438,
        1140.1343994140625,
        129.52923583984375
      ],
      [
        -197.011962890625,
        1130.9688720703125,
        120.0
      ],
      [
        -181.13681030273438,
        1140.1343994140625,
        129.52923583984375
      ],
      [
        -309.5,
        1066.0238037109375,
        75.0
      ],
      [
        -240.8894805908203,
        1140.2772216796875,
        78.0
      ],
      [
        -240.61631774902344,
        1139.8575439453125,
        78.0
      ],
      [
        -240.61631774902344,
        1139.8575439453125,
        75.0
      ],
      [
        -214.8716278076172,
        1155.2987060546875,
        95.0
      ],
      [
        -214.59840393066406,
        1154.8790283203125,
        95.0
      ],
      [
        -240.61631774902344,
        1139.8575439453125,
        95.0
      ],
      [
        -214.59840393066406,
        1154.87890625,
        95.0
      ],
      [
        -214.8716278076172,
        1155.2987060546875,
        95.0
      ],
      [
        -189.29701232910156,
        1170.064208984375,
        95.0
      ],
      [
        -188.71461486816406,
        1169.822998046875,
        95.0
      ],
      [
        -240.61631774902344,
        1139.8575439453125,
        95.0
      ],
      [
        -197.011962890625,
        1130.9688720703125,
        95.0
      ],
      [
        -160.0,
        1157.9288330078125,
        95.0
      ],
      [
        -160.0,
        1152.337646484375,
        95.0
      ],
      [
        -197.011962890625,
        1130.9688720703125,
        120.0
      ],
      [
        -197.011962890625,
        1130.9688720703125,
        95.0
      ],
      [
        -160.0,
        1162.071044921875,
        95.0
      ],
      [
        -165.00003051757812,
        1160.0,
        95.0
      ],
      [
        -165.00001525878906,
        1180.0001220703125,
        95.0
      ],
      [
        -189.14198303222656,
        1170.0,
        95.0
      ],
      [
        -179.36158752441406,
        1175.8004150390625,
        131.0
      ],
      [
        -184.49166870117188,
        1172.8385009765625,
        131.0
      ],
      [
        -183.21275329589844,
        1172.4560546875,
        131.0
      ],
      [
        -183.21275329589844,
        1172.4560546875,
        131.0
      ],
      [
        -184.49166870117188,
        1172.8385009765625,
        131.0
      ],
      [
        -189.14198303222656,
        1170.0,
        131.0
      ],
      [
        -179.36158752441406,
        1175.8004150390625,
        131.0
      ],
      [
        -177.07106018066406,
        1165.0,
        95.0
      ],
      [
        -172.07106018066406,
        1177.0711669921875,
        95.0
      ],
      [
        -177.071044921875,
        1165.0,
        131.0
      ],
      [
        -172.0710906982422,
        1162.928955078125,
        95.0
      ],
      [
        -175.00001525878906,
        1170.0,
        95.0
      ],
      [
        -289.5,
        850.556396484375,
        249.99998474121094
      ],
      [
        -254.5,
        911.17822265625,
        250.0
      ],
      [
        -254.5,
        911.17822265625,
        249.99998474121094
      ],
      [
        -289.5,
        971.800048828125,
        250.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        200.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        210.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        210.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        225.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        210.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        225.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        225.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        250.0
      ],
      [
        -289.5,
        971.800048828125,
        249.99998474121094
      ],
      [
        -309.5,
        971.800048828125,
        250.0
      ],
      [
        -301.0470275878906,
        830.556396484375,
        60.00611877441406
      ],
      [
        -289.5000305175781,
        971.800048828125,
        200.0
      ],
      [
        -309.5,
        1006.4410400390625,
        200.0
      ],
      [
        -309.5,
        1006.4410400390625,
        80.00611877441406
      ],
      [
        -296.82049560546875,
        984.4795532226562,
        67.32662200927734
      ],
      [
        -296.82049560546875,
        984.4795532226562,
        67.32662200927734
      ],
      [
        -309.5,
        1006.4410400390625,
        225.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        225.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        205.0
      ],
      [
        -296.82049560546875,
        984.4795532226562,
        205.0
      ],
      [
        -309.5,
        1006.4410400390625,
        205.0
      ],
      [
        -296.82049560546875,
        984.4795532226562,
        205.0
      ],
      [
        -290.7701110839844,
        974.0,
        210.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        210.0
      ],
      [
        -290.7701110839844,
        974.0,
        210.0
      ],
      [
        -290.7701110839844,
        974.0,
        205.0
      ],
      [
        -214.5,
        1097.7781982421875,
        249.99998474121094
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        200.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        210.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        210.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        225.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        210.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        225.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        225.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        250.0
      ],
      [
        -224.5,
        1115.0986328125,
        250.00003051757812
      ],
      [
        -214.5,
        1097.7781982421875,
        250.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        200.0
      ],
      [
        -254.4998779296875,
        1097.7781982421875,
        200.0
      ],
      [
        -254.4998779296875,
        1097.7781982421875,
        80.0
      ],
      [
        -229.1409912109375,
        1097.7781982421875,
        67.32440948486328
      ],
      [
        -229.1409912109375,
        1097.7781982421875,
        67.32440948486328
      ],
      [
        -254.4998779296875,
        1097.7781982421875,
        225.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        225.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        205.0
      ],
      [
        -229.14097595214844,
        1097.7781982421875,
        205.0
      ],
      [
        -254.4998779296875,
        1097.7781982421875,
        205.0
      ],
      [
        -229.14097595214844,
        1097.7781982421875,
        205.0
      ],
      [
        -216.7322540283203,
        1097.7781982421875,
        210.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        210.0
      ],
      [
        -216.7322540283203,
        1097.7781982421875,
        210.0
      ],
      [
        -216.7322540283203,
        1097.7781982421875,
        205.0
      ],
      [
        -242.95303344726562,
        931.1782836914062,
        60.00611877441406
      ],
      [
        -289.5,
        1011.800048828125,
        60.00611877441406
      ],
      [
        -250.78097534179688,
        1083.898193359375,
        66.12432861328125
      ],
      [
        -249.1448516845703,
        1077.77587890625,
        60.003910064697266
      ],
      [
        -250.78097534179688,
        1083.898193359375,
        66.12432861328125
      ],
      [
        -304.4938659667969,
        1059.2205810546875,
        75.0
      ],
      [
        -304.4938659667969,
        1068.9140625,
        75.0
      ],
      [
        -309.5,
        1051.800048828125,
        80.00613403320312
      ],
      [
        -304.4938659667969,
        1059.2205810546875,
        75.0
      ],
      [
        -300.1638488769531,
        1065.638916015625,
        75.0
      ],
      [
        -304.4938659667969,
        1063.1390380859375,
        75.0
      ],
      [
        -300.1638488769531,
        1065.638916015625,
        75.0
      ],
      [
        -293.78204345703125,
        1075.0986328125,
        79.99991607666016
      ],
      [
        -289.5000305175781,
        971.800048828125,
        202.5
      ],
      [
        -229.5,
        971.800048828125,
        202.5
      ],
      [
        -184.49986267089844,
        1045.8167724609375,
        202.5
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        202.5
      ],
      [
        -185.47727966308594,
        1047.5096435546875,
        205.0
      ],
      [
        -186.49981689453125,
        1045.8394775390625,
        205.0
      ],
      [
        -231.8271484375,
        971.800048828125,
        205.0
      ],
      [
        -230.61416625976562,
        973.7813720703125,
        205.0
      ],
      [
        -230.61416625976562,
        973.7813720703125,
        205.0
      ],
      [
        -186.49981689453125,
        1045.8394775390625,
        205.0
      ],
      [
        -229.5,
        971.800048828125,
        205.0
      ],
      [
        -231.8271484375,
        971.800048828125,
        202.5
      ],
      [
        -231.8271484375,
        971.800048828125,
        205.0
      ],
      [
        -184.49986267089844,
        1045.8167724609375,
        205.0
      ],
      [
        -185.47727966308594,
        1047.5096435546875,
        205.0
      ],
      [
        -185.47727966308594,
        1047.5096435546875,
        202.5
      ],
      [
        -231.8271484375,
        971.800048828125,
        210.0
      ],
      [
        -185.47727966308594,
        1047.5096435546875,
        210.0
      ],
      [
        -252.9062042236328,
        971.800048828125,
        205.0
      ],
      [
        -231.8271484375,
        971.800048828125,
        205.0
      ],
      [
        -252.9062042236328,
        971.800048828125,
        202.5
      ],
      [
        -195.90069580078125,
        1065.5634765625,
        202.5
      ],
      [
        -185.47727966308594,
        1047.5096435546875,
        205.0
      ],
      [
        -195.90069580078125,
        1065.5634765625,
        205.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        205.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        205.0
      ],
      [
        -339.4835205078125,
        1051.800048828125,
        300.0
      ],
      [
        -339.4835205078125,
        1083.35400390625,
        300.0
      ],
      [
        -309.5,
        1100.6649169921875,
        300.0
      ],
      [
        -339.4810485839844,
        1051.800048828125,
        270.0
      ],
      [
        -309.5,
        1100.6649169921875,
        270.0
      ],
      [
        -339.4810485839844,
        1083.35546875,
        270.0
      ],
      [
        -339.4794006347656,
        1051.800048828125,
        250.0
      ],
      [
        -339.4810485839844,
        1051.800048828125,
        270.0
      ],
      [
        -309.5,
        1053.5880126953125,
        250.0
      ],
      [
        -309.5,
        1053.5880126953125,
        268.5177307128906
      ],
      [
        -309.5,
        1053.5880126953125,
        270.0
      ],
      [
        -309.5,
        1053.5880126953125,
        268.5177307128906
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        251.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        260.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        260.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        251.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        251.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        260.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        260.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        251.0
      ],
      [
        -339.48516845703125,
        1051.800048828125,
        320.0
      ],
      [
        -309.5,
        1100.6649169921875,
        320.0
      ],
      [
        -339.48516845703125,
        1083.35302734375,
        320.0
      ],
      [
        -339.4919128417969,
        1051.800048828125,
        402.0
      ],
      [
        -339.4919128417969,
        1083.34912109375,
        402.0
      ],
      [
        -309.5,
        1100.6650390625,
        402.0
      ],
      [
        -339.4935607910156,
        1051.800048828125,
        422.0
      ],
      [
        -309.5,
        1100.6650390625,
        422.0
      ],
      [
        -339.4935607910156,
        1083.34814453125,
        422.0
      ],
      [
        -339.4919128417969,
        1051.800048828125,
        402.0
      ],
      [
        -339.4935607910156,
        1051.800048828125,
        422.0
      ],
      [
        -339.4835205078125,
        1051.800048828125,
        300.0
      ],
      [
        -339.48516845703125,
        1051.800048828125,
        320.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        301.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        310.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        310.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        301.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        301.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        310.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        310.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        301.0
      ],
      [
        -309.4876403808594,
        971.800048828125,
        350.0
      ],
      [
        -309.4835205078125,
        971.800048828125,
        300.0
      ],
      [
        -309.4794006347656,
        971.800048828125,
        250.0
      ],
      [
        -309.4794006347656,
        1051.83056640625,
        250.0
      ],
      [
        -309.4810485839844,
        1051.828125,
        269.9660949707031
      ],
      [
        -309.4810485839844,
        1051.828125,
        269.9660949707031
      ],
      [
        -309.4810485839844,
        1051.828125,
        270.0
      ],
      [
        -309.48516845703125,
        1051.822021484375,
        320.0
      ],
      [
        -309.4835205078125,
        1051.824462890625,
        300.0
      ],
      [
        -309.4935607910156,
        1051.8095703125,
        422.0
      ],
      [
        -309.4919128417969,
        1051.81201171875,
        402.0
      ],
      [
        -309.4810485839844,
        1051.828125,
        270.0
      ],
      [
        -309.4835205078125,
        1051.824462890625,
        300.0
      ],
      [
        -309.4835205078125,
        1100.6744384765625,
        300.0
      ],
      [
        -309.4810485839844,
        1051.828125,
        270.0
      ],
      [
        -309.4810485839844,
        1100.6759033203125,
        270.0
      ],
      [
        -309.4794006347656,
        1053.6185302734375,
        250.0
      ],
      [
        -309.4809265136719,
        1053.6163330078125,
        268.4836120605469
      ],
      [
        -309.4810485839844,
        1053.6160888671875,
        270.0
      ],
      [
        -309.4809265136719,
        1053.6163330078125,
        268.4836120605469
      ],
      [
        -309.4919128417969,
        1051.81201171875,
        402.0
      ],
      [
        -309.4919128417969,
        1100.669677734375,
        402.0
      ],
      [
        -309.48516845703125,
        1051.822021484375,
        320.0
      ],
      [
        -309.48516845703125,
        1100.6734619140625,
        320.0
      ],
      [
        -309.4935607910156,
        1051.8095703125,
        422.0
      ],
      [
        -309.4935607910156,
        1100.668701171875,
        422.0
      ],
      [
        -309.4835205078125,
        1051.824462890625,
        300.0
      ],
      [
        -309.4835205078125,
        971.800048828125,
        300.0
      ],
      [
        -339.5,
        1083.344482421875,
        320.0
      ],
      [
        -339.5,
        1083.344482421875,
        402.0
      ],
      [
        -339.5,
        1083.344482421875,
        422.0
      ],
      [
        -339.5,
        1083.344482421875,
        270.0
      ],
      [
        -339.5,
        1083.344482421875,
        300.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        270.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        250.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        320.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        300.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        422.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        402.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        320.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        402.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        422.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        300.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        270.0
      ],
      [
        -134.50001525878906,
        1201.701171875,
        300.0
      ],
      [
        -161.91433715820312,
        1185.87353515625,
        300.0
      ],
      [
        -119.4999771118164,
        1175.7203369140625,
        300.0
      ],
      [
        -137.2472686767578,
        1165.4739990234375,
        300.0
      ],
      [
        -309.4835205078125,
        1066.0333251953125,
        300.0
      ],
      [
        -173.94740295410156,
        1178.92626953125,
        300.0
      ],
      [
        -156.19825744628906,
        1154.5325927734375,
        300.0
      ],
      [
        -161.91433715820312,
        1185.87353515625,
        300.0
      ],
      [
        -173.94740295410156,
        1178.92626953125,
        300.0
      ],
      [
        -156.19825744628906,
        1154.5325927734375,
        300.0
      ],
      [
        -137.2472686767578,
        1165.4739990234375,
        300.0
      ],
      [
        -161.91433715820312,
        1185.87353515625,
        270.0
      ],
      [
        -134.50001525878906,
        1201.701171875,
        270.0
      ],
      [
        -137.2472686767578,
        1165.4739990234375,
        270.0
      ],
      [
        -119.4999771118164,
        1175.7203369140625,
        270.0
      ],
      [
        -309.4810485839844,
        1066.0347900390625,
        270.0
      ],
      [
        -173.94740295410156,
        1178.92626953125,
        270.0
      ],
      [
        -156.19825744628906,
        1154.5325927734375,
        270.0
      ],
      [
        -173.94740295410156,
        1178.92626953125,
        270.0
      ],
      [
        -161.91433715820312,
        1185.87353515625,
        270.0
      ],
      [
        -137.2472686767578,
        1165.4739990234375,
        270.0
      ],
      [
        -156.19825744628906,
        1154.5325927734375,
        270.0
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        255.0
      ],
      [
        -119.49998474121094,
        1175.720458984375,
        255.0
      ],
      [
        -119.49998474121094,
        1175.720458984375,
        250.0
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        250.0
      ],
      [
        -119.49998474121094,
        1175.720458984375,
        255.0
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        255.0
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        270.0
      ],
      [
        -119.49998474121094,
        1175.720458984375,
        270.0
      ],
      [
        -295.75787353515625,
        1073.9578857421875,
        267.9493408203125
      ],
      [
        -295.75787353515625,
        1073.9578857421875,
        250.0
      ],
      [
        -295.7579040527344,
        1073.9578857421875,
        270.0
      ],
      [
        -295.75787353515625,
        1073.9578857421875,
        267.9493408203125
      ],
      [
        -143.64317321777344,
        1161.7813720703125,
        268.0
      ],
      [
        -139.8084716796875,
        1163.9952392578125,
        268.0
      ],
      [
        -142.6605987548828,
        1169.25341796875,
        268.0
      ],
      [
        -140.77679443359375,
        1170.0335693359375,
        268.0
      ],
      [
        -142.6605987548828,
        1169.25341796875,
        270.0
      ],
      [
        -142.6605987548828,
        1169.25341796875,
        268.0
      ],
      [
        -143.64317321777344,
        1161.7813720703125,
        270.0
      ],
      [
        -143.64317321777344,
        1161.7813720703125,
        268.0
      ],
      [
        -152.89796447753906,
        1191.0792236328125,
        268.0
      ],
      [
        -148.2029571533203,
        1186.9576416015625,
        268.0
      ],
      [
        -146.14324951171875,
        1187.810791015625,
        268.0
      ],
      [
        -151.06922912597656,
        1192.1351318359375,
        268.0
      ],
      [
        -152.89796447753906,
        1191.0792236328125,
        270.0
      ],
      [
        -148.2029571533203,
        1186.9576416015625,
        270.0
      ],
      [
        -148.2029571533203,
        1186.9576416015625,
        268.0
      ],
      [
        -152.89796447753906,
        1191.0792236328125,
        268.0
      ],
      [
        -142.9852294921875,
        1170.8812255859375,
        268.0
      ],
      [
        -140.85781860351562,
        1170.0,
        268.0
      ],
      [
        -142.9852294921875,
        1170.8812255859375,
        270.0
      ],
      [
        -142.9852294921875,
        1170.8812255859375,
        268.0
      ],
      [
        -156.62240600585938,
        1176.5299072265625,
        260.0
      ],
      [
        -156.6223907470703,
        1176.5299072265625,
        261.0
      ],
      [
        -157.00506591796875,
        1177.4537353515625,
        261.0
      ],
      [
        -156.6223907470703,
        1176.5299072265625,
        261.0
      ],
      [
        -156.62240600585938,
        1176.5299072265625,
        260.0
      ],
      [
        -154.45880126953125,
        1171.3065185546875,
        260.0
      ],
      [
        -154.4587860107422,
        1171.3065185546875,
        261.0
      ],
      [
        -154.07614135742188,
        1170.3826904296875,
        261.0
      ],
      [
        -154.45880126953125,
        1171.3065185546875,
        260.0
      ],
      [
        -154.4587860107422,
        1171.3065185546875,
        261.0
      ],
      [
        -309.48516845703125,
        1066.0323486328125,
        320.0
      ],
      [
        -187.0,
        1171.390380859375,
        320.0
      ],
      [
        -171.99993896484375,
        1145.4095458984375,
        320.0
      ],
      [
        -119.49998474121094,
        1175.720458984375,
        320.0
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        320.0
      ],
      [
        -309.4935607910156,
        1066.027587890625,
        422.0
      ],
      [
        -309.4919128417969,
        1066.0284423828125,
        402.0
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        305.0
      ],
      [
        -119.49998474121094,
        1175.720458984375,
        305.0
      ],
      [
        -119.49998474121094,
        1175.720458984375,
        300.0
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        300.0
      ],
      [
        -119.49998474121094,
        1175.720458984375,
        305.0
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        305.0
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        320.0
      ],
      [
        -119.49998474121094,
        1175.720458984375,
        320.0
      ],
      [
        -143.64317321777344,
        1161.7813720703125,
        318.0
      ],
      [
        -139.8084716796875,
        1163.9952392578125,
        318.0
      ],
      [
        -142.6605987548828,
        1169.25341796875,
        318.0
      ],
      [
        -140.77679443359375,
        1170.0335693359375,
        318.0
      ],
      [
        -142.6605987548828,
        1169.25341796875,
        320.0
      ],
      [
        -142.6605987548828,
        1169.25341796875,
        318.0
      ],
      [
        -139.8084716796875,
        1163.9952392578125,
        318.0
      ],
      [
        -139.8084716796875,
        1163.9952392578125,
        320.0
      ],
      [
        -143.64317321777344,
        1161.7813720703125,
        320.0
      ],
      [
        -143.64317321777344,
        1161.7813720703125,
        318.0
      ],
      [
        -151.06922912597656,
        1192.1351318359375,
        318.0
      ],
      [
        -146.14324951171875,
        1187.810791015625,
        318.0
      ],
      [
        -146.14324951171875,
        1187.810791015625,
        320.0
      ],
      [
        -151.06922912597656,
        1192.1351318359375,
        320.0
      ],
      [
        -152.89796447753906,
        1191.0792236328125,
        318.0
      ],
      [
        -148.2029571533203,
        1186.9576416015625,
        318.0
      ],
      [
        -146.14324951171875,
        1187.810791015625,
        318.0
      ],
      [
        -151.06922912597656,
        1192.1351318359375,
        318.0
      ],
      [
        -152.89796447753906,
        1191.0792236328125,
        320.0
      ],
      [
        -148.2029571533203,
        1186.9576416015625,
        320.0
      ],
      [
        -148.2029571533203,
        1186.9576416015625,
        318.0
      ],
      [
        -152.89796447753906,
        1191.0792236328125,
        318.0
      ],
      [
        -142.9852294921875,
        1170.8812255859375,
        318.0
      ],
      [
        -140.85781860351562,
        1170.0,
        318.0
      ],
      [
        -142.9852294921875,
        1170.8812255859375,
        320.0
      ],
      [
        -142.9852294921875,
        1170.8812255859375,
        318.0
      ],
      [
        -156.62240600585938,
        1176.5299072265625,
        310.0
      ],
      [
        -156.6223907470703,
        1176.5299072265625,
        311.0
      ],
      [
        -157.00506591796875,
        1177.4537353515625,
        311.0
      ],
      [
        -156.6223907470703,
        1176.5299072265625,
        311.0
      ],
      [
        -156.62240600585938,
        1176.5299072265625,
        310.0
      ],
      [
        -154.45880126953125,
        1171.3065185546875,
        310.0
      ],
      [
        -154.4587860107422,
        1171.3065185546875,
        311.0
      ],
      [
        -154.07614135742188,
        1170.3826904296875,
        311.0
      ],
      [
        -154.45880126953125,
        1171.3065185546875,
        310.0
      ],
      [
        -154.4587860107422,
        1171.3065185546875,
        311.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        350.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        300.0
      ],
      [
        -156.35299682617188,
        1126.80712890625,
        253.0
      ],
      [
        -156.35299682617188,
        1126.80712890625,
        262.0
      ],
      [
        -156.35299682617188,
        1126.80712890625,
        262.0
      ],
      [
        -156.35299682617188,
        1126.80712890625,
        253.0
      ],
      [
        -156.35299682617188,
        1126.80712890625,
        303.0
      ],
      [
        -156.35299682617188,
        1126.80712890625,
        312.0
      ],
      [
        -156.35299682617188,
        1126.80712890625,
        312.0
      ],
      [
        -156.35299682617188,
        1126.80712890625,
        303.0
      ],
      [
        -254.4998779296875,
        1097.7781982421875,
        300.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        300.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        350.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        300.0
      ],
      [
        -309.4835205078125,
        1006.4124755859375,
        300.0
      ],
      [
        -289.5000305175781,
        971.800048828125,
        300.0
      ],
      [
        0.0,
        839.9456176757812,
        155.0
      ],
      [
        0.0,
        1000.0,
        82.0
      ],
      [
        0.0,
        1000.0,
        126.0
      ],
      [
        0.0,
        1027.272705078125,
        104.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        250.0
      ],
      [
        -334.49993896484375,
        1097.7781982421875,
        250.0
      ],
      [
        -482.9289245605469,
        1162.928955078125,
        250.0
      ],
      [
        -490.0,
        1160.0,
        250.00001525878906
      ],
      [
        -339.4679260253906,
        1100.646484375,
        78.0
      ],
      [
        -334.49993896484375,
        1097.7781982421875,
        75.0
      ],
      [
        -335.49993896484375,
        1097.7781982421875,
        75.0
      ],
      [
        -340.46795654296875,
        1100.646484375,
        75.0
      ],
      [
        -409.6885070800781,
        1140.611083984375,
        75.0
      ],
      [
        -340.46795654296875,
        1100.646484375,
        75.0
      ],
      [
        -336.5,
        1098.6800537109375,
        78.0
      ],
      [
        -336.5,
        1098.3555908203125,
        78.0
      ],
      [
        -336.5,
        1098.3555908203125,
        75.0
      ],
      [
        -336.5,
        1098.6800537109375,
        78.0
      ],
      [
        -336.5,
        1098.9329833984375,
        75.0
      ],
      [
        -336.5,
        1098.9329833984375,
        78.0
      ],
      [
        -335.5,
        1098.3555908203125,
        75.0
      ],
      [
        -335.5,
        1097.7781982421875,
        75.0
      ],
      [
        -335.5,
        1097.7781982421875,
        78.0
      ],
      [
        -335.5,
        1098.3555908203125,
        78.0
      ],
      [
        -339.4679260253906,
        1100.646484375,
        75.0
      ],
      [
        -339.46795654296875,
        1100.646484375,
        78.0
      ],
      [
        -409.4375,
        1141.04345703125,
        78.0
      ],
      [
        -409.6885070800781,
        1140.611083984375,
        75.0
      ],
      [
        -409.6885070800781,
        1140.611083984375,
        78.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        75.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        75.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        75.0
      ],
      [
        -424.5,
        1115.0986328125,
        78.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        75.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        78.0
      ],
      [
        -417.09478759765625,
        1136.816650390625,
        78.0
      ],
      [
        -424.6260986328125,
        1123.84423828125,
        78.0
      ],
      [
        -413.2030944824219,
        1134.5572509765625,
        78.0
      ],
      [
        -424.6260986328125,
        1123.84423828125,
        78.0
      ],
      [
        -420.7344055175781,
        1121.5848388671875,
        78.0
      ],
      [
        -413.2030944824219,
        1134.5572509765625,
        78.0
      ],
      [
        -417.09478759765625,
        1136.816650390625,
        78.0
      ],
      [
        -336.5,
        1097.7781982421875,
        78.0
      ],
      [
        -336.5,
        1097.7781982421875,
        75.0
      ],
      [
        -435.4183654785156,
        1156.04345703125,
        120.0
      ],
      [
        -409.91668701171875,
        1141.320068359375,
        120.0
      ],
      [
        -417.6866149902344,
        1145.8060302734375,
        120.0
      ],
      [
        -334.49993896484375,
        1097.7781982421875,
        120.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        120.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        120.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        120.0
      ],
      [
        -445.0,
        1100.0,
        120.0
      ],
      [
        -500.0,
        1100.0,
        120.0
      ],
      [
        -340.8411865234375,
        1100.0,
        205.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        205.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        225.0
      ],
      [
        -340.8411865234375,
        1100.0,
        225.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        205.0
      ],
      [
        -340.8411865234375,
        1100.0,
        205.0
      ],
      [
        -338.3482360839844,
        1100.0,
        205.0
      ],
      [
        -334.49993896484375,
        1097.7781982421875,
        205.0
      ],
      [
        -340.8411865234375,
        1100.0,
        225.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        225.0
      ],
      [
        -334.49993896484375,
        1097.7781982421875,
        225.0
      ],
      [
        -338.3482360839844,
        1100.0,
        225.0
      ],
      [
        -520.1583862304688,
        1147.5079345703125,
        120.0
      ],
      [
        -496.91070556640625,
        1157.1373291015625,
        131.0
      ],
      [
        -500.0,
        1100.0,
        120.0
      ],
      [
        -500.0,
        1120.0,
        120.0
      ],
      [
        -435.4183654785156,
        1156.04345703125,
        120.0
      ],
      [
        -452.7389221191406,
        1166.04345703125,
        131.0
      ],
      [
        -496.9107666015625,
        1157.137451171875,
        131.0
      ],
      [
        -452.7389221191406,
        1166.04345703125,
        131.0
      ],
      [
        -462.2093505859375,
        1171.51123046875,
        131.0
      ],
      [
        -435.4183654785156,
        1156.04345703125,
        95.0
      ],
      [
        -435.4183654785156,
        1156.04345703125,
        95.0
      ],
      [
        -520.1583862304688,
        1147.5079345703125,
        95.0
      ],
      [
        -462.20941162109375,
        1171.51123046875,
        95.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        95.0
      ],
      [
        -487.30767822265625,
        1110.0,
        95.0
      ],
      [
        -336.5,
        1097.7781982421875,
        78.049072265625
      ],
      [
        -336.5,
        1098.9329833984375,
        78.5
      ],
      [
        -336.0618896484375,
        1098.6800537109375,
        78.5
      ],
      [
        -335.5,
        1098.3555908203125,
        78.33779907226562
      ],
      [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      [
        -336.5,
        1097.7781982421875,
        78.049072265625
      ],
      [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      [
        -335.5,
        1098.3555908203125,
        78.33779907226562
      ],
      [
        -336.0618896484375,
        1098.6800537109375,
        78.5
      ],
      [
        -336.5,
        1098.9329833984375,
        78.5
      ],
      [
        -398.348388671875,
        1100.0,
        95.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        95.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        120.0
      ],
      [
        -398.348388671875,
        1100.0,
        120.0
      ],
      [
        -520.1583862304688,
        1147.5079345703125,
        105.0
      ],
      [
        -520.1583862304688,
        1147.5078125,
        95.0
      ],
      [
        -520.1583862304688,
        1147.5079345703125,
        120.0
      ],
      [
        -520.1583862304688,
        1147.5078125,
        105.0
      ],
      [
        -455.5519104003906,
        1110.0,
        107.79500579833984
      ],
      [
        -455.0,
        1109.6795654296875,
        108.0
      ],
      [
        -455.5519104003906,
        1110.0,
        107.79500579833984
      ],
      [
        -455.5519104003906,
        1110.0,
        106.79500579833984
      ],
      [
        -450.54339599609375,
        1130.134765625,
        120.0
      ],
      [
        -450.54339599609375,
        1130.134765625,
        95.0
      ],
      [
        -430.0,
        1118.2740478515625,
        95.0
      ],
      [
        -430.0,
        1118.2740478515625,
        105.0
      ],
      [
        -430.0,
        1118.2740478515625,
        105.0
      ],
      [
        -435.0,
        1121.160888671875,
        105.0
      ],
      [
        -430.0,
        1118.291748046875,
        95.0
      ],
      [
        -430.0,
        1118.291748046875,
        105.0
      ],
      [
        -430.0,
        1118.291748046875,
        105.0
      ],
      [
        -480.0,
        1170.0,
        250.0
      ],
      [
        -482.9289245605469,
        1162.928955078125,
        250.00001525878906
      ],
      [
        -476.06134033203125,
        1179.5086669921875,
        95.0
      ],
      [
        -482.9288635253906,
        1162.928955078125,
        95.0
      ],
      [
        -468.59075927734375,
        1175.195556640625,
        131.0
      ],
      [
        -468.8244934082031,
        1175.33056640625,
        131.0
      ],
      [
        -477.35589599609375,
        1176.38330078125,
        131.0
      ],
      [
        -477.35589599609375,
        1176.38330078125,
        131.0
      ],
      [
        -468.8244934082031,
        1175.33056640625,
        131.0
      ],
      [
        -476.0613098144531,
        1179.5086669921875,
        131.0
      ],
      [
        -468.59075927734375,
        1175.195556640625,
        131.0
      ],
      [
        -482.9289245605469,
        1177.071044921875,
        250.0
      ],
      [
        -480.0,
        1170.0,
        250.00001525878906
      ],
      [
        -486.4145812988281,
        1185.486083984375,
        95.0
      ],
      [
        -479.9999694824219,
        1170.0,
        95.0
      ],
      [
        -486.41455078125,
        1185.486083984375,
        131.0
      ],
      [
        -490.0,
        1160.0,
        250.0
      ],
      [
        -497.0710754394531,
        1162.928955078125,
        250.00001525878906
      ],
      [
        -528.0411376953125,
        1175.7572021484375,
        95.0
      ],
      [
        -489.9999694824219,
        1160.0,
        95.0
      ],
      [
        -528.0411376953125,
        1175.7572021484375,
        95.0
      ],
      [
        -528.0411376953125,
        1175.7572021484375,
        120.0
      ],
      [
        -528.0411376953125,
        1175.7572021484375,
        120.0
      ],
      [
        -509.39813232421875,
        1168.0350341796875,
        131.0
      ],
      [
        -506.9605407714844,
        1167.0252685546875,
        131.0
      ],
      [
        -509.39813232421875,
        1168.0350341796875,
        131.0
      ],
      [
        -506.9605407714844,
        1167.0252685546875,
        131.0
      ],
      [
        -490.0,
        1180.0,
        250.0
      ],
      [
        -482.9289245605469,
        1177.071044921875,
        250.00001525878906
      ],
      [
        -518.680908203125,
        1191.8800048828125,
        95.0
      ],
      [
        -513.3609008789062,
        1201.0435791015625,
        95.0
      ],
      [
        -482.9289245605469,
        1177.071044921875,
        95.0
      ],
      [
        -513.3609008789062,
        1201.0435791015625,
        95.0
      ],
      [
        -518.680908203125,
        1191.8800048828125,
        95.0
      ],
      [
        -518.680908203125,
        1191.8800048828125,
        120.0
      ],
      [
        -513.3609008789062,
        1201.0435791015625,
        120.0
      ],
      [
        -513.3609008789062,
        1201.0435791015625,
        120.0
      ],
      [
        -518.680908203125,
        1191.8800048828125,
        120.0
      ],
      [
        -500.037841796875,
        1184.157958984375,
        131.0
      ],
      [
        -496.0403137207031,
        1191.0435791015625,
        131.0
      ],
      [
        -495.941162109375,
        1190.986328125,
        131.0
      ],
      [
        -496.61090087890625,
        1182.7384033203125,
        131.0
      ],
      [
        -495.7098388671875,
        1190.852783203125,
        131.0
      ],
      [
        -496.0403137207031,
        1191.0435791015625,
        131.0
      ],
      [
        -500.037841796875,
        1184.157958984375,
        131.0
      ],
      [
        -496.61090087890625,
        1182.7384033203125,
        131.0
      ],
      [
        -495.941162109375,
        1190.986328125,
        131.0
      ],
      [
        -495.7098388671875,
        1190.852783203125,
        131.0
      ],
      [
        -497.0710754394531,
        1177.071044921875,
        250.0
      ],
      [
        -490.0,
        1180.0,
        250.00001525878906
      ],
      [
        -498.377685546875,
        1176.52978515625,
        95.0
      ],
      [
        -490.0001525878906,
        1180.0,
        95.0
      ],
      [
        -514.1420288085938,
        1170.0,
        95.0
      ],
      [
        -514.1420288085938,
        1170.0,
        128.200927734375
      ],
      [
        -506.3941345214844,
        1173.2093505859375,
        131.0
      ],
      [
        -506.3941345214844,
        1173.2093505859375,
        131.0
      ],
      [
        -498.377685546875,
        1176.52978515625,
        105.0
      ],
      [
        -498.37762451171875,
        1176.5299072265625,
        106.0
      ],
      [
        -497.9949645996094,
        1177.4537353515625,
        106.0
      ],
      [
        -498.377685546875,
        1176.52978515625,
        105.0
      ],
      [
        -498.37762451171875,
        1176.5299072265625,
        106.0
      ],
      [
        -500.0,
        1170.0,
        250.0
      ],
      [
        -497.0710754394531,
        1177.071044921875,
        250.00001525878906
      ],
      [
        -502.071044921875,
        1165.0,
        95.0
      ],
      [
        -497.071044921875,
        1177.0711669921875,
        95.0
      ],
      [
        -502.0710754394531,
        1165.0,
        131.0
      ],
      [
        -500.3826599121094,
        1169.076171875,
        106.0
      ],
      [
        -500.3826599121094,
        1169.076171875,
        95.0
      ],
      [
        -500.3826599121094,
        1169.076171875,
        106.0
      ],
      [
        -497.0710754394531,
        1162.928955078125,
        250.0
      ],
      [
        -500.0,
        1170.0,
        250.00001525878906
      ],
      [
        -500.3826599121094,
        1169.076171875,
        95.0
      ],
      [
        -500.0,
        1170.0,
        95.0
      ],
      [
        -499.4588317871094,
        1168.6934814453125,
        95.0
      ],
      [
        -497.0710754394531,
        1162.928955078125,
        95.0
      ],
      [
        -493.57470703125,
        1189.6201171875,
        300.0
      ],
      [
        -514.4999389648438,
        1201.7012939453125,
        300.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        300.0
      ],
      [
        -334.49993896484375,
        1097.7781982421875,
        300.0
      ],
      [
        -478.4936218261719,
        1180.9130859375,
        300.0
      ],
      [
        -478.4936218261719,
        1180.9130859375,
        300.0
      ],
      [
        -493.57470703125,
        1189.6201171875,
        300.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        300.0
      ],
      [
        -394.5002136230469,
        1097.7781982421875,
        300.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        250.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        270.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        270.0
      ],
      [
        -334.49993896484375,
        1097.7781982421875,
        270.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        320.0
      ],
      [
        -334.49993896484375,
        1097.7781982421875,
        320.0
      ],
      [
        -514.4999389648438,
        1201.7012939453125,
        320.0
      ],
      [
        -461.9999694824219,
        1171.390380859375,
        320.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        320.0
      ],
      [
        -394.5002136230469,
        1097.7781982421875,
        320.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        402.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        422.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        422.0
      ],
      [
        -334.49993896484375,
        1097.7781982421875,
        422.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        402.0
      ],
      [
        -334.49993896484375,
        1097.7781982421875,
        402.0
      ],
      [
        -394.5002136230469,
        1097.7781982421875,
        320.0
      ],
      [
        -394.5002136230469,
        1097.7781982421875,
        300.0
      ],
      [
        -529.5000610351562,
        1175.72021484375,
        305.0
      ],
      [
        -529.5001220703125,
        1175.72021484375,
        300.0
      ],
      [
        -529.5001220703125,
        1175.72021484375,
        305.0
      ],
      [
        -529.5000610351562,
        1175.72021484375,
        320.0
      ],
      [
        -492.64703369140625,
        1126.80712890625,
        303.0
      ],
      [
        -492.64703369140625,
        1126.80712890625,
        312.0
      ],
      [
        -492.64703369140625,
        1126.80712890625,
        312.0
      ],
      [
        -492.64703369140625,
        1126.80712890625,
        303.0
      ],
      [
        -514.4999389648438,
        1201.7012939453125,
        305.0
      ],
      [
        -514.4999389648438,
        1201.7012939453125,
        300.0
      ],
      [
        -514.4999389648438,
        1201.7012939453125,
        305.0
      ],
      [
        -514.4999389648438,
        1201.7012939453125,
        320.0
      ],
      [
        -498.377685546875,
        1176.52978515625,
        310.0
      ],
      [
        -498.37762451171875,
        1176.5299072265625,
        311.0
      ],
      [
        -497.9949645996094,
        1177.4537353515625,
        311.0
      ],
      [
        -498.377685546875,
        1176.52978515625,
        310.0
      ],
      [
        -498.37762451171875,
        1176.5299072265625,
        311.0
      ],
      [
        -500.54119873046875,
        1171.3065185546875,
        310.0
      ],
      [
        -500.54119873046875,
        1171.306640625,
        311.0
      ],
      [
        -500.92388916015625,
        1170.3826904296875,
        311.0
      ],
      [
        -500.54119873046875,
        1171.306640625,
        311.0
      ],
      [
        -500.54119873046875,
        1171.3065185546875,
        310.0
      ],
      [
        -324.5,
        1092.0047607421875,
        250.0
      ],
      [
        -324.5,
        1092.0047607421875,
        120.0
      ],
      [
        -324.5,
        1092.0047607421875,
        205.0
      ],
      [
        -324.5,
        1092.0047607421875,
        225.0
      ],
      [
        -324.5,
        1092.0047607421875,
        75.0
      ],
      [
        -324.5,
        1092.0047607421875,
        320.0
      ],
      [
        -324.5,
        1092.0047607421875,
        402.0
      ],
      [
        -324.5,
        1092.0047607421875,
        422.0
      ],
      [
        -324.5,
        1092.0047607421875,
        300.0
      ],
      [
        -324.5,
        1092.0047607421875,
        270.0
      ],
      [
        -340.21795654296875,
        1101.0794677734375,
        250.0
      ],
      [
        -308.78204345703125,
        1101.0794677734375,
        250.00003051757812
      ],
      [
        -332.1410217285156,
        1130.4095458984375,
        95.0
      ],
      [
        -317.6125793457031,
        1130.4095458984375,
        95.0
      ],
      [
        -317.612548828125,
        1130.4095458984375,
        95.0
      ],
      [
        -257.9808044433594,
        1130.4095458984375,
        95.0
      ],
      [
        -391.01904296875,
        1130.4095458984375,
        95.0
      ],
      [
        -332.1410217285156,
        1130.4095458984375,
        95.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        120.0
      ],
      [
        -391.0191650390625,
        1130.4095458984375,
        120.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        120.0
      ],
      [
        -257.9808349609375,
        1130.4095458984375,
        120.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        118.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        118.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        120.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        118.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        120.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        118.0
      ],
      [
        -329.5,
        1130.4095458984375,
        400.0
      ],
      [
        -320.5,
        1130.4095458984375,
        400.0
      ],
      [
        -391.0191650390625,
        1130.4095458984375,
        400.0
      ],
      [
        -329.5,
        1130.4095458984375,
        400.0
      ],
      [
        -320.5,
        1130.4095458984375,
        400.0
      ],
      [
        -257.9808349609375,
        1130.4095458984375,
        400.0
      ],
      [
        -257.9808349609375,
        1130.4095458984375,
        402.0
      ],
      [
        -257.9808349609375,
        1130.4095458984375,
        422.0
      ],
      [
        -320.5,
        1130.4095458984375,
        432.0
      ],
      [
        -320.5,
        1190.0,
        432.0
      ],
      [
        -320.5,
        1190.0,
        402.0
      ],
      [
        -320.5,
        1190.0,
        402.0
      ],
      [
        -320.5,
        1190.0,
        432.0
      ],
      [
        -320.5,
        1160.0,
        432.0
      ],
      [
        -320.5,
        1160.0,
        402.0
      ],
      [
        -320.5,
        1158.0,
        402.0
      ],
      [
        -320.5,
        1158.0,
        432.0
      ],
      [
        -320.5,
        1154.0,
        405.5
      ],
      [
        -320.5,
        1158.0,
        405.5
      ],
      [
        -320.5,
        1158.0,
        405.0
      ],
      [
        -320.5,
        1154.0,
        405.0
      ],
      [
        -320.5,
        1154.0,
        405.0
      ],
      [
        -320.5,
        1154.0,
        405.5
      ],
      [
        -320.5,
        1161.4000244140625,
        404.0
      ],
      [
        -320.5,
        1163.300048828125,
        404.0
      ],
      [
        -320.5,
        1180.0,
        404.0
      ],
      [
        -320.5,
        1170.0,
        404.0
      ],
      [
        -320.5,
        1170.0,
        404.0
      ],
      [
        -320.5,
        1170.0,
        404.5
      ],
      [
        -320.5,
        1177.25,
        404.5
      ],
      [
        -320.5,
        1172.25,
        404.5
      ],
      [
        -320.5,
        1170.0,
        404.5
      ],
      [
        -320.5,
        1180.0,
        404.5
      ],
      [
        -320.5,
        1180.0,
        404.5
      ],
      [
        -320.5,
        1180.0,
        404.0
      ],
      [
        -320.5,
        1160.7999267578125,
        407.0
      ],
      [
        -320.5,
        1160.0,
        407.0
      ],
      [
        -320.5,
        1161.4000244140625,
        404.0
      ],
      [
        -320.5,
        1160.7999267578125,
        407.0
      ],
      [
        -320.5,
        1163.300048828125,
        404.0
      ],
      [
        -320.5,
        1163.300048828125,
        402.0
      ],
      [
        -320.5,
        1172.0,
        402.0
      ],
      [
        -320.5,
        1172.0,
        404.0
      ],
      [
        -320.5,
        1178.0,
        404.0
      ],
      [
        -320.5,
        1178.0,
        402.0
      ],
      [
        -375.0001220703125,
        1147.0,
        406.20001220703125
      ],
      [
        -375.0001220703125,
        1180.0,
        406.20001220703125
      ],
      [
        -372.0001220703125,
        1130.5,
        405.5
      ],
      [
        -372.0001220703125,
        1136.5,
        405.5
      ],
      [
        -372.0001220703125,
        1136.5,
        405.5
      ],
      [
        -372.0001220703125,
        1136.5,
        402.0
      ],
      [
        -372.0001220703125,
        1180.0,
        419.20001220703125
      ],
      [
        -375.0001220703125,
        1180.0,
        419.20001220703125
      ],
      [
        -375.0001220703125,
        1147.0,
        419.20001220703125
      ],
      [
        -372.0001220703125,
        1147.0,
        419.20001220703125
      ],
      [
        -372.0001220703125,
        1150.0,
        409.0
      ],
      [
        -372.0001220703125,
        1150.0,
        409.5
      ],
      [
        -375.0001220703125,
        1150.0,
        409.5
      ],
      [
        -375.0001220703125,
        1150.0,
        409.0
      ],
      [
        -375.0001220703125,
        1147.0,
        409.0
      ],
      [
        -375.0001220703125,
        1147.0,
        409.5
      ],
      [
        -372.0001220703125,
        1147.0,
        409.5
      ],
      [
        -372.0001220703125,
        1147.0,
        409.0
      ],
      [
        -372.0001220703125,
        1180.0,
        409.0
      ],
      [
        -372.0001220703125,
        1180.0,
        409.5
      ],
      [
        -375.0001220703125,
        1180.0,
        409.5
      ],
      [
        -375.0001220703125,
        1180.0,
        409.0
      ],
      [
        -375.0001220703125,
        1177.0,
        409.0
      ],
      [
        -375.0001220703125,
        1177.0,
        409.5
      ],
      [
        -372.0001220703125,
        1177.0,
        409.5
      ],
      [
        -372.0001220703125,
        1177.0,
        409.0
      ],
      [
        -372.0001220703125,
        1150.0,
        412.5
      ],
      [
        -372.0001220703125,
        1150.0,
        413.0
      ],
      [
        -375.0001220703125,
        1150.0,
        413.0
      ],
      [
        -375.0001220703125,
        1150.0,
        412.5
      ],
      [
        -375.0001220703125,
        1147.0,
        412.5
      ],
      [
        -375.0001220703125,
        1147.0,
        413.0
      ],
      [
        -372.0001220703125,
        1147.0,
        413.0
      ],
      [
        -372.0001220703125,
        1147.0,
        412.5
      ],
      [
        -372.0001220703125,
        1180.0,
        412.5
      ],
      [
        -372.0001220703125,
        1180.0,
        413.0
      ],
      [
        -375.0001220703125,
        1180.0,
        413.0
      ],
      [
        -375.0001220703125,
        1180.0,
        412.5
      ],
      [
        -375.0001220703125,
        1177.0,
        412.5
      ],
      [
        -375.0001220703125,
        1177.0,
        413.0
      ],
      [
        -372.0001220703125,
        1177.0,
        413.0
      ],
      [
        -372.0001220703125,
        1177.0,
        412.5
      ],
      [
        -372.0001220703125,
        1150.0,
        416.1000061035156
      ],
      [
        -372.0001220703125,
        1150.0,
        416.6000061035156
      ],
      [
        -375.0001220703125,
        1150.0,
        416.6000061035156
      ],
      [
        -375.0001220703125,
        1150.0,
        416.1000061035156
      ],
      [
        -375.0001220703125,
        1147.0,
        416.1000061035156
      ],
      [
        -375.0001220703125,
        1147.0,
        416.6000061035156
      ],
      [
        -372.0001220703125,
        1147.0,
        416.6000061035156
      ],
      [
        -372.0001220703125,
        1147.0,
        416.1000061035156
      ],
      [
        -372.0001220703125,
        1180.0,
        416.1000061035156
      ],
      [
        -372.0001220703125,
        1180.0,
        416.6000061035156
      ],
      [
        -375.0001220703125,
        1180.0,
        416.6000061035156
      ],
      [
        -375.0001220703125,
        1180.0,
        416.1000061035156
      ],
      [
        -375.0001220703125,
        1177.0,
        416.1000061035156
      ],
      [
        -375.0001220703125,
        1177.0,
        416.6000061035156
      ],
      [
        -372.0001220703125,
        1177.0,
        416.6000061035156
      ],
      [
        -372.0001220703125,
        1177.0,
        416.1000061035156
      ],
      [
        -360.0,
        1177.5147705078125,
        406.20001220703125
      ],
      [
        -360.0,
        1177.5147705078125,
        402.0
      ],
      [
        -409.4998474121094,
        1141.07958984375,
        95.0
      ],
      [
        -409.49993896484375,
        1141.0794677734375,
        95.0
      ],
      [
        -320.5,
        1130.4095458984375,
        95.0
      ],
      [
        -320.5,
        1200.361328125,
        95.0
      ],
      [
        -340.0255432128906,
        1210.361328125,
        120.0
      ],
      [
        -340.0,
        1210.361328125,
        120.0
      ],
      [
        -377.9443664550781,
        1195.7349853515625,
        120.0
      ],
      [
        -369.4998779296875,
        1210.361328125,
        120.0
      ],
      [
        -340.0255432128906,
        1210.361328125,
        120.0
      ],
      [
        -409.4998474121094,
        1141.07958984375,
        120.0
      ],
      [
        -409.49993896484375,
        1141.0794677734375,
        120.0
      ],
      [
        -377.9443664550781,
        1195.7349853515625,
        120.0
      ],
      [
        -320.5,
        1130.4095458984375,
        118.0
      ],
      [
        -320.5,
        1180.199951171875,
        118.0
      ],
      [
        -320.5,
        1180.199951171875,
        118.0
      ],
      [
        -340.0,
        1210.361328125,
        118.0
      ],
      [
        -320.5,
        1210.361328125,
        118.0
      ],
      [
        -357.96875,
        1195.25,
        114.68749237060547
      ],
      [
        -376.25,
        1195.25,
        114.68749237060547
      ],
      [
        -365.0,
        1195.25,
        114.68749237060547
      ],
      [
        -365.0,
        1195.25,
        114.68749237060547
      ],
      [
        -357.96875,
        1195.25,
        114.68749237060547
      ],
      [
        -376.25,
        1166.050048828125,
        118.0
      ],
      [
        -376.25,
        1185.25,
        118.0
      ],
      [
        -409.4375,
        1141.04345703125,
        118.0
      ],
      [
        -409.4998474121094,
        1141.07958984375,
        95.0
      ],
      [
        -409.4998474121094,
        1141.07958984375,
        118.0
      ],
      [
        -353.0,
        1195.25,
        118.0
      ],
      [
        -353.0,
        1185.25,
        118.0
      ],
      [
        -376.25,
        1195.25,
        118.0
      ],
      [
        -365.0,
        1195.25,
        118.0
      ],
      [
        -365.0,
        1195.25,
        118.0
      ],
      [
        -353.0,
        1195.25,
        118.0
      ],
      [
        -340.0,
        1210.361328125,
        120.0
      ],
      [
        -340.0,
        1210.361328125,
        118.0
      ],
      [
        -409.4998474121094,
        1141.07958984375,
        120.0
      ],
      [
        -374.483154296875,
        1201.7301025390625,
        125.006103515625
      ],
      [
        -387.80487060546875,
        1178.65625,
        125.006103515625
      ],
      [
        -387.80487060546875,
        1178.65625,
        120.0
      ],
      [
        -387.80487060546875,
        1178.65625,
        125.006103515625
      ],
      [
        -340.0,
        1210.361328125,
        125.0
      ],
      [
        -355.0,
        1210.361328125,
        125.0
      ],
      [
        -340.0,
        1210.361328125,
        120.0
      ],
      [
        -340.0,
        1210.361328125,
        125.0
      ],
      [
        -320.5,
        1200.361328125,
        75.0
      ],
      [
        -320.5,
        1200.361328125,
        95.0
      ],
      [
        -340.0,
        1210.361328125,
        60.0
      ],
      [
        -340.0,
        1210.361328125,
        75.0
      ],
      [
        -364.75,
        1175.0,
        90.75
      ],
      [
        -364.75,
        1175.0,
        65.0
      ],
      [
        -364.75,
        1187.7750244140625,
        82.40657806396484
      ],
      [
        -364.75,
        1175.0,
        77.33158111572266
      ],
      [
        -364.75,
        1185.219970703125,
        87.54440307617188
      ],
      [
        -364.75,
        1175.0,
        83.4843978881836
      ],
      [
        -364.75,
        1183.176025390625,
        91.68366241455078
      ],
      [
        -364.75,
        1175.0,
        88.43566131591797
      ],
      [
        -364.75,
        1162.2249755859375,
        82.40657806396484
      ],
      [
        -364.75,
        1175.0,
        77.33158111572266
      ],
      [
        -364.75,
        1164.780029296875,
        87.54440307617188
      ],
      [
        -364.75,
        1175.0,
        83.4843978881836
      ],
      [
        -364.75,
        1166.823974609375,
        91.68366241455078
      ],
      [
        -364.75,
        1175.0,
        88.43566131591797
      ],
      [
        -429.4999084472656,
        1210.361328125,
        120.0008773803711
      ],
      [
        -429.4999084472656,
        1210.361328125,
        100.00611877441406
      ],
      [
        -429.4999084472656,
        1210.361328125,
        100.00611877441406
      ],
      [
        -429.4999084472656,
        1210.361328125,
        80.00611877441406
      ],
      [
        -429.4999084472656,
        1210.361328125,
        120.0008773803711
      ],
      [
        -429.4999084472656,
        1210.361328125,
        500.0
      ],
      [
        -509.5000915527344,
        1210.361328125,
        320.0
      ],
      [
        -439.5000915527344,
        1210.361328125,
        320.0
      ],
      [
        -501.2818908691406,
        1210.361328125,
        300.0
      ],
      [
        -509.5000915527344,
        1210.361328125,
        300.0
      ],
      [
        -439.5000915527344,
        1210.361328125,
        300.0
      ],
      [
        -444.4977722167969,
        1210.361328125,
        300.0
      ],
      [
        -444.4977722167969,
        1210.361328125,
        300.0
      ],
      [
        -501.2818908691406,
        1210.361328125,
        300.0
      ],
      [
        -407.63079833984375,
        1145.3536376953125,
        128.45095825195312
      ],
      [
        -407.18524169921875,
        1145.0887451171875,
        128.45394897460938
      ],
      [
        -417.67535400390625,
        1145.8260498046875,
        120.0
      ],
      [
        -399.4999694824219,
        1158.39990234375,
        120.0
      ],
      [
        -399.5027770996094,
        1158.40478515625,
        120.0
      ],
      [
        -439.5000915527344,
        1210.361328125,
        320.0
      ],
      [
        -439.5000915527344,
        1210.361328125,
        300.0
      ],
      [
        -509.5000915527344,
        1210.361328125,
        305.0
      ],
      [
        -509.5000915527344,
        1210.361328125,
        300.0
      ],
      [
        -509.5000915527344,
        1210.361328125,
        305.0
      ],
      [
        -509.5000915527344,
        1210.361328125,
        320.0
      ],
      [
        -429.4999084472656,
        1210.361328125,
        80.00611877441406
      ],
      [
        -406.4058837890625,
        1210.361328125,
        60.00611877441406
      ],
      [
        -369.522216796875,
        1210.361328125,
        120.0
      ],
      [
        -387.80487060546875,
        1178.65625,
        120.0
      ],
      [
        -387.8139953613281,
        1178.6614990234375,
        120.0
      ],
      [
        -248.47630310058594,
        1135.89697265625,
        402.0
      ],
      [
        -248.47630310058594,
        1135.89697265625,
        422.0
      ],
      [
        -280.0,
        1158.0,
        410.0
      ],
      [
        -280.0,
        1158.0,
        406.0
      ],
      [
        -280.0,
        1158.0,
        406.0
      ],
      [
        -280.0,
        1158.0,
        402.0
      ],
      [
        -280.0,
        1158.0,
        432.0
      ],
      [
        -280.0,
        1158.0,
        410.0
      ],
      [
        -305.0,
        1158.0,
        405.0
      ],
      [
        -305.0,
        1154.0,
        405.5
      ],
      [
        -305.0,
        1154.0,
        405.0
      ],
      [
        -305.0,
        1152.0,
        405.0
      ],
      [
        -239.54287719726562,
        1141.15380859375,
        95.0
      ],
      [
        -239.49996948242188,
        1141.0794677734375,
        95.0
      ],
      [
        -244.0028076171875,
        1148.8785400390625,
        95.0
      ],
      [
        -249.50714111328125,
        1158.412353515625,
        95.0
      ],
      [
        -239.49996948242188,
        1141.0794677734375,
        120.0
      ],
      [
        -239.54287719726562,
        1141.15380859375,
        120.0
      ],
      [
        -262.0843811035156,
        1180.196533203125,
        120.0
      ],
      [
        -310.0,
        1210.361328125,
        120.0
      ],
      [
        -279.5001220703125,
        1210.361328125,
        120.0
      ],
      [
        -262.0843811035156,
        1180.196533203125,
        120.0
      ],
      [
        -310.0,
        1210.361328125,
        118.0
      ],
      [
        -240.8894805908203,
        1140.2772216796875,
        118.0
      ],
      [
        -239.54287719726562,
        1141.15380859375,
        118.0
      ],
      [
        -239.54287719726562,
        1141.15380859375,
        95.0
      ],
      [
        -249.50714111328125,
        1158.412353515625,
        95.0
      ],
      [
        -249.50714111328125,
        1158.412353515625,
        110.0
      ],
      [
        -249.50714111328125,
        1158.412353515625,
        110.0
      ],
      [
        -244.0028076171875,
        1148.8785400390625,
        110.0
      ],
      [
        -310.0,
        1210.361328125,
        120.0
      ],
      [
        -310.0,
        1210.361328125,
        118.0
      ],
      [
        -239.54287719726562,
        1141.15380859375,
        120.0
      ],
      [
        -261.195068359375,
        1178.65625,
        125.006103515625
      ],
      [
        -274.516845703125,
        1201.7301025390625,
        125.006103515625
      ],
      [
        -261.195068359375,
        1178.65625,
        120.0
      ],
      [
        -261.195068359375,
        1178.65625,
        125.006103515625
      ],
      [
        -295.0,
        1210.361328125,
        125.0
      ],
      [
        -310.0,
        1210.361328125,
        125.0
      ],
      [
        -310.0,
        1210.361328125,
        125.0
      ],
      [
        -310.0,
        1210.361328125,
        120.0
      ],
      [
        -310.0,
        1210.361328125,
        75.0
      ],
      [
        -310.0,
        1210.361328125,
        60.0
      ],
      [
        -285.25,
        1175.0,
        65.0
      ],
      [
        -285.25,
        1175.0,
        88.75
      ],
      [
        -285.25,
        1175.0,
        74.83158111572266
      ],
      [
        -285.25,
        1187.7750244140625,
        79.90657806396484
      ],
      [
        -285.25,
        1175.0,
        80.9843978881836
      ],
      [
        -285.25,
        1185.219970703125,
        85.04440307617188
      ],
      [
        -285.25,
        1175.0,
        85.93566131591797
      ],
      [
        -285.25,
        1183.176025390625,
        89.18366241455078
      ],
      [
        -285.25,
        1175.0,
        74.83158111572266
      ],
      [
        -285.25,
        1162.2249755859375,
        79.90657806396484
      ],
      [
        -285.25,
        1175.0,
        80.9843978881836
      ],
      [
        -285.25,
        1164.780029296875,
        85.04440307617188
      ],
      [
        -285.25,
        1175.0,
        85.93566131591797
      ],
      [
        -285.25,
        1166.823974609375,
        89.18366241455078
      ],
      [
        -279.4776611328125,
        1210.361328125,
        120.0
      ],
      [
        -249.42201232910156,
        1158.2647705078125,
        120.0
      ],
      [
        -261.042724609375,
        1178.4073486328125,
        60.00611877441406
      ],
      [
        -219.50009155273438,
        1210.361328125,
        120.00524139404297
      ],
      [
        -219.5000762939453,
        1210.361328125,
        100.00611877441406
      ],
      [
        -219.5000762939453,
        1210.361328125,
        100.00611877441406
      ],
      [
        -219.50009155273438,
        1210.361328125,
        80.0
      ],
      [
        -219.50009155273438,
        1210.361328125,
        120.00524139404297
      ],
      [
        -219.5000762939453,
        1210.361328125,
        500.0
      ],
      [
        -249.50003051757812,
        1158.4000244140625,
        95.0
      ],
      [
        -249.484375,
        1158.4271240234375,
        95.0
      ],
      [
        -169.8828887939453,
        1210.361328125,
        95.0
      ],
      [
        -162.16839599609375,
        1210.361328125,
        95.0
      ],
      [
        -139.49990844726562,
        1210.361328125,
        80.0
      ],
      [
        -119.50043487548828,
        1210.361328125,
        62.68523025512695
      ],
      [
        -209.49990844726562,
        1210.361328125,
        320.0
      ],
      [
        -139.49990844726562,
        1210.361328125,
        320.0
      ],
      [
        -139.49993896484375,
        1210.361328125,
        250.0
      ],
      [
        -149.0497283935547,
        1210.361328125,
        250.0
      ],
      [
        -209.49990844726562,
        1210.361328125,
        250.0
      ],
      [
        -205.74085998535156,
        1210.361328125,
        250.0
      ],
      [
        -149.0497283935547,
        1210.361328125,
        250.0
      ],
      [
        -205.74085998535156,
        1210.361328125,
        250.0
      ],
      [
        -169.8828887939453,
        1210.361328125,
        120.0
      ],
      [
        -169.88290405273438,
        1210.361328125,
        95.0
      ],
      [
        -169.88290405273438,
        1210.361328125,
        120.0
      ],
      [
        -167.1900177001953,
        1210.361328125,
        120.8079833984375
      ],
      [
        -162.16839599609375,
        1210.361328125,
        120.0
      ],
      [
        -162.16839599609375,
        1210.361328125,
        95.0
      ],
      [
        -249.484375,
        1158.4271240234375,
        95.0
      ],
      [
        -249.484375,
        1158.4271240234375,
        110.0
      ],
      [
        -209.94268798828125,
        1184.0941162109375,
        110.0
      ],
      [
        -209.94268798828125,
        1184.0941162109375,
        95.0
      ],
      [
        -209.94268798828125,
        1184.0941162109375,
        120.0
      ],
      [
        -209.94268798828125,
        1184.0941162109375,
        110.0
      ],
      [
        -209.94268798828125,
        1184.0941162109375,
        120.0
      ],
      [
        -209.80831909179688,
        1184.181396484375,
        120.08821868896484
      ],
      [
        -249.484375,
        1158.4271240234375,
        110.0
      ],
      [
        -249.50003051757812,
        1158.4000244140625,
        110.0
      ],
      [
        -249.49725341796875,
        1158.40478515625,
        120.0
      ],
      [
        -239.5428924560547,
        1141.15380859375,
        120.0
      ],
      [
        -239.54290771484375,
        1141.15380859375,
        120.0
      ],
      [
        -249.50003051757812,
        1158.4000244140625,
        120.0
      ],
      [
        -167.1900177001953,
        1210.361328125,
        120.8079833984375
      ],
      [
        -162.16839599609375,
        1210.361328125,
        120.0
      ],
      [
        -214.50567626953125,
        1162.5135498046875,
        110.0
      ],
      [
        -211.1370086669922,
        1178.445556640625,
        110.0
      ],
      [
        -139.49993896484375,
        1210.361328125,
        300.0
      ],
      [
        -149.0497283935547,
        1210.361328125,
        300.0
      ],
      [
        -209.49990844726562,
        1210.361328125,
        300.0
      ],
      [
        -205.74085998535156,
        1210.361328125,
        300.0
      ],
      [
        -149.0497283935547,
        1210.361328125,
        300.0
      ],
      [
        -205.74085998535156,
        1210.361328125,
        300.0
      ],
      [
        -149.0497283935547,
        1210.361328125,
        270.0
      ],
      [
        -139.49993896484375,
        1210.361328125,
        270.0
      ],
      [
        -205.74085998535156,
        1210.361328125,
        270.0
      ],
      [
        -209.49990844726562,
        1210.361328125,
        270.0
      ],
      [
        -205.74085998535156,
        1210.361328125,
        270.0
      ],
      [
        -149.0497283935547,
        1210.361328125,
        270.0
      ],
      [
        -209.49990844726562,
        1210.361328125,
        250.0
      ],
      [
        -209.49990844726562,
        1210.361328125,
        270.0
      ],
      [
        -139.49990844726562,
        1210.361328125,
        255.0
      ],
      [
        -139.49990844726562,
        1210.361328125,
        250.0
      ],
      [
        -139.49990844726562,
        1210.361328125,
        255.0
      ],
      [
        -139.49990844726562,
        1210.361328125,
        270.0
      ],
      [
        -190.35296630859375,
        1185.80712890625,
        253.0
      ],
      [
        -190.35296630859375,
        1185.80712890625,
        262.0
      ],
      [
        -190.35296630859375,
        1185.80712890625,
        262.0
      ],
      [
        -190.35296630859375,
        1185.80712890625,
        253.0
      ],
      [
        -209.49990844726562,
        1210.361328125,
        300.0
      ],
      [
        -209.49990844726562,
        1210.361328125,
        320.0
      ],
      [
        -139.49990844726562,
        1210.361328125,
        305.0
      ],
      [
        -139.49990844726562,
        1210.361328125,
        300.0
      ],
      [
        -139.49990844726562,
        1210.361328125,
        305.0
      ],
      [
        -139.49990844726562,
        1210.361328125,
        320.0
      ],
      [
        -158.34146118164062,
        1198.5191650390625,
        318.0
      ],
      [
        -158.34146118164062,
        1198.5191650390625,
        320.0
      ],
      [
        -190.35296630859375,
        1185.80712890625,
        303.0
      ],
      [
        -190.35296630859375,
        1185.80712890625,
        312.0
      ],
      [
        -190.35296630859375,
        1185.80712890625,
        312.0
      ],
      [
        -190.35296630859375,
        1185.80712890625,
        303.0
      ],
      [
        -242.59410095214844,
        1210.361328125,
        60.00611877441406
      ],
      [
        -219.50009155273438,
        1210.361328125,
        80.0
      ],
      [
        -261.18597412109375,
        1178.6614990234375,
        120.0
      ],
      [
        -261.186279296875,
        1178.6612548828125,
        120.0
      ],
      [
        -540.0,
        1430.0,
        120.0
      ],
      [
        -394.65386962890625,
        1410.0,
        60.0
      ],
      [
        -400.42303466796875,
        1420.0,
        120.0
      ],
      [
        -406.1922912597656,
        1430.0,
        120.0
      ],
      [
        -400.42303466796875,
        1420.0,
        120.0
      ],
      [
        -516.034423828125,
        1239.0,
        60.02784729003906
      ],
      [
        -422.9655456542969,
        1239.0,
        60.02784729003906
      ],
      [
        -340.0,
        1239.02783203125,
        60.0
      ],
      [
        -340.0,
        1239.0,
        60.0
      ],
      [
        -340.0,
        1239.0,
        60.02788162231445
      ],
      [
        -422.9655456542969,
        1239.0,
        60.02784729003906
      ],
      [
        -422.9404602050781,
        1239.0,
        60.00611877441406
      ],
      [
        -310.0,
        1239.0,
        60.0
      ],
      [
        -310.0,
        1239.02783203125,
        60.0
      ],
      [
        -310.0,
        1239.0,
        60.02788162231445
      ],
      [
        -310.0,
        1239.0,
        80.0
      ],
      [
        -310.0,
        1239.0,
        125.0
      ],
      [
        -310.0,
        1239.0,
        80.0
      ],
      [
        -310.0,
        1239.0,
        125.0
      ],
      [
        -299.5,
        1239.0,
        125.0
      ],
      [
        -340.0,
        1239.0,
        80.0
      ],
      [
        -340.0,
        1239.0,
        80.0
      ],
      [
        -340.0,
        1239.0,
        125.0
      ],
      [
        -350.5,
        1239.0,
        125.0
      ],
      [
        -340.0,
        1239.0,
        125.0
      ],
      [
        -336.0,
        1239.0,
        65.0
      ],
      [
        -314.0,
        1239.0,
        65.0
      ],
      [
        -313.88458251953125,
        1270.0,
        65.0
      ],
      [
        -312.4634094238281,
        1267.53662109375,
        65.0
      ],
      [
        -310.0,
        1263.2667236328125,
        65.0
      ],
      [
        -310.0,
        1239.0,
        65.0
      ],
      [
        -314.0,
        1239.0,
        65.0
      ],
      [
        -312.4634094238281,
        1267.53662109375,
        65.0
      ],
      [
        -340.0,
        1239.0,
        65.0
      ],
      [
        -336.0,
        1239.0,
        65.0
      ],
      [
        -335.0,
        1239.0,
        85.0
      ],
      [
        -315.0,
        1239.0,
        85.0
      ],
      [
        -310.0,
        1239.0,
        85.0
      ],
      [
        -311.0,
        1239.0,
        85.0
      ],
      [
        -340.0,
        1239.0,
        85.0
      ],
      [
        -339.0,
        1239.0,
        85.0
      ],
      [
        -311.0,
        1239.0,
        85.0
      ],
      [
        -339.0,
        1239.0,
        85.0
      ],
      [
        -446.0344543457031,
        1239.0,
        60.02784729003906
      ],
      [
        -504.5,
        1219.021728515625,
        302.5
      ],
      [
        -504.5,
        1219.021728515625,
        302.0
      ],
      [
        -506.82196044921875,
        1215.0,
        302.0
      ],
      [
        -506.82196044921875,
        1215.0,
        302.5
      ],
      [
        -434.5,
        1219.021728515625,
        302.0
      ],
      [
        -434.5,
        1219.021728515625,
        302.5
      ],
      [
        -436.82196044921875,
        1215.0,
        302.5
      ],
      [
        -436.82196044921875,
        1215.0,
        302.0
      ],
      [
        -509.5000915527344,
        1210.361328125,
        302.0
      ],
      [
        -509.5000915527344,
        1210.361328125,
        302.5
      ],
      [
        -439.5000915527344,
        1210.361328125,
        302.5
      ],
      [
        -439.5000915527344,
        1210.361328125,
        302.0
      ],
      [
        -226.0344696044922,
        1239.0,
        60.02783966064453
      ],
      [
        -132.9655303955078,
        1239.0,
        60.02783966064453
      ],
      [
        -132.9655303955078,
        1239.0,
        60.02783966064453
      ],
      [
        -132.94044494628906,
        1239.0,
        60.00611877441406
      ],
      [
        -226.05955505371094,
        1239.0,
        60.00611877441406
      ],
      [
        -226.0344696044922,
        1239.0,
        60.02783966064453
      ],
      [
        -202.96554565429688,
        1239.0,
        60.02783966064453
      ],
      [
        -144.5,
        1219.021728515625,
        302.0
      ],
      [
        -144.5,
        1219.021728515625,
        302.5
      ],
      [
        -142.1780548095703,
        1215.0,
        302.5
      ],
      [
        -142.1780548095703,
        1215.0,
        302.0
      ],
      [
        -214.5,
        1219.021728515625,
        302.5
      ],
      [
        -214.5,
        1219.021728515625,
        302.0
      ],
      [
        -212.1780548095703,
        1215.0,
        302.0
      ],
      [
        -212.1780548095703,
        1215.0,
        302.5
      ],
      [
        -139.49990844726562,
        1210.361328125,
        302.5
      ],
      [
        -139.49990844726562,
        1210.361328125,
        302.0
      ],
      [
        -209.49990844726562,
        1210.361328125,
        302.0
      ],
      [
        -209.49990844726562,
        1210.361328125,
        302.5
      ],
      [
        -144.5,
        1219.021728515625,
        252.0
      ],
      [
        -144.5,
        1219.021728515625,
        252.5
      ],
      [
        -142.1780548095703,
        1215.0,
        252.5
      ],
      [
        -142.1780548095703,
        1215.0,
        252.0
      ],
      [
        -214.5,
        1219.021728515625,
        252.5
      ],
      [
        -214.5,
        1219.021728515625,
        252.0
      ],
      [
        -212.1780548095703,
        1215.0,
        252.0
      ],
      [
        -212.1780548095703,
        1215.0,
        252.5
      ],
      [
        -139.49990844726562,
        1210.361328125,
        252.5
      ],
      [
        -139.49990844726562,
        1210.361328125,
        252.0
      ],
      [
        -209.49990844726562,
        1210.361328125,
        252.0
      ],
      [
        -209.49990844726562,
        1210.361328125,
        252.5
      ],
      [
        190.0,
        1000.0,
        130.0
      ],
      [
        190.0,
        1500.0,
        130.0
      ],
      [
        190.0,
        829.921142578125,
        120.0
      ],
      [
        190.0,
        829.921142578125,
        130.0
      ],
      [
        183.3708953857422,
        820.0,
        130.0
      ],
      [
        190.0,
        829.921142578125,
        140.0
      ],
      [
        190.0,
        820.0,
        140.0
      ],
      [
        190.0,
        829.921142578125,
        140.0
      ],
      [
        120.0,
        1490.0,
        60.0
      ],
      [
        120.0,
        1490.0,
        214.0
      ],
      [
        252.0435028076172,
        1460.0,
        240.0
      ],
      [
        358.3660888671875,
        1698.2799072265625,
        240.0
      ],
      [
        260.0,
        1460.0,
        140.0
      ],
      [
        252.04348754882812,
        1460.0,
        140.0
      ],
      [
        289.462890625,
        1648.1199951171875,
        240.0
      ],
      [
        230.1345672607422,
        1500.0,
        120.0
      ],
      [
        230.14447021484375,
        1502.9405517578125,
        120.0
      ],
      [
        246.7465362548828,
        1584.1904296875,
        120.0
      ],
      [
        230.1345672607422,
        1500.0,
        120.0
      ],
      [
        250.0,
        1460.0,
        120.0
      ],
      [
        230.0,
        1460.0,
        120.0
      ],
      [
        250.0,
        1460.0,
        140.0
      ],
      [
        250.0,
        1460.0,
        120.0
      ],
      [
        250.0,
        1460.0,
        140.0
      ],
      [
        229.54360961914062,
        1500.0,
        120.0
      ],
      [
        229.54360961914062,
        1500.0,
        120.0
      ],
      [
        221.37026977539062,
        1460.0,
        120.0
      ],
      [
        203.68621826171875,
        1519.745849609375,
        120.0
      ],
      [
        200.0,
        1460.0,
        120.0
      ],
      [
        190.0,
        1460.0,
        130.0
      ],
      [
        190.0,
        1499.262939453125,
        130.0
      ],
      [
        190.4924774169922,
        1500.0,
        130.0
      ],
      [
        200.0,
        1460.0,
        130.0
      ],
      [
        250.0,
        1310.0,
        120.0
      ],
      [
        200.0,
        1310.0,
        120.0
      ],
      [
        270.0,
        1310.0,
        120.0
      ],
      [
        270.0,
        1415.0,
        120.0
      ],
      [
        250.0,
        1310.0,
        120.0
      ],
      [
        250.0,
        1310.0,
        140.0
      ],
      [
        250.0,
        1310.0,
        140.0
      ],
      [
        260.0,
        1310.0,
        140.0
      ],
      [
        190.0,
        1310.0,
        130.0
      ],
      [
        200.0,
        1310.0,
        130.0
      ],
      [
        440.0,
        940.0,
        80.0
      ],
      [
        440.0,
        980.0,
        80.0
      ],
      [
        440.0,
        930.0,
        60.0
      ],
      [
        440.0,
        920.0,
        80.0
      ],
      [
        440.0,
        921.8181762695312,
        76.36363983154297
      ],
      [
        358.18182373046875,
        921.8181762695312,
        76.36363220214844
      ],
      [
        260.0,
        1000.0,
        135.0
      ],
      [
        310.0,
        970.0,
        140.0
      ],
      [
        254.03262329101562,
        970.0,
        140.0
      ],
      [
        250.0,
        949.7266235351562,
        120.0
      ],
      [
        254.03262329101562,
        970.0,
        140.0
      ],
      [
        250.0,
        949.7266235351562,
        140.0
      ],
      [
        250.0,
        1000.0,
        130.0
      ],
      [
        226.98284912109375,
        885.2699584960938,
        130.0
      ],
      [
        250.0,
        949.7266235351562,
        130.0
      ],
      [
        236.40264892578125,
        881.3681640625,
        130.0
      ],
      [
        221.82235717773438,
        859.5471801757812,
        120.0
      ],
      [
        236.40264892578125,
        881.3681640625,
        130.0
      ],
      [
        221.82235717773438,
        859.5471801757812,
        130.0
      ],
      [
        226.98284912109375,
        885.2699584960938,
        130.0
      ],
      [
        190.0,
        829.921142578125,
        130.0
      ],
      [
        195.3977813720703,
        820.0,
        130.0
      ],
      [
        236.40264892578125,
        881.3681640625,
        140.0
      ],
      [
        236.40264892578125,
        881.3681640625,
        140.0
      ],
      [
        221.82235717773438,
        859.5471801757812,
        140.0
      ],
      [
        221.82235717773438,
        859.5471801757812,
        130.0
      ],
      [
        195.3977813720703,
        820.0,
        140.0
      ],
      [
        254.03262329101562,
        1000.0,
        192.38694763183594
      ],
      [
        254.03262329101562,
        980.0,
        192.38694763183594
      ],
      [
        254.03265380859375,
        1240.0,
        192.38693237304688
      ],
      [
        254.03262329101562,
        1000.0,
        192.38694763183594
      ],
      [
        254.03262329101562,
        980.0,
        192.38694763183594
      ],
      [
        254.03262329101562,
        980.0,
        340.0
      ],
      [
        210.0,
        841.853759765625,
        350.0
      ],
      [
        210.0,
        820.0,
        350.0
      ],
      [
        210.0,
        841.853759765625,
        370.0
      ],
      [
        210.0,
        841.853759765625,
        350.0
      ],
      [
        210.0,
        841.853759765625,
        230.0
      ],
      [
        210.0,
        820.0,
        230.0
      ],
      [
        210.0,
        841.853759765625,
        230.0
      ],
      [
        210.0,
        841.853759765625,
        210.0
      ],
      [
        224.19573974609375,
        820.0,
        280.0
      ],
      [
        210.0,
        841.853759765625,
        280.0
      ],
      [
        210.0,
        820.0,
        280.0
      ],
      [
        210.0,
        841.853759765625,
        300.0
      ],
      [
        210.0,
        841.853759765625,
        280.0
      ],
      [
        210.0,
        841.853759765625,
        160.0
      ],
      [
        210.0,
        820.0,
        160.0
      ],
      [
        210.0,
        841.853759765625,
        160.0
      ],
      [
        210.0,
        841.853759765625,
        140.0
      ],
      [
        0.0,
        1250.0,
        165.0
      ],
      [
        10.0,
        1265.0,
        165.0
      ],
      [
        0.0,
        1050.0,
        82.0
      ],
      [
        10.0,
        1050.0,
        82.0
      ],
      [
        0.0,
        1050.0,
        104.0
      ],
      [
        10.0,
        1050.0,
        104.0
      ],
      [
        0.0,
        1050.0,
        126.0
      ],
      [
        10.0,
        1050.0,
        126.0
      ],
      [
        110.0,
        949.7265625,
        175.0
      ],
      [
        84.7259750366211,
        901.519287109375,
        175.0
      ],
      [
        110.0,
        957.7964477539062,
        175.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        2637.3291015625,
        4583.6513671875,
        610.11962890625
      ],
      "bbox_max": [
        6532.3798828125,
        7186.23974609375,
        2025.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        4547.47998046875,
        4834.6591796875,
        1135.405029296875
      ],
      "bbox_max": [
        6430.5654296875,
        6601.240234375,
        1974.9913330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        5764.48095703125,
        4834.6591796875,
        1469.62939453125
      ],
      "bbox_max": [
        6430.5654296875,
        5140.50634765625,
        1974.9913330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2274780273438,
      "bbox_min": [
        5957.56005859375,
        4834.6591796875,
        1590.8251953125
      ],
      "bbox_max": [
        6430.5654296875,
        5140.50634765625,
        1974.9913330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4106284976005554,
        0.01650269143283367,
        0.9116533994674683
      ],
      "plane_d": 760.2809448242188,
      "bbox_min": [
        6145.49169921875,
        4834.6591796875,
        1843.751220703125
      ],
      "bbox_max": [
        6430.5654296875,
        5140.50634765625,
        1974.9913330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4106284976005554,
        0.01650269143283367,
        0.9116533994674683
      ],
      "plane_d": 760.2809448242188,
      "bbox_min": [
        2637.3291015625,
        4583.6513671875,
        610.11962890625
      ],
      "bbox_max": [
        6532.3798828125,
        7186.23974609375,
        2025.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2274780273438,
      "bbox_min": [
        6000.23779296875,
        4904.69091796875,
        1686.8756103515625
      ],
      "bbox_max": [
        6145.49169921875,
        4991.369140625,
        1843.7510986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        2637.3291015625,
        6834.52880859375,
        610.11962890625
      ],
      "bbox_max": [
        3163.701416015625,
        7186.23974609375,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        3014.04736328125,
        6834.52880859375,
        610.11962890625
      ],
      "bbox_max": [
        3163.701416015625,
        7183.8857421875,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -4110.0,
        -5240.431640625,
        -500.0
      ],
      "bbox_max": [
        7986.5068359375,
        7700.0,
        2700.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.1585269570350647,
        -0.2054760754108429,
        0.9657374024391174
      ],
      "plane_d": 128.0882568359375,
      "bbox_min": [
        3977.8642578125,
        -2830.98681640625,
        0.0
      ],
      "bbox_max": [
        7986.5068359375,
        6290.52294921875,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1284712553024292,
        -0.3080694079399109,
        0.9426496624946594
      ],
      "plane_d": 160.421142578125,
      "bbox_min": [
        3977.8642578125,
        1225.50634765625,
        0.0
      ],
      "bbox_max": [
        7986.5068359375,
        6290.52294921875,
        1909.3966064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2274780273438,
      "bbox_min": [
        3977.8642578125,
        1715.807373046875,
        0.0
      ],
      "bbox_max": [
        6281.5830078125,
        6290.52294921875,
        1909.3966064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4106284976005554,
        0.01650269143283367,
        0.9116533994674683
      ],
      "plane_d": 760.2809448242188,
      "bbox_min": [
        4089.31982421875,
        1715.807373046875,
        911.6276245117188
      ],
      "bbox_max": [
        6281.5830078125,
        4904.69091796875,
        1909.3966064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        4089.31982421875,
        1715.807373046875,
        911.6276245117188
      ],
      "bbox_max": [
        4157.6171875,
        3150.14306640625,
        991.8312377929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        4089.31982421875,
        2887.374755859375,
        938.4326782226562
      ],
      "bbox_max": [
        4157.6171875,
        3150.14306640625,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        4096.705078125,
        2092.76416015625,
        959.0196533203125
      ],
      "bbox_max": [
        4157.6171875,
        3150.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        4118.2841796875,
        2092.76416015625,
        985.7462768554688
      ],
      "bbox_max": [
        4137.6171875,
        2280.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8271484375,
      "bbox_min": [
        4117.16162109375,
        2269.442626953125,
        1016.0430908203125
      ],
      "bbox_max": [
        4137.6171875,
        2301.583251953125,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        4118.24951171875,
        2269.442626953125,
        1019.1718139648438
      ],
      "bbox_max": [
        4137.6171875,
        2280.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3977.8642578125,
        3098.861328125,
        0.0
      ],
      "bbox_max": [
        5957.56005859375,
        6290.52294921875,
        1590.8251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3977.8642578125,
        3098.861328125,
        0.0
      ],
      "bbox_max": [
        5764.48095703125,
        6290.52294921875,
        1469.6295166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3977.8642578125,
        5037.267578125,
        101.1990737915039
      ],
      "bbox_max": [
        4547.47998046875,
        6290.52294921875,
        1135.4051513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6274019479751587,
        0.7507457733154297,
        0.20675456523895264
      ],
      "plane_d": -431.48779296875,
      "bbox_min": [
        4059.008056640625,
        3098.861328125,
        0.0
      ],
      "bbox_max": [
        4237.6171875,
        4116.14306640625,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        4087.392822265625,
        3098.861328125,
        933.0609741210938
      ],
      "bbox_max": [
        4157.6171875,
        3154.043701171875,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.023681640625,
      "bbox_min": [
        4278.67626953125,
        -2830.98681640625,
        1461.146240234375
      ],
      "bbox_max": [
        7550.0,
        4751.228515625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        140.185791015625,
        4760.92822265625,
        -300.0
      ],
      "bbox_max": [
        4031.279296875,
        7196.82421875,
        919.177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        140.185791015625,
        4858.1806640625,
        -300.0
      ],
      "bbox_max": [
        3966.75,
        5035.24365234375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        3017.69189453125,
        4882.0908203125,
        -13.693603515625
      ],
      "bbox_max": [
        4000.44775390625,
        6932.08935546875,
        638.5988159179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3045.157470703125,
        4947.60009765625,
        -13.693603515625
      ],
      "bbox_max": [
        3970.173828125,
        5034.5224609375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3970.173828125,
        4949.3115234375,
        0.0
      ],
      "bbox_max": [
        4000.44775390625,
        4979.27001953125,
        32.464378356933594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3970.173828125,
        4949.3115234375,
        0.0
      ],
      "bbox_max": [
        4000.44775390625,
        4954.3212890625,
        24.79587745666504
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3970.173828125,
        4882.0908203125,
        0.0
      ],
      "bbox_max": [
        3999.89697265625,
        4951.876953125,
        23.07600212097168
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        235.99966430664062,
        4760.92822265625,
        -36.837890625
      ],
      "bbox_max": [
        4031.279296875,
        6830.2890625,
        919.177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3170.046875,
        5048.34375,
        54.11029052734375
      ],
      "bbox_max": [
        4020.44775390625,
        6830.2890625,
        919.177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3956.206787109375,
        4760.92822265625,
        0.0
      ],
      "bbox_max": [
        4031.279296875,
        5071.1044921875,
        123.28400421142578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3956.206787109375,
        4954.3212890625,
        24.79583168029785
      ],
      "bbox_max": [
        4024.458251953125,
        5071.1044921875,
        123.28400421142578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3986.6806640625,
        4954.3212890625,
        24.79583168029785
      ],
      "bbox_max": [
        4024.458251953125,
        5037.267578125,
        101.1990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.023681640625,
      "bbox_min": [
        2200.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        4296.39453125,
        -2050.0,
        1946.677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        2200.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6274019479751587,
        0.7507457733154297,
        0.20675456523895264
      ],
      "plane_d": -431.48779296875,
      "bbox_min": [
        3317.77783203125,
        3319.888916015625,
        0.0
      ],
      "bbox_max": [
        4059.62060546875,
        3966.878662109375,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8271484375,
      "bbox_min": [
        2878.090087890625,
        1339.7322998046875,
        100.0
      ],
      "bbox_max": [
        4150.75,
        3861.65869140625,
        1019.3637084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        2917.732666015625,
        1339.7322998046875,
        100.0
      ],
      "bbox_max": [
        4150.75,
        3861.65869140625,
        1019.3637084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6274019479751587,
        0.7507457733154297,
        0.20675456523895264
      ],
      "plane_d": -431.48779296875,
      "bbox_min": [
        2917.732666015625,
        1339.7322998046875,
        100.0
      ],
      "bbox_max": [
        4150.75,
        3861.65869140625,
        911.6276245117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        2917.732666015625,
        1339.7322998046875,
        228.48062133789062
      ],
      "bbox_max": [
        4150.75,
        1985.22265625,
        911.6276245117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1585269570350647,
        -0.2054760754108429,
        0.9657374024391174
      ],
      "plane_d": 128.0882568359375,
      "bbox_min": [
        4137.6171875,
        1339.7322998046875,
        831.6990966796875
      ],
      "bbox_max": [
        4150.75,
        1715.807373046875,
        911.6276245117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1284712553024292,
        -0.3080694079399109,
        0.9426496624946594
      ],
      "plane_d": 160.421142578125,
      "bbox_min": [
        4137.6171875,
        1339.7322998046875,
        831.6990966796875
      ],
      "bbox_max": [
        4150.75,
        1343.3211669921875,
        834.5104370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        2878.090087890625,
        1830.0,
        137.21926879882812
      ],
      "bbox_max": [
        4117.16162109375,
        3200.0,
        1016.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        2878.090087890625,
        1830.0,
        137.21926879882812
      ],
      "bbox_max": [
        3260.0,
        3200.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        2889.345947265625,
        1830.0,
        170.32931518554688
      ],
      "bbox_max": [
        3240.0,
        2798.10986328125,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        2780.0,
        2676.666748046875,
        80.0
      ],
      "bbox_max": [
        2814.28564453125,
        3107.142822265625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        2780.0,
        3033.157958984375,
        80.0
      ],
      "bbox_max": [
        2814.28564453125,
        3107.142822265625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        2780.0,
        1830.0,
        100.0
      ],
      "bbox_max": [
        2923.153076171875,
        3120.435546875,
        239.58474731445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        2804.21044921875,
        2798.10986328125,
        100.0
      ],
      "bbox_max": [
        2889.345947265625,
        3120.435546875,
        170.32931518554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.60302734375,
      "bbox_min": [
        -3833.671875,
        -5072.0185546875,
        1040.098388671875
      ],
      "bbox_max": [
        -2147.99658203125,
        -4327.0185546875,
        1390.1221923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5844033360481262,
        0.7305042147636414,
        0.35332190990448
      ],
      "plane_d": 957.4642333984375,
      "bbox_min": [
        -3080.0,
        -3623.86962890625,
        -300.0
      ],
      "bbox_max": [
        -1016.7769165039062,
        -2346.006103515625,
        1659.98291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7519490718841553,
        0.5784223675727844,
        0.31622791290283203
      ],
      "plane_d": 266.113037109375,
      "bbox_min": [
        -1791.9246826171875,
        -2671.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2556.84375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7519490718841553,
        0.5784223675727844,
        0.31622791290283203
      ],
      "plane_d": 266.113037109375,
      "bbox_min": [
        -1806.8819580078125,
        -2671.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1502.348388671875,
        -2346.006103515625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3364546000957489,
        0.8870165944099426,
        0.31622767448425293
      ],
      "plane_d": 1797.4375,
      "bbox_min": [
        -1806.8819580078125,
        -2671.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2599.128662109375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4769039750099182,
        0.7969357371330261,
        0.37075066566467285
      ],
      "plane_d": 1317.8309326171875,
      "bbox_min": [
        -3080.0,
        -3623.86962890625,
        -300.0
      ],
      "bbox_max": [
        -1016.7769165039062,
        -2604.802001953125,
        1659.98291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5160083770751953,
        0.7518967390060425,
        0.41034960746765137
      ],
      "plane_d": 1040.8974609375,
      "bbox_min": [
        -2100.0,
        -3623.86962890625,
        -300.0
      ],
      "bbox_max": [
        -1550.0,
        -2604.802001953125,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3364546000957489,
        0.8870165944099426,
        0.31622767448425293
      ],
      "plane_d": 1797.4375,
      "bbox_min": [
        -1850.0902099609375,
        -2671.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2604.802001953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -3080.0,
        -3580.0,
        -300.0
      ],
      "bbox_max": [
        -1016.7769165039062,
        -2621.19140625,
        1659.98291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3364546000957489,
        0.8870165944099426,
        0.31622767448425293
      ],
      "plane_d": 1797.4375,
      "bbox_min": [
        -2861.24462890625,
        -3111.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2621.19140625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3080.0,
        -3580.0,
        0.0
      ],
      "bbox_max": [
        -1016.7769165039062,
        -2798.138916015625,
        1659.98291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1074.7418212890625,
        -2950.0,
        1382.2545166015625
      ],
      "bbox_max": [
        -1016.7769165039062,
        -2798.138916015625,
        1659.98291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -1576.8857421875,
        -3700.0,
        -300.0
      ],
      "bbox_max": [
        2200.0,
        -747.3431396484375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -1576.8857421875,
        -3700.0,
        -300.0
      ],
      "bbox_max": [
        400.0,
        -1978.615966796875,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1576.8857421875,
        -2850.33056640625,
        -300.0
      ],
      "bbox_max": [
        -825.0,
        -1978.615966796875,
        1702.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320768237113953,
        0.5631359815597534,
        0.38332945108413696
      ],
      "plane_d": 259.0802001953125,
      "bbox_min": [
        -1576.8857421875,
        -2798.138916015625,
        -300.0
      ],
      "bbox_max": [
        -1074.7418212890625,
        -1978.615966796875,
        1382.2545166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7519490718841553,
        0.5784223675727844,
        0.31622791290283203
      ],
      "plane_d": 266.113037109375,
      "bbox_min": [
        -1576.8857421875,
        -2413.1201171875,
        -300.0
      ],
      "bbox_max": [
        -1201.24462890625,
        -1978.615966796875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        -1185.6846923828125,
        -2834.78271484375,
        -300.0
      ],
      "bbox_max": [
        2200.0,
        -747.3431396484375,
        1830.86083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -1185.6846923828125,
        -2500.0,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -747.3431396484375,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -1185.6846923828125,
        -2500.0,
        -300.0
      ],
      "bbox_max": [
        0.0,
        -1127.742431640625,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29317936301231384,
        0.9022449254989624,
        0.31622767448425293
      ],
      "plane_d": 1075.9822998046875,
      "bbox_min": [
        -1185.6846923828125,
        -1476.3109130859375,
        -300.0
      ],
      "bbox_max": [
        -279.618896484375,
        -1127.742431640625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14309725165367126,
        0.2930086553096771,
        0.9453407526016235
      ],
      "plane_d": 323.03399658203125,
      "bbox_min": [
        -551.24462890625,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -747.3431396484375,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4163157343864441,
        0.8524560332298279,
        0.3162277638912201
      ],
      "plane_d": 939.8093872070312,
      "bbox_min": [
        -551.24462890625,
        -1371.68505859375,
        -300.0
      ],
      "bbox_max": [
        502.19775390625,
        -747.3431396484375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4163157343864441,
        0.8524560332298279,
        0.3162277638912201
      ],
      "plane_d": 939.8093872070312,
      "bbox_min": [
        64.31683349609375,
        -1133.334716796875,
        -264.3855895996094
      ],
      "bbox_max": [
        571.793701171875,
        -759.136474609375,
        96.11875915527344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14309725165367126,
        0.2930086553096771,
        0.9453407526016235
      ],
      "plane_d": 323.03399658203125,
      "bbox_min": [
        64.31683349609375,
        -1133.334716796875,
        0.0
      ],
      "bbox_max": [
        571.793701171875,
        -846.68505859375,
        96.11875915527344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -2700.0,
      "bbox_min": [
        -150.0,
        -300.0,
        2200.0
      ],
      "bbox_max": [
        3400.0,
        1180.0,
        0.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 415.5232849121094,
      "bbox_min": [
        28.08397674560547,
        1512.0,
        -300.0
      ],
      "bbox_max": [
        438.0,
        2511.107177734375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7888013124465942,
        0.5270602107048035,
        0.3162277936935425
      ],
      "plane_d": -754.0639038085938,
      "bbox_min": [
        28.08397674560547,
        1512.0,
        -300.0
      ],
      "bbox_max": [
        208.00323486328125,
        1814.0926513671875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9304545521736145,
        0.1850789338350296,
        0.3162277638912201
      ],
      "plane_d": -177.34805297851562,
      "bbox_min": [
        28.08397674560547,
        1512.0,
        -300.0
      ],
      "bbox_max": [
        133.8159942626953,
        1669.9857177734375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -2700.0,
        -150.0,
        0.0
      ],
      "bbox_max": [
        2200.0,
        3400.0,
        1180.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 279.9999694824219,
      "bbox_min": [
        -471.8027038574219,
        245.45787048339844,
        60.0
      ],
      "bbox_max": [
        350.0,
        600.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        -471.8027038574219,
        249.4182586669922,
        60.0
      ],
      "bbox_max": [
        -280.0,
        575.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        -390.0,
        415.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        575.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        -390.0,
        415.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        480.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 354.9999694824219,
      "bbox_min": [
        -390.0,
        415.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        -390.0,
        460.0,
        60.0
      ],
      "bbox_max": [
        -355.0,
        460.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        -315.0,
        460.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 354.9999694824219,
      "bbox_min": [
        -390.0,
        419.3478088378906,
        80.0
      ],
      "bbox_max": [
        -280.0,
        462.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        -390.0,
        435.0,
        80.0
      ],
      "bbox_max": [
        -355.0,
        462.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 380.0,
      "bbox_min": [
        -380.0,
        435.0,
        80.0
      ],
      "bbox_max": [
        -365.0,
        455.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -435.0,
      "bbox_min": [
        -380.0,
        435.0,
        80.0
      ],
      "bbox_max": [
        -365.0,
        435.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -462.0,
      "bbox_min": [
        -365.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -360.0,
        462.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -360.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -360.0,
        462.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -435.0,
      "bbox_min": [
        -305.0,
        435.0,
        80.0
      ],
      "bbox_max": [
        -280.0,
        462.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        -290.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -280.0,
        462.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -462.0,
      "bbox_min": [
        -290.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -285.0,
        462.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 285.0,
      "bbox_min": [
        -285.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -285.0,
        462.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        -390.0,
        480.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        575.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -390.0,
        530.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        575.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9771763682365417,
        0.21242964267730713
      ],
      "plane_d": -574.6221923828125,
      "bbox_min": [
        -390.0,
        570.6521606445312,
        60.0
      ],
      "bbox_max": [
        -355.0,
        575.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": -360.55517578125,
      "bbox_min": [
        -355.0,
        530.0,
        60.0
      ],
      "bbox_max": [
        -280.0,
        575.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -355.0,
        530.0,
        60.0
      ],
      "bbox_max": [
        -315.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        -355.0,
        530.0,
        78.0
      ],
      "bbox_max": [
        -345.0,
        530.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        -325.0,
        530.0,
        78.0
      ],
      "bbox_max": [
        -315.0,
        530.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9771763682365417,
        0.21242964267730713
      ],
      "plane_d": -574.6221923828125,
      "bbox_min": [
        -315.0,
        570.6521606445312,
        60.0
      ],
      "bbox_max": [
        -280.0,
        575.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -390.0,
        530.0,
        80.0
      ],
      "bbox_max": [
        -280.0,
        570.6521606445312,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9771763682365417,
        0.21242964267730713
      ],
      "plane_d": -574.6221923828125,
      "bbox_min": [
        -390.0,
        566.3043212890625,
        80.0
      ],
      "bbox_max": [
        -355.0,
        570.6521606445312,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9771763682365417,
        0.21242964267730713
      ],
      "plane_d": -574.6221923828125,
      "bbox_min": [
        -315.0,
        566.3043212890625,
        80.0
      ],
      "bbox_max": [
        -280.0,
        570.6521606445312,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        -280.0,
        245.45787048339844,
        60.0
      ],
      "bbox_max": [
        350.0,
        600.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        -280.0,
        245.45787048339844,
        60.0
      ],
      "bbox_max": [
        350.0,
        520.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -438.2693176269531,
      "bbox_min": [
        -280.0,
        270.0,
        60.0
      ],
      "bbox_max": [
        300.0,
        500.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": -205.71824645996094,
      "bbox_min": [
        -200.0,
        270.0,
        60.0
      ],
      "bbox_max": [
        -190.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        -280.0,
        500.0,
        78.0
      ],
      "bbox_max": [
        40.0,
        500.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        -1854.4622802734375,
        98.42288208007812,
        100.0
      ],
      "bbox_max": [
        310.0,
        690.0,
        420.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        -200.0,
        280.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        690.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -200.0,
        280.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        470.0,
        381.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -247.48736572265625,
      "bbox_min": [
        -200.0,
        450.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        470.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        -190.0,
        280.0,
        140.0
      ],
      "bbox_max": [
        -190.0,
        440.0,
        381.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -100.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -100.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        420.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        -100.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        420.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -100.0,
        650.0,
        280.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        420.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        254.0325927734375,
        650.0,
        350.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        254.0325927734375,
        650.0,
        280.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        -100.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        280.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        254.0325927734375,
        650.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        254.0325927734375,
        650.0,
        230.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 279.9999694824219,
      "bbox_min": [
        -1854.4622802734375,
        98.42288208007812,
        100.0
      ],
      "bbox_max": [
        -200.0,
        640.0,
        200.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -565.0,
      "bbox_min": [
        -390.0,
        423.6956481933594,
        100.0
      ],
      "bbox_max": [
        -280.0,
        566.3043212890625,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -116.0,
      "bbox_min": [
        -390.0,
        423.6956481933594,
        100.0
      ],
      "bbox_max": [
        -280.0,
        565.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        -390.0,
        423.6956481933594,
        100.0
      ],
      "bbox_max": [
        -280.0,
        565.0,
        116.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -435.0,
      "bbox_min": [
        -305.0,
        435.0,
        100.0
      ],
      "bbox_max": [
        -290.0,
        435.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -360.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        -355.0,
        565.0,
        106.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -360.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        -360.0,
        462.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        -390.0,
        435.0,
        116.0
      ],
      "bbox_max": [
        -280.0,
        565.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -435.0,
      "bbox_min": [
        -305.0,
        435.0,
        116.0
      ],
      "bbox_max": [
        -290.0,
        435.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -355.0,
        530.0,
        116.0
      ],
      "bbox_max": [
        -355.0,
        565.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9771763682365417,
        0.21242964267730713
      ],
      "plane_d": -574.6221923828125,
      "bbox_min": [
        -390.0,
        565.0,
        100.0
      ],
      "bbox_max": [
        -280.0,
        566.3043212890625,
        106.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -355.0,
        565.0,
        100.0
      ],
      "bbox_max": [
        -355.0,
        566.3043212890625,
        106.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 435.0,
      "bbox_min": [
        -1692.0,
        435.0,
        140.0
      ],
      "bbox_max": [
        -280.0,
        565.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -555.0,
      "bbox_min": [
        -1692.0,
        435.0,
        140.0
      ],
      "bbox_max": [
        -280.0,
        565.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        -410.0,
        435.0,
        140.0
      ],
      "bbox_max": [
        -280.0,
        555.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        -410.0,
        435.0,
        140.0
      ],
      "bbox_max": [
        -280.0,
        480.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        -410.0,
        435.0,
        140.0
      ],
      "bbox_max": [
        -285.0,
        455.0,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 305.0,
      "bbox_min": [
        -305.0,
        435.0,
        140.0
      ],
      "bbox_max": [
        -305.0,
        440.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -385.0,
        440.0,
        145.0
      ],
      "bbox_max": [
        -285.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 380.0,
      "bbox_min": [
        -385.0,
        440.0,
        145.0
      ],
      "bbox_max": [
        -360.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -455.0,
      "bbox_min": [
        -385.0,
        455.0,
        145.0
      ],
      "bbox_max": [
        -380.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -455.0,
      "bbox_min": [
        -365.0,
        455.0,
        145.0
      ],
      "bbox_max": [
        -360.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 305.0,
      "bbox_min": [
        -310.0,
        440.0,
        145.0
      ],
      "bbox_max": [
        -285.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -455.0,
      "bbox_min": [
        -310.0,
        455.0,
        145.0
      ],
      "bbox_max": [
        -305.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -455.0,
      "bbox_min": [
        -290.0,
        455.0,
        145.0
      ],
      "bbox_max": [
        -285.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284767508506775,
        0.371390700340271
      ],
      "plane_d": -576.5840454101562,
      "bbox_min": [
        -390.0,
        555.0,
        140.0
      ],
      "bbox_max": [
        -280.0,
        565.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -355.0,
        555.0,
        140.0
      ],
      "bbox_max": [
        -355.0,
        565.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -210.0,
      "bbox_min": [
        -280.0,
        280.0,
        110.0
      ],
      "bbox_max": [
        -200.0,
        555.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -210.0,
        280.0,
        110.0
      ],
      "bbox_max": [
        -200.0,
        470.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        -210.0,
        460.0,
        110.0
      ],
      "bbox_max": [
        -200.0,
        470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -247.48736572265625,
      "bbox_min": [
        -210.0,
        460.0,
        110.0
      ],
      "bbox_max": [
        -200.0,
        470.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7893522381782532,
        0.6139406561851501,
        0.0
      ],
      "plane_d": -119.71844482421875,
      "bbox_min": [
        -280.0,
        435.0,
        140.0
      ],
      "bbox_max": [
        -245.0,
        555.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        -280.0,
        435.0,
        140.0
      ],
      "bbox_max": [
        -245.0,
        555.0,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 245.0,
      "bbox_min": [
        -245.0,
        480.0,
        140.0
      ],
      "bbox_max": [
        -245.0,
        510.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1645.0,
        1469.9998779296875,
        370.0
      ],
      "bbox_max": [
        2091.7158203125,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1645.0,
        1470.0,
        370.0
      ],
      "bbox_max": [
        1971.7369384765625,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1910.0,
        1805.0001220703125,
        1060.0
      ],
      "bbox_max": [
        1971.7369384765625,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1805.0001220703125,
        1060.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1940.0999755859375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1910.0,
        1805.0001220703125,
        1060.0
      ],
      "bbox_max": [
        1917.9425048828125,
        1812.9427490234375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        1645.0,
        1654.800048828125,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1660.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1910.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1885.0001220703125,
        1831.2440185546875,
        1130.0
      ],
      "bbox_max": [
        1910.0,
        1881.243408203125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1843.8228759765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1708.26318359375,
        1843.8228759765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1668.9998779296875,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1704.19970703125,
        1865.1998291015625,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        8.719300694792764e-07,
        0.0
      ],
      "plane_d": 1659.9984130859375,
      "bbox_min": [
        1658.9056396484375,
        1654.800048828125,
        1059.6480712890625
      ],
      "bbox_max": [
        1910.0,
        1830.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1659.9998779296875,
        1654.800048828125,
        1059.6480712890625
      ],
      "bbox_max": [
        1910.0,
        1830.0,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1660.0,
        1760.0,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1830.0,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1892.9425048828125,
        1812.9425048828125,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1830.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.355224609375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1658.9056396484375,
        1767.4713134765625,
        1130.0
      ],
      "bbox_max": [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9617391228675842,
        0.19130180776119232,
        0.1961161196231842
      ],
      "plane_d": -183.31097412109375,
      "bbox_min": [
        110.15185546875,
        1500.0,
        0.0
      ],
      "bbox_max": [
        190.0,
        1715.052978515625,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8153231143951416,
        0.5447813868522644,
        0.1961159110069275
      ],
      "plane_d": -779.4175415039062,
      "bbox_min": [
        133.8159942626953,
        1626.2855224609375,
        0.0
      ],
      "bbox_max": [
        190.0,
        1715.052978515625,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8153231143951416,
        0.5447813868522644,
        0.1961159110069275
      ],
      "plane_d": -779.4175415039062,
      "bbox_min": [
        190.0,
        1693.45361328125,
        0.0
      ],
      "bbox_max": [
        216.65475463867188,
        1741.9967041015625,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        -625.0554809570312,
        690.0,
        60.0
      ],
      "bbox_max": [
        1645.0,
        2778.15673828125,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1830.0,
      "bbox_min": [
        1010.0,
        880.0,
        60.0
      ],
      "bbox_max": [
        1645.0,
        2050.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1010.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1390.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        -0.4999992549419403,
        0.7071068286895752
      ],
      "plane_d": 959.9496459960938,
      "bbox_min": [
        1350.0,
        910.7692260742188,
        80.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1390.0,
        777.8890380859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1350.0,
        910.7692260742188,
        80.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1390.0,
        700.1072387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1400.0,
        1270.0,
        490.0
      ],
      "bbox_max": [
        1520.0,
        1390.0,
        700.1072387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1350.0,
        910.7692260742188,
        80.0
      ],
      "bbox_max": [
        1380.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1010.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1350.0,
        1310.0,
        515.0852661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1174.9146728515625,
        1310.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1310.0,
        515.0852661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1010.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1350.0,
        1110.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665761947631836,
      "bbox_min": [
        1018.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1350.0,
        980.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1018.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1350.0,
        960.7692260742188,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1010.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1029.5867919921875,
        1090.0,
        369.672119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665761947631836,
      "bbox_min": [
        1010.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1029.5867919921875,
        1090.0,
        369.672119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1010.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1018.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1010.0,
        960.0,
        130.0
      ],
      "bbox_max": [
        1020.0,
        1090.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1029.1378173828125,
        949.1378173828125,
        369.22308349609375
      ],
      "bbox_max": [
        1175.0,
        1380.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1075.0,
        1310.0,
        515.0
      ],
      "bbox_max": [
        1075.0,
        1380.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        1029.1378173828125,
        949.1378173828125,
        369.22308349609375
      ],
      "bbox_max": [
        1174.9146728515625,
        1300.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1029.640380859375,
        965.0,
        369.7255859375
      ],
      "bbox_max": [
        1174.9146728515625,
        1300.0,
        796.2268676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1045.0,
      "bbox_min": [
        1029.640380859375,
        965.0,
        369.7255859375
      ],
      "bbox_max": [
        1061.14208984375,
        1085.0,
        796.2268676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1496.945068359375,
      "bbox_min": [
        1045.0,
        978.013916015625,
        750.0
      ],
      "bbox_max": [
        1061.14208984375,
        1072.0,
        795.8037719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7077255845069885,
        0.7064874172210693,
        0.0
      ],
      "plane_d": 48.61865234375,
      "bbox_min": [
        1045.0,
        978.013916015625,
        750.0
      ],
      "bbox_max": [
        1061.0999755859375,
        994.1422119140625,
        795.7902221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1496.945068359375,
      "bbox_min": [
        1029.640380859375,
        970.0,
        369.7255859375
      ],
      "bbox_max": [
        1045.0,
        1074.050048828125,
        796.2268676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7077255845069885,
        0.7064874172210693,
        0.0
      ],
      "plane_d": 48.61865234375,
      "bbox_min": [
        1029.640380859375,
        970.0,
        369.7255859375
      ],
      "bbox_max": [
        1045.0,
        979.9147338867188,
        796.2144165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665761947631836,
      "bbox_min": [
        1029.640380859375,
        970.0,
        369.7255859375
      ],
      "bbox_max": [
        1039.9146728515625,
        979.9147338867188,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1029.1378173828125,
        949.1378173828125,
        369.22308349609375
      ],
      "bbox_max": [
        1044.56787109375,
        1300.0,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1496.945068359375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1044.56787109375,
        1080.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7077255845069885,
        0.7064874172210693,
        0.0
      ],
      "plane_d": 48.61865234375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1044.5675048828125,
        977.5806884765625,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1029.1378173828125,
        949.1378173828125,
        369.22308349609375
      ],
      "bbox_max": [
        1034.7249755859375,
        1300.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1029.1378173828125,
        949.1378173828125,
        369.22308349609375
      ],
      "bbox_max": [
        1030.0,
        1100.4130859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665761947631836,
      "bbox_min": [
        1029.5867919921875,
        969.9998779296875,
        369.6720275878906
      ],
      "bbox_max": [
        1030.0,
        970.0513305664062,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1029.1378173828125,
        949.1378173828125,
        369.22308349609375
      ],
      "bbox_max": [
        1030.0,
        970.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665761947631836,
      "bbox_min": [
        1029.1378173828125,
        969.5689086914062,
        369.22308349609375
      ],
      "bbox_max": [
        1030.0,
        970.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        1010.0,
        1390.0,
        350.0852355957031
      ],
      "bbox_max": [
        1645.0,
        1550.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1549.9998779296875,
        1390.0,
        500.0
      ],
      "bbox_max": [
        1645.0,
        1508.2841796875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2162.533447265625,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        500.0
      ],
      "bbox_max": [
        1588.2841796875,
        1508.2841796875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        -0.4999992549419403,
        0.7071068286895752
      ],
      "plane_d": 959.9496459960938,
      "bbox_min": [
        1549.9998779296875,
        1390.0,
        721.3203735351562
      ],
      "bbox_max": [
        1630.0,
        1400.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999999701976776,
        -0.5000001788139343,
        0.7071067094802856
      ],
      "plane_d": 959.94970703125,
      "bbox_min": [
        1350.0,
        1390.0,
        490.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1550.0,
        784.9600830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1520.0,
        1390.0,
        490.0
      ],
      "bbox_max": [
        1530.0,
        1400.0,
        714.2493896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1010.0,
        1390.0,
        350.0852355957031
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1174.9146728515625,
        1470.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1470.0,
        515.0852661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1075.0,
        1470.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1075.0,
        1470.0,
        515.0
      ],
      "bbox_max": [
        1075.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        1057.5947265625,
        1550.0,
        303.5163879394531
      ],
      "bbox_max": [
        1550.0,
        1830.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.707106351852417,
        0.0,
        0.7071071863174438
      ],
      "plane_d": 533.21337890625,
      "bbox_min": [
        1057.5947265625,
        1610.0,
        303.5163879394531
      ],
      "bbox_max": [
        1083.078369140625,
        1710.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1550.0,
        1830.0,
        140.0
      ],
      "bbox_max": [
        1550.0,
        1910.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1550.0,
        1910.0,
        140.0
      ],
      "bbox_max": [
        1588.2843017578125,
        2050.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -326.482421875,
      "bbox_min": [
        1550.0001220703125,
        2011.7158203125,
        140.0
      ],
      "bbox_max": [
        1588.2843017578125,
        2050.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -500.0,
        690.0,
        120.0
      ],
      "bbox_max": [
        -50.0,
        820.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        -500.0,
        690.0,
        120.0
      ],
      "bbox_max": [
        -50.0,
        770.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -500.0,
        690.0,
        140.0
      ],
      "bbox_max": [
        -50.0,
        700.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        -450.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        -50.0,
        770.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -450.0,
        770.0,
        120.0
      ],
      "bbox_max": [
        -50.0,
        770.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        -50.0,
        690.0,
        60.0
      ],
      "bbox_max": [
        800.0,
        820.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        740.0,
        701.7157592773438,
        60.0
      ],
      "bbox_max": [
        800.0,
        820.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        760.0,
        730.0,
        60.0
      ],
      "bbox_max": [
        800.0,
        820.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        820.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        740.0,
        726.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        820.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        750.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        820.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        -50.0,
        690.0,
        120.0
      ],
      "bbox_max": [
        254.03260803222656,
        820.0,
        370.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -50.0,
        690.0,
        120.0
      ],
      "bbox_max": [
        254.03260803222656,
        820.0,
        230.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        64.73006439208984,
        713.5973510742188,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555700063705444,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -565.204833984375,
      "bbox_min": [
        64.73006439208984,
        723.0171508789062,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        169.20310974121094,
        780.796875,
        120.0
      ],
      "bbox_max": [
        183.72076416015625,
        802.5241088867188,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -303.1000061035156,
      "bbox_min": [
        161.99351501464844,
        788.0064697265625,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        183.72076416015625,
        802.5241088867188,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        169.20310974121094,
        780.796875,
        140.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        68.63186645507812,
        713.5973510742188,
        210.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        169.20310974121094,
        780.796875,
        210.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -50.0,
        690.0,
        280.0
      ],
      "bbox_max": [
        254.03260803222656,
        820.0,
        370.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        68.63186645507812,
        713.5973510742188,
        350.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        169.20310974121094,
        780.796875,
        350.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        -50.0,
        690.0,
        280.0
      ],
      "bbox_max": [
        250.98464965820312,
        820.0,
        300.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        68.63186645507812,
        713.5973510742188,
        280.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        169.20310974121094,
        780.796875,
        280.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        1010.0,
        1570.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        1010.0,
        1570.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        1010.0,
        1570.0,
        110.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        820.0,
        1540.0,
        64.44444274902344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": 17.91067123413086,
      "bbox_min": [
        780.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        820.0,
        1530.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        720.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        720.0,
        926.6382446289062,
        60.0
      ],
      "bbox_max": [
        730.0,
        930.0,
        66.72349548339844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        820.0,
        1570.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1450.0,
        64.44444274902344
      ],
      "bbox_max": [
        820.0,
        1540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        720.0,
        960.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1453.3616943359375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        737.914794921875,
        960.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        820.0,
        80.0
      ],
      "bbox_max": [
        960.0,
        1540.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        820.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        930.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 472.2575988769531,
      "bbox_min": [
        836.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        836.0,
        950.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -949.9999389648438,
      "bbox_min": [
        836.0,
        950.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        777.914794921875,
        820.0,
        110.0
      ],
      "bbox_max": [
        1008.2842407226562,
        1540.0,
        220.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        779.9147338867188,
        820.0,
        110.0
      ],
      "bbox_max": [
        986.2361450195312,
        930.0,
        200.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        820.0,
        110.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.21319580078125,
      "bbox_min": [
        886.0660400390625,
        856.0660400390625,
        118.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        819.914794921875,
        910.0,
        160.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        779.9147338867188,
        930.0,
        110.0
      ],
      "bbox_max": [
        1000.0,
        950.0,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 472.2575988769531,
      "bbox_min": [
        820.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        836.0,
        950.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        859.914794921875,
        930.0,
        200.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        820.0,
        950.0,
        110.0
      ],
      "bbox_max": [
        1000.0,
        1540.0,
        205.08523559570312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 330.9380798339844,
      "bbox_min": [
        860.0,
        950.0,
        110.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        950.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        970.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 860.0,
      "bbox_min": [
        860.0,
        970.5,
        110.0
      ],
      "bbox_max": [
        870.0,
        980.5,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.5,
      "bbox_min": [
        860.0,
        970.5,
        110.0
      ],
      "bbox_max": [
        870.0,
        970.5,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        829.914794921875,
        968.6068725585938,
        120.0
      ],
      "bbox_max": [
        922.2498779296875,
        1121.3931884765625,
        205.08523559570312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.5,
      "bbox_min": [
        829.914794921875,
        968.6068725585938,
        120.0
      ],
      "bbox_max": [
        870.0,
        1121.3931884765625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 860.0,
      "bbox_min": [
        829.914794921875,
        970.5,
        120.0
      ],
      "bbox_max": [
        865.0,
        1121.3931884765625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -741.3171997070312,
      "bbox_min": [
        860.0,
        970.5,
        170.0
      ],
      "bbox_max": [
        865.0,
        1121.3931884765625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        860.0,
        970.5,
        170.0
      ],
      "bbox_max": [
        860.0140991210938,
        970.50537109375,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        829.914794921875,
        970.50537109375,
        170.0
      ],
      "bbox_max": [
        860.0,
        1119.4947509765625,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -741.3171997070312,
      "bbox_min": [
        829.914794921875,
        1108.071533203125,
        170.0
      ],
      "bbox_max": [
        860.0,
        1119.4947509765625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        860.0140991210938,
        968.6068725585938,
        170.0
      ],
      "bbox_max": [
        865.0,
        970.5,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -741.3171997070312,
      "bbox_min": [
        849.914794921875,
        1115.6654052734375,
        190.0
      ],
      "bbox_max": [
        865.0,
        1121.3931884765625,
        205.085205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        849.914794921875,
        968.6068725585938,
        190.0
      ],
      "bbox_max": [
        865.0,
        974.3346557617188,
        205.085205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        -0.4117816090583801,
        -0.0
      ],
      "plane_d": 1143.894287109375,
      "bbox_min": [
        735.6064453125,
        820.0,
        80.0
      ],
      "bbox_max": [
        879.9147338867188,
        1121.3931884765625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        807.7501220703125,
        910.0,
        166.0657958984375
      ],
      "bbox_max": [
        879.9147338867188,
        1121.3931884765625,
        600.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -741.3171997070312,
      "bbox_min": [
        807.7501220703125,
        974.3346557617188,
        170.0
      ],
      "bbox_max": [
        872.0,
        1121.3931884765625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.354968398809433,
        -0.9348783493041992,
        0.0
      ],
      "plane_d": 1222.5772705078125,
      "bbox_min": [
        807.7501220703125,
        974.3346557617188,
        190.0
      ],
      "bbox_max": [
        872.0,
        1009.0,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 858.0,
      "bbox_min": [
        858.0,
        995.0,
        365.0
      ],
      "bbox_max": [
        872.0,
        1009.0,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1009.0,
      "bbox_min": [
        858.0,
        1009.0,
        365.0
      ],
      "bbox_max": [
        872.0,
        1009.0,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -189.99998474121094,
      "bbox_min": [
        807.7501220703125,
        974.3346557617188,
        190.0
      ],
      "bbox_max": [
        849.914794921875,
        998.2267456054688,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        825.9805908203125,
        910.0,
        166.0657958984375
      ],
      "bbox_max": [
        879.9147338867188,
        950.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        825.9806518554688,
        910.0,
        200.0
      ],
      "bbox_max": [
        859.914794921875,
        950.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        735.6064453125,
        820.0,
        80.0
      ],
      "bbox_max": [
        844.055419921875,
        950.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        760.0,
        820.0,
        118.0
      ],
      "bbox_max": [
        844.055419921875,
        950.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        760.0,
        950.0,
        118.0
      ],
      "bbox_max": [
        779.914794921875,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        760.0,
        910.0,
        140.0
      ],
      "bbox_max": [
        844.055419921875,
        950.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        760.0,
        910.0,
        160.0
      ],
      "bbox_max": [
        819.914794921875,
        950.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        735.6064453125,
        940.0,
        80.0
      ],
      "bbox_max": [
        739.914794921875,
        949.5344848632812,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        920.0,
        60.0851936340332
      ],
      "bbox_max": [
        739.914794921875,
        1560.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        720.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        739.914794921875,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        720.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        730.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        720.0,
        2260.0,
        240.0
      ],
      "bbox_max": [
        800.0,
        2350.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 1301.7037353515625,
      "bbox_min": [
        450.0,
        1040.0,
        60.0
      ],
      "bbox_max": [
        680.0,
        1460.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        -0.3090174198150635,
        0.0
      ],
      "plane_d": 882.6156005859375,
      "bbox_min": [
        450.0,
        1185.6285400390625,
        60.0
      ],
      "bbox_max": [
        680.0,
        1460.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        0.3090174198150635,
        0.0
      ],
      "plane_d": 88.44082641601562,
      "bbox_min": [
        500.0,
        1185.6285400390625,
        60.0
      ],
      "bbox_max": [
        680.0,
        1460.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        0.8090178370475769,
        0.0
      ],
      "plane_d": -777.47216796875,
      "bbox_min": [
        530.4696044921875,
        1185.6285400390625,
        60.0
      ],
      "bbox_max": [
        680.0,
        1460.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 627.7926025390625,
      "bbox_min": [
        582.7122802734375,
        1185.6285400390625,
        60.0
      ],
      "bbox_max": [
        680.0,
        1455.0550537109375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        60.0
      ],
      "bbox_max": [
        680.0,
        1455.0550537109375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        631.7507934570312,
        1420.0,
        60.0
      ],
      "bbox_max": [
        680.0,
        1455.0550537109375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        631.7507934570312,
        1420.0,
        60.0
      ],
      "bbox_max": [
        680.0,
        1455.0550537109375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        673.0423583984375,
        1450.0,
        60.0
      ],
      "bbox_max": [
        680.0,
        1455.0550537109375,
        70.11000061035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        582.7122802734375,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        602.2073974609375,
        1185.6285400390625,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        535.7269287109375,
        1362.5953369140625,
        60.0
      ],
      "bbox_max": [
        680.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        535.7269287109375,
        1362.5953369140625,
        78.0
      ],
      "bbox_max": [
        659.2786254882812,
        1440.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        554.3788452148438,
        1420.0,
        78.0
      ],
      "bbox_max": [
        631.7508544921875,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9994449019432068,
        0.03331482782959938
      ],
      "plane_d": 1371.5716552734375,
      "bbox_min": [
        500.0,
        1285.0,
        60.0
      ],
      "bbox_max": [
        567.3756713867188,
        1460.0,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993628263473511,
        0.0,
        0.035691533237695694
      ],
      "plane_d": 506.8197326660156,
      "bbox_min": [
        500.0,
        1375.0,
        60.0
      ],
      "bbox_max": [
        567.3756713867188,
        1460.0,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        509.28570556640625,
        1375.0,
        60.0
      ],
      "bbox_max": [
        567.3756713867188,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        509.9285583496094,
        1375.0,
        78.0
      ],
      "bbox_max": [
        554.3788452148438,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        510.0,
        1375.0,
        80.0
      ],
      "bbox_max": [
        547.8804931640625,
        1400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        500.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        510.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        521.9630737304688,
        1352.5953369140625,
        80.0
      ],
      "bbox_max": [
        539.7575073242188,
        1375.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506506085395813,
        0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": 34.38273620605469,
      "bbox_min": [
        500.0,
        1285.0,
        80.0
      ],
      "bbox_max": [
        510.5146179199219,
        1301.1802978515625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        450.0,
        1040.0,
        120.0
      ],
      "bbox_max": [
        680.0,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        450.0,
        1040.0,
        190.0
      ],
      "bbox_max": [
        680.0,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        450.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        680.0,
        1040.0,
        330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        450.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        680.0,
        1040.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        450.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        680.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        450.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        680.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        450.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        680.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        600.1320190429688,
        920.0,
        80.0
      ],
      "bbox_max": [
        680.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 979.9999389648438,
      "bbox_min": [
        450.0,
        980.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        980.0,
        330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        680.0,
        1040.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        1460.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        680.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        680.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        680.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        680.0,
        1040.0,
        190.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        680.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        1040.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        680.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        1040.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        680.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        680.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29667383432388306,
        0.0,
        0.954978883266449
      ],
      "plane_d": 97.84910583496094,
      "bbox_min": [
        685.8578491210938,
        960.0,
        110.60659790039062
      ],
      "bbox_max": [
        700.0,
        980.0,
        115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        680.0,
        920.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        980.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7371524572372437,
        -0.6757264733314514,
        0.0
      ],
      "plane_d": 1031.923828125,
      "bbox_min": [
        505.0,
        2100.0,
        180.0
      ],
      "bbox_max": [
        552.6314086914062,
        2130.0,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2805706262588501,
        -0.9598334431648254,
        0.0
      ],
      "plane_d": 1873.962158203125,
      "bbox_min": [
        505.0,
        2100.0,
        180.0
      ],
      "bbox_max": [
        532.5,
        2108.03857421875,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        680.0,
        2260.0,
        240.0
      ],
      "bbox_max": [
        720.0,
        2350.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -625.0554809570312,
        820.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        2540.0,
        640.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        -595.0115356445312,
        1430.0,
        60.0
      ],
      "bbox_max": [
        0.0,
        1490.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9700985550880432,
        -0.2427113950252533,
        0.0
      ],
      "plane_d": 924.297119140625,
      "bbox_min": [
        -595.0115356445312,
        1430.0,
        60.0
      ],
      "bbox_max": [
        -580.0,
        1490.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -50.843994140625,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1250.4873046875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -50.843994140625,
        1250.0,
        120.0
      ],
      "bbox_max": [
        -50.0,
        1250.4873046875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -249.99998474121094,
      "bbox_min": [
        -500.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1211.7012939453125,
        540.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 309.5,
      "bbox_min": [
        -500.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1211.7012939453125,
        250.00003051757812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -339.5,
      "bbox_min": [
        -500.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -339.5,
        820.0,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        250.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        -339.5,
        820.0,
        60.0
      ],
      "bbox_max": [
        -309.5,
        850.556396484375,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -339.5,
        820.0,
        140.0
      ],
      "bbox_max": [
        -309.5,
        830.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 544.861328125,
      "bbox_min": [
        -339.5,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -309.5,
        850.556396484375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        -339.5,
        1040.0,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        250.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -339.5,
        1050.0,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -339.5,
        1050.0,
        205.0
      ],
      "bbox_max": [
        -309.5,
        1100.6649169921875,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -339.5,
        1050.0,
        205.0
      ],
      "bbox_max": [
        -309.5,
        1100.6649169921875,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -339.5,
        1050.0,
        205.0
      ],
      "bbox_max": [
        -309.5,
        1053.0,
        225.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -330.0,
        1050.0,
        205.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        -330.0,
        1050.0,
        205.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -330.0,
        1050.0,
        205.0
      ],
      "bbox_max": [
        -330.0,
        1051.800048828125,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        205.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -332.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        205.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        205.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575021624565125,
        0.5144803524017334
      ],
      "plane_d": -1013.5630493164062,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        215.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        205.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        205.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        205.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575021624565125,
        0.5144803524017334
      ],
      "plane_d": -1013.5630493164062,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        215.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -339.5,
        1050.0,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -339.5,
        1050.0,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -330.0,
        1050.0,
        75.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 85.0,
      "bbox_min": [
        -330.0,
        1050.0,
        75.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -330.0,
        1050.0,
        75.0
      ],
      "bbox_max": [
        -330.0,
        1051.800048828125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -339.02734375,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -332.0,
      "bbox_min": [
        -339.02734375,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -318.0,
        1057.8154296875,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575021624565125,
        0.5144803524017334
      ],
      "plane_d": -946.6806030273438,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        85.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575021624565125,
        0.5144803524017334
      ],
      "plane_d": -946.6806030273438,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        85.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -76.0,
      "bbox_min": [
        -339.02734375,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7746033668518066,
        -0.4471936821937561,
        -0.44722193479537964
      ],
      "plane_d": 765.14208984375,
      "bbox_min": [
        -337.8636474609375,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -912.150634765625,
      "bbox_min": [
        -337.8636474609375,
        1055.800048828125,
        75.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745686173439026,
        0.44724565744400024,
        -0.44723013043403625
      ],
      "plane_d": -179.21800231933594,
      "bbox_min": [
        -335.824951171875,
        1055.800048828125,
        75.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        -0.7070940732955933,
        0.0
      ],
      "plane_d": 984.6046752929688,
      "bbox_min": [
        -338.37939453125,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -508.52301025390625,
      "bbox_min": [
        -338.37939453125,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -226.1374969482422,
      "bbox_min": [
        -338.37939453125,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -336.6470947265625,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.489622978416264e-09,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -594.5062866210938,
      "bbox_min": [
        -338.37939453125,
        1055.80712890625,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -508.52301025390625,
      "bbox_min": [
        -338.308837890625,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 478.4278869628906,
      "bbox_min": [
        -338.308837890625,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -334.9853515625,
        1055.80712890625,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": 115.78661346435547,
      "bbox_min": [
        -336.6470947265625,
        1054.1455078125,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.6800537109375,
      "bbox_min": [
        -315.62744140625,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 313.5,
      "bbox_min": [
        -314.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        78.33777618408203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -314.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -313.5,
        1098.3555908203125,
        78.33777618408203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -314.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -313.5,
        1098.3555908203125,
        78.33777618408203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1100.646484375,
      "bbox_min": [
        -309.53204345703125,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -309.53204345703125,
        1100.646484375,
        78.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -912.150634765625,
      "bbox_min": [
        -315.62744140625,
        1055.800048828125,
        75.0
      ],
      "bbox_max": [
        -312.1363525390625,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745679020881653,
        0.4472414255142212,
        -0.4472355842590332
      ],
      "plane_d": -682.6824951171875,
      "bbox_min": [
        -315.62744140625,
        1055.800048828125,
        75.0
      ],
      "bbox_max": [
        -314.175048828125,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -524.9769897460938,
      "bbox_min": [
        -315.0853271484375,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -968.1423950195312,
      "bbox_min": [
        -315.0853271484375,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -311.691162109375,
        1057.53955078125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 478.40325927734375,
      "bbox_min": [
        -315.0146484375,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -311.691162109375,
        1055.80712890625,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.010574648156762123,
        0.861408531665802
      ],
      "plane_d": -214.28509521484375,
      "bbox_min": [
        -315.0853271484375,
        1054.1455078125,
        76.0
      ],
      "bbox_max": [
        -313.3529052734375,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -968.1423950195312,
      "bbox_min": [
        -315.0853271484375,
        1055.80712890625,
        76.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -594.5062866210938,
      "bbox_min": [
        -315.0853271484375,
        1055.80712890625,
        76.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -335.0,
        1040.0,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1050.0,
        250.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 335.0,
      "bbox_min": [
        -335.0,
        1040.0,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1050.0,
        250.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -335.0,
        1040.0,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1050.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        -500.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -500.0,
        820.0,
        140.0
      ],
      "bbox_max": [
        -339.5,
        830.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 544.861328125,
      "bbox_min": [
        -371.0469970703125,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289903402328491,
        0.5592629313468933,
        -0.0
      ],
      "plane_d": -306.7905578613281,
      "bbox_min": [
        -354.81549072265625,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        225.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -354.81549072265625,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -354.81549072265625,
        1051.800048828125,
        205.0
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -354.81549072265625,
        1051.800048828125,
        225.0
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -354.81549072265625,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        -309.5,
        820.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1211.7012939453125,
        250.00003051757812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -309.5,
        820.0,
        140.0
      ],
      "bbox_max": [
        -50.0,
        830.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -309.5,
        830.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1211.7012939453125,
        250.00003051757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        -160.0,
        830.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1211.7012939453125,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        -160.0,
        890.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1211.7012939453125,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -160.0,
        1050.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1211.7012939453125,
        155.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.6122786402702332,
        -0.3534996807575226,
        0.7072148323059082
      ],
      "plane_d": 419.9613342285156,
      "bbox_min": [
        -160.0,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -86.40599060058594,
        1211.7012939453125,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122788786888123,
        0.35349905490875244,
        0.7072149515151978
      ],
      "plane_d": -399.02593994140625,
      "bbox_min": [
        -160.0,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -86.40599060058594,
        1211.7012939453125,
        133.48248291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -160.0,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -128.13587951660156,
        1194.198974609375,
        121.88594818115234
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7069985866546631,
        0.7072149515151978
      ],
      "plane_d": 719.5504150390625,
      "bbox_min": [
        -160.0,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -132.9530029296875,
        1097.7781982421875,
        93.41925811767578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.7781982421875,
      "bbox_min": [
        -160.0,
        1097.7781982421875,
        80.0
      ],
      "bbox_max": [
        -144.5,
        1097.7781982421875,
        93.41925811767578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.545535147190094,
        0.8380879163742065,
        0.0
      ],
      "plane_d": -1037.0234375,
      "bbox_min": [
        -160.0,
        1133.2198486328125,
        95.0
      ],
      "bbox_max": [
        -128.13587951660156,
        1178.3775634765625,
        121.88594818115234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1134.84228515625,
      "bbox_min": [
        -160.0,
        1153.508544921875,
        95.0
      ],
      "bbox_max": [
        -128.13587951660156,
        1178.3775634765625,
        121.88594818115234
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826940953731537,
        -0.923875093460083,
        0.0
      ],
      "plane_d": 1139.25146484375,
      "bbox_min": [
        -155.54116821289062,
        1168.6934814453125,
        95.0
      ],
      "bbox_max": [
        -153.6934356689453,
        1171.3065185546875,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238695502281189,
        0.3827075958251953,
        -0.0
      ],
      "plane_d": -305.568115234375,
      "bbox_min": [
        -155.54116821289062,
        1168.6934814453125,
        95.0
      ],
      "bbox_max": [
        -153.6934356689453,
        1171.3065185546875,
        106.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826913833618164,
        0.9238762259483337,
        0.0
      ],
      "plane_d": -1140.2523193359375,
      "bbox_min": [
        -155.54116821289062,
        1168.6934814453125,
        95.0
      ],
      "bbox_max": [
        -153.6934356689453,
        1171.3065185546875,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        -155.0,
        1170.0,
        105.0
      ],
      "bbox_max": [
        -154.07611083984375,
        1171.3065185546875,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -155.0,
        1170.0,
        105.0
      ],
      "bbox_max": [
        -154.0761260986328,
        1171.3065185546875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1027.03369140625,
      "bbox_min": [
        -160.0,
        1170.0,
        95.0
      ],
      "bbox_max": [
        -154.45880126953125,
        1178.3775634765625,
        113.95943450927734
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38270488381385803,
        0.9238706231117249,
        0.0
      ],
      "plane_d": -1148.9014892578125,
      "bbox_min": [
        -159.23541259765625,
        1176.5299072265625,
        95.0
      ],
      "bbox_max": [
        -156.62240600585938,
        1178.3775634765625,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238695502281189,
        0.3827075660228729,
        0.0
      ],
      "plane_d": -305.5682678222656,
      "bbox_min": [
        -159.23541259765625,
        1176.5299072265625,
        95.0
      ],
      "bbox_max": [
        -156.62240600585938,
        1178.3775634765625,
        106.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826913833618164,
        -0.9238762259483337,
        0.0
      ],
      "plane_d": 1147.906005859375,
      "bbox_min": [
        -159.23541259765625,
        1176.5299072265625,
        95.0
      ],
      "bbox_max": [
        -156.62240600585938,
        1178.3775634765625,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        -159.23541259765625,
        1177.071044921875,
        106.0
      ],
      "bbox_max": [
        -157.00506591796875,
        1178.3775634765625,
        106.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        -157.92892456054688,
        1176.5299072265625,
        106.0
      ],
      "bbox_max": [
        -156.62240600585938,
        1177.4537353515625,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -0.0
      ],
      "plane_d": -304.5385437011719,
      "bbox_min": [
        -157.92892456054688,
        1170.0,
        105.0
      ],
      "bbox_max": [
        -154.45880126953125,
        1177.071044921875,
        113.59385681152344
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -157.92892456054688,
        1170.0,
        105.0
      ],
      "bbox_max": [
        -154.45880126953125,
        1177.071044921875,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        -157.92892456054688,
        1170.0,
        105.0
      ],
      "bbox_max": [
        -154.45880126953125,
        1177.071044921875,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -2.5911433112923987e-05
      ],
      "plane_d": -305.53582763671875,
      "bbox_min": [
        -156.62240600585938,
        1171.3065185546875,
        105.0
      ],
      "bbox_max": [
        -154.45880126953125,
        1176.5299072265625,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.978369414806366,
        0.20686548948287964,
        0.0
      ],
      "plane_d": -365.4665832519531,
      "bbox_min": [
        -129.64987182617188,
        1153.508544921875,
        95.0
      ],
      "bbox_max": [
        -128.13587951660156,
        1160.6689453125,
        96.54955291748047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4038896858692169,
        -0.26290363073349,
        -0.8762161731719971
      ],
      "plane_d": 365.4664001464844,
      "bbox_min": [
        -160.0,
        1158.39990234375,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1200.363037109375,
        133.48248291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1027.03369140625,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        112.59514617919922
      ],
      "bbox_max": [
        -151.9368133544922,
        1190.3486328125,
        133.48248291015625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -157.92892456054688,
        1176.7674560546875,
        131.0
      ],
      "bbox_max": [
        -157.68597412109375,
        1177.071044921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -590.941162109375,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        113.59385681152344
      ],
      "bbox_max": [
        -155.0,
        1170.0,
        125.55592346191406
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1134.84228515625,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        119.66397857666016
      ],
      "bbox_max": [
        -157.92892456054688,
        1162.928955078125,
        125.55592346191406
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660251498222351,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 674.0302734375,
      "bbox_min": [
        -160.0,
        1097.7781982421875,
        80.0
      ],
      "bbox_max": [
        -109.5,
        1196.012939453125,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.545535147190094,
        0.8380879163742065,
        0.0
      ],
      "plane_d": -1037.0234375,
      "bbox_min": [
        -160.0,
        1097.7781982421875,
        80.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1196.012939453125,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.7781982421875,
      "bbox_min": [
        -160.0,
        1097.7781982421875,
        80.0
      ],
      "bbox_max": [
        -144.5,
        1097.7781982421875,
        155.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1134.84228515625,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        133.07298278808594
      ],
      "bbox_max": [
        -155.0,
        1177.928955078125,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 304.5385437011719,
      "bbox_min": [
        -160.0,
        1170.0,
        135.45352172851562
      ],
      "bbox_max": [
        -155.0,
        1177.928955078125,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1027.03369140625,
      "bbox_min": [
        -160.0,
        1177.071044921875,
        139.5917510986328
      ],
      "bbox_max": [
        -157.92892456054688,
        1177.928955078125,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.978369414806366,
        0.20686548948287964,
        0.0
      ],
      "plane_d": -365.4665832519531,
      "bbox_min": [
        -160.0,
        1152.6546630859375,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1196.012939453125,
        140.60861206054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6006801724433899,
        0.12700723111629486,
        -0.7893367409706116
      ],
      "plane_d": -129.66162109375,
      "bbox_min": [
        -160.0,
        1152.6546630859375,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1196.012939453125,
        140.60861206054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4038896858692169,
        -0.26290363073349,
        -0.8762161731719971
      ],
      "plane_d": 365.4664001464844,
      "bbox_min": [
        -160.0,
        1152.6546630859375,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1196.012939453125,
        140.60861206054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 304.5385437011719,
      "bbox_min": [
        -160.0,
        1172.9346923828125,
        136.71969604492188
      ],
      "bbox_max": [
        -156.21560668945312,
        1177.928955078125,
        140.60861206054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1027.03369140625,
      "bbox_min": [
        -160.0,
        1177.071044921875,
        136.71969604492188
      ],
      "bbox_max": [
        -157.92892456054688,
        1177.928955078125,
        140.60861206054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380875587463379,
        -0.5455357432365417,
        0.0
      ],
      "plane_d": 540.175537109375,
      "bbox_min": [
        -160.0,
        1152.6546630859375,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1196.012939453125,
        137.4169464111328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -160.0,
        1152.6546630859375,
        95.0
      ],
      "bbox_max": [
        -129.64987182617188,
        1186.9283447265625,
        137.4169464111328
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -590.941162109375,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        131.0
      ],
      "bbox_max": [
        -155.0,
        1177.928955078125,
        137.4169464111328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 304.5385437011719,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        131.0
      ],
      "bbox_max": [
        -155.0,
        1177.928955078125,
        137.4169464111328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1134.84228515625,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        131.0
      ],
      "bbox_max": [
        -157.92892456054688,
        1162.928955078125,
        133.2989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 590.941162109375,
      "bbox_min": [
        -160.0,
        1152.6546630859375,
        95.0
      ],
      "bbox_max": [
        -129.64987182617188,
        1176.7674560546875,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        -0.0
      ],
      "plane_d": 304.5385437011719,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        124.19163513183594
      ],
      "bbox_max": [
        -155.0,
        1176.7674560546875,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1134.84228515625,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        124.19163513183594
      ],
      "bbox_max": [
        -157.92892456054688,
        1162.928955078125,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.7781982421875,
      "bbox_min": [
        -160.0,
        1097.7781982421875,
        155.0
      ],
      "bbox_max": [
        -144.5,
        1177.928955078125,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 304.5385437011719,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        155.0
      ],
      "bbox_max": [
        -155.0,
        1177.928955078125,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -590.941162109375,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        155.0
      ],
      "bbox_max": [
        -155.0,
        1177.928955078125,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1027.03369140625,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        155.0
      ],
      "bbox_max": [
        -157.92892456054688,
        1177.928955078125,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1134.84228515625,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        155.0
      ],
      "bbox_max": [
        -157.92892456054688,
        1162.928955078125,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -160.0,
        1050.0,
        155.0
      ],
      "bbox_max": [
        -100.0,
        1050.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        -160.0,
        840.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        1177.928955078125,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        -110.0,
        920.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        1158.39990234375,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -110.0,
        920.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        920.0,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660251498222351,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 674.0302734375,
      "bbox_min": [
        -110.0,
        1157.533935546875,
        230.0
      ],
      "bbox_max": [
        -109.5,
        1158.39990234375,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660251498222351,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 674.0302734375,
      "bbox_min": [
        -160.0,
        840.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1177.928955078125,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.7781982421875,
      "bbox_min": [
        -160.0,
        1097.7781982421875,
        230.0
      ],
      "bbox_max": [
        -144.5,
        1177.928955078125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 304.5385437011719,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        230.0
      ],
      "bbox_max": [
        -155.0,
        1177.928955078125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -590.941162109375,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        230.0
      ],
      "bbox_max": [
        -155.0,
        1177.928955078125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1027.03369140625,
      "bbox_min": [
        -160.0,
        1162.071044921875,
        230.0
      ],
      "bbox_max": [
        -157.92892456054688,
        1177.928955078125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -160.0,
        840.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1040.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        -150.0,
        840.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1040.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -150.0,
        1040.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1040.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        -150.0,
        840.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        880.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        -150.0,
        840.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        840.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -942.0,
      "bbox_min": [
        -160.0,
        942.0,
        230.0
      ],
      "bbox_max": [
        -150.0,
        942.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        -160.0,
        840.0,
        240.0
      ],
      "bbox_max": [
        -110.0,
        942.0,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -942.0,
      "bbox_min": [
        -160.0,
        942.0,
        240.0
      ],
      "bbox_max": [
        -150.0,
        942.0,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999403953552,
        -0.866025447845459,
        0.0
      ],
      "plane_d": 1077.9537353515625,
      "bbox_min": [
        -309.5,
        830.556396484375,
        60.0
      ],
      "bbox_max": [
        -160.0,
        1186.9788818359375,
        250.00003051757812
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1027.03369140625,
      "bbox_min": [
        -309.5,
        1066.0238037109375,
        75.0
      ],
      "bbox_max": [
        -160.0,
        1186.9788818359375,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -169.12681579589844,
        1177.928955078125,
        95.0
      ],
      "bbox_max": [
        -160.0,
        1186.9788818359375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -169.12673950195312,
        1177.928955078125,
        131.0
      ],
      "bbox_max": [
        -160.0,
        1186.978759765625,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826856315135956,
        0.9238786101341248,
        -0.0
      ],
      "plane_d": -1008.5560302734375,
      "bbox_min": [
        -309.5,
        1066.0238037109375,
        75.0
      ],
      "bbox_max": [
        -160.0,
        1181.70947265625,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -309.5,
        1066.0238037109375,
        75.0
      ],
      "bbox_max": [
        -160.0,
        1170.064208984375,
        225.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4038896858692169,
        0.26290363073349,
        -0.8762161731719971
      ],
      "plane_d": -111.8018569946289,
      "bbox_min": [
        -309.5,
        1066.0238037109375,
        120.0
      ],
      "bbox_max": [
        -160.0,
        1170.064208984375,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 283.12530517578125,
      "bbox_min": [
        -309.5,
        1066.0238037109375,
        205.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1101.0794677734375,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -309.5,
        1066.0238037109375,
        205.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1101.0794677734375,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -309.5,
        1066.0238037109375,
        205.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1101.0794677734375,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -199.3573760986328,
        1130.9688720703125,
        120.0
      ],
      "bbox_max": [
        -160.0,
        1170.064208984375,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.26290392875671387,
        0.40389078855514526,
        -0.8762155771255493
      ],
      "plane_d": -394.6158142089844,
      "bbox_min": [
        -199.3573760986328,
        1130.9688720703125,
        120.0
      ],
      "bbox_max": [
        -160.0,
        1157.0836181640625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12700527906417847,
        0.6006799340248108,
        -0.7893372178077698
      ],
      "plane_d": -559.6082763671875,
      "bbox_min": [
        -199.3573760986328,
        1130.9688720703125,
        120.0
      ],
      "bbox_max": [
        -181.13681030273438,
        1142.37548828125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -309.5,
        1066.0238037109375,
        75.0
      ],
      "bbox_max": [
        -160.0,
        1170.064208984375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49999967217445374,
        -0.8660256266593933,
        0.0
      ],
      "plane_d": 1107.4539794921875,
      "bbox_min": [
        -309.5,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -160.0,
        1170.064208984375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -309.5,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -188.71461486816406,
        1170.064208984375,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1100.646484375,
      "bbox_min": [
        -309.5,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -240.61631774902344,
        1140.2772216796875,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380868434906006,
        -0.5455368757247925,
        -0.0
      ],
      "plane_d": 420.1769714355469,
      "bbox_min": [
        -240.8894805908203,
        1139.8575439453125,
        75.0
      ],
      "bbox_max": [
        -240.61631774902344,
        1140.2772216796875,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380868434906006,
        -0.5455368757247925,
        -0.0
      ],
      "plane_d": 420.1769714355469,
      "bbox_min": [
        -240.8894805908203,
        1139.8575439453125,
        78.0
      ],
      "bbox_max": [
        -240.61631774902344,
        1140.2772216796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -240.61631774902344,
        1115.0986328125,
        75.0
      ],
      "bbox_max": [
        -160.0,
        1169.822998046875,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5455361604690552,
        -0.838087260723114,
        0.0
      ],
      "plane_d": 1079.5657958984375,
      "bbox_min": [
        -240.61631774902344,
        1115.0986328125,
        75.0
      ],
      "bbox_max": [
        -203.4488983154297,
        1150.357666015625,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380868434906006,
        -0.5455368757247925,
        -0.0
      ],
      "plane_d": 420.1769714355469,
      "bbox_min": [
        -240.61631774902344,
        1133.9915771484375,
        75.0
      ],
      "bbox_max": [
        -236.79795837402344,
        1139.8575439453125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5455361604690552,
        0.838087260723114,
        0.0
      ],
      "plane_d": -1064.5228271484375,
      "bbox_min": [
        -228.59152221679688,
        1115.0986328125,
        75.0
      ],
      "bbox_max": [
        -203.4488983154297,
        1137.7503662109375,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380868434906006,
        -0.5455368757247925,
        0.0
      ],
      "plane_d": 420.17694091796875,
      "bbox_min": [
        -228.59152221679688,
        1115.0986328125,
        75.0
      ],
      "bbox_max": [
        -224.5,
        1121.38427734375,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5455361604690552,
        0.838087260723114,
        0.0
      ],
      "plane_d": -1057.0228271484375,
      "bbox_min": [
        -238.1999969482422,
        1115.0986328125,
        95.0
      ],
      "bbox_max": [
        -197.011962890625,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20686249434947968,
        0.9783700108528137,
        0.0
      ],
      "plane_d": -1065.7515869140625,
      "bbox_min": [
        -199.3573760986328,
        1130.9688720703125,
        95.0
      ],
      "bbox_max": [
        -197.011962890625,
        1131.4647216796875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1136.2679443359375,
      "bbox_min": [
        -238.1999969482422,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -222.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1139.7320556640625,
      "bbox_min": [
        -238.1999969482422,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551382422447205,
        0.5184000730514526,
        0.0
      ],
      "plane_d": -793.6332397460938,
      "bbox_min": [
        -238.1999969482422,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551382422447205,
        -0.5184000730514526,
        -0.0
      ],
      "plane_d": 386.245361328125,
      "bbox_min": [
        -238.1999969482422,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8551382422447205,
        0.5184000730514526,
        0.0
      ],
      "plane_d": -389.8369445800781,
      "bbox_min": [
        -235.0500030517578,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8551382422447205,
        -0.5184000730514526,
        0.0
      ],
      "plane_d": 790.0416259765625,
      "bbox_min": [
        -235.0500030517578,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1138.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1121.7320556640625,
      "bbox_min": [
        -225.14999389648438,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -222.0,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8551382422447205,
        0.5184000730514526,
        0.0
      ],
      "plane_d": -390.76739501953125,
      "bbox_min": [
        -223.0500030517578,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -222.0,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8551382422447205,
        -0.5184000730514526,
        0.0
      ],
      "plane_d": 770.4487915039062,
      "bbox_min": [
        -223.0500030517578,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -222.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1134.84228515625,
      "bbox_min": [
        -189.29701232910156,
        1157.9288330078125,
        95.0
      ],
      "bbox_max": [
        -160.0,
        1181.70947265625,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -165.00003051757812,
        1157.9288330078125,
        95.0
      ],
      "bbox_max": [
        -160.0,
        1162.071044921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -165.0,
        1157.928955078125,
        131.0
      ],
      "bbox_max": [
        -160.0,
        1162.071044921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1153.3199462890625,
      "bbox_min": [
        -189.29701232910156,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -160.0,
        1181.70947265625,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -189.29701232910156,
        1170.0,
        95.0
      ],
      "bbox_max": [
        -165.0,
        1181.70947265625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -189.29701232910156,
        1170.0,
        131.0
      ],
      "bbox_max": [
        -165.0,
        1181.70947265625,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 609.4187622070312,
      "bbox_min": [
        -189.14198303222656,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -160.0,
        1180.0001220703125,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -189.14198303222656,
        1165.0,
        95.0
      ],
      "bbox_max": [
        -172.07106018066406,
        1177.0711669921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -189.14198303222656,
        1165.0,
        131.0
      ],
      "bbox_max": [
        -172.07107543945312,
        1177.071044921875,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -0.0
      ],
      "plane_d": -286.0609436035156,
      "bbox_min": [
        -177.07106018066406,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -160.0,
        1180.0001220703125,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -175.00001525878906,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -160.0,
        1180.0001220703125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 675.9923706054688,
      "bbox_min": [
        -309.5,
        830.556396484375,
        60.0
      ],
      "bbox_max": [
        -160.0,
        1152.337646484375,
        250.00003051757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660255670547485,
        0.4999997019767761,
        -0.0
      ],
      "plane_d": -235.18533325195312,
      "bbox_min": [
        -309.5,
        830.556396484375,
        60.0
      ],
      "bbox_max": [
        -160.0,
        1152.337646484375,
        250.00003051757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -309.5,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -289.5,
        1006.4410400390625,
        250.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 544.861328125,
      "bbox_min": [
        -309.5,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -289.5,
        850.556396484375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -743.7392578125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        67.32662200927734
      ],
      "bbox_max": [
        -289.5,
        984.4795532226562,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        205.0
      ],
      "bbox_max": [
        -289.5000305175781,
        1006.4410400390625,
        210.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -210.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        205.0
      ],
      "bbox_max": [
        -289.5000305175781,
        974.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.0,
      "bbox_min": [
        -309.5,
        974.0,
        205.0
      ],
      "bbox_max": [
        -290.7701110839844,
        974.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.7781982421875,
      "bbox_min": [
        -309.5,
        911.17822265625,
        60.0
      ],
      "bbox_max": [
        -160.0,
        1152.337646484375,
        250.00003051757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660245537757874,
        -0.5000016093254089,
        0.0
      ],
      "plane_d": 363.12860107421875,
      "bbox_min": [
        -254.4998779296875,
        1097.7781982421875,
        67.32440948486328
      ],
      "bbox_max": [
        -160.0,
        1152.337646484375,
        250.00003051757812
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -197.011962890625,
        1125.61376953125,
        95.0
      ],
      "bbox_max": [
        -160.0,
        1152.337646484375,
        129.52923583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.545535147190094,
        0.8380879163742065,
        0.0
      ],
      "plane_d": -1037.0234375,
      "bbox_min": [
        -197.011962890625,
        1125.61376953125,
        95.0
      ],
      "bbox_max": [
        -160.0,
        1152.337646484375,
        129.52923583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26290392875671387,
        0.40389078855514526,
        -0.8762155771255493
      ],
      "plane_d": -394.6158142089844,
      "bbox_min": [
        -197.011962890625,
        1125.61376953125,
        120.0
      ],
      "bbox_max": [
        -160.0,
        1152.337646484375,
        129.52923583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12700527906417847,
        0.6006799340248108,
        -0.7893372178077698
      ],
      "plane_d": -559.6082763671875,
      "bbox_min": [
        -197.011962890625,
        1125.61376953125,
        120.0
      ],
      "bbox_max": [
        -171.68490600585938,
        1140.1343994140625,
        129.52923583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        -254.4998779296875,
        1097.7781982421875,
        67.32440948486328
      ],
      "bbox_max": [
        -214.49998474121094,
        1115.0986328125,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3534996807575226,
        -0.6122795343399048,
        0.7072141170501709
      ],
      "plane_d": 705.53564453125,
      "bbox_min": [
        -254.4998779296875,
        1097.7781982421875,
        67.32440948486328
      ],
      "bbox_max": [
        -214.5,
        1115.0986328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122781038284302,
        -0.3535004258155823,
        0.7072149515151978
      ],
      "plane_d": 200.15420532226562,
      "bbox_min": [
        -229.1409912109375,
        1097.7781982421875,
        67.32440948486328
      ],
      "bbox_max": [
        -214.5,
        1115.0986328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -254.4998779296875,
        1097.7781982421875,
        205.0
      ],
      "bbox_max": [
        -214.49998474121094,
        1115.0986328125,
        210.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -210.0,
      "bbox_min": [
        -226.2320556640625,
        1097.7781982421875,
        205.0
      ],
      "bbox_max": [
        -214.49998474121094,
        1115.0986328125,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642498254776001,
        -0.5030628442764282,
        -0.0
      ],
      "plane_d": 364.94061279296875,
      "bbox_min": [
        -226.2320556640625,
        1097.7781982421875,
        205.0
      ],
      "bbox_max": [
        -216.7322540283203,
        1114.0986328125,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        -309.5,
        911.17822265625,
        60.0
      ],
      "bbox_max": [
        -160.0,
        1097.7781982421875,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 162.27667236328125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        60.00611877441406
      ],
      "bbox_max": [
        -277.9530029296875,
        1011.800048828125,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3534996807575226,
        -0.6122795343399048,
        0.7072141170501709
      ],
      "plane_d": 705.53564453125,
      "bbox_min": [
        -254.4998779296875,
        1077.77587890625,
        60.003910064697266
      ],
      "bbox_max": [
        -214.5,
        1097.7781982421875,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -304.4938659667969,
        1068.9140625,
        80.00613403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -844.8052978515625,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -304.4938659667969,
        1059.2205810546875,
        80.00613403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3534996807575226,
        -0.6122795343399048,
        0.7072141170501709
      ],
      "plane_d": 705.53564453125,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -249.1448516845703,
        1097.7781982421875,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -304.4938659667969,
        1063.1390380859375,
        75.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        79.99991607666016
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -844.8052978515625,
      "bbox_min": [
        -300.1638488769531,
        1065.638916015625,
        75.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        79.99991607666016
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -844.8052978515625,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -304.4938659667969,
        1059.2205810546875,
        75.0
      ],
      "bbox_max": [
        -300.1638488769531,
        1065.638916015625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -289.5000305175781,
        971.800048828125,
        225.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241365432739,
        0.5000022053718567,
        -0.0
      ],
      "plane_d": -363.1293640136719,
      "bbox_min": [
        -214.49998474121094,
        1045.8167724609375,
        225.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960236549377,
        0.0
      ],
      "plane_d": 700.94775390625,
      "bbox_min": [
        -309.5,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -202.5,
      "bbox_min": [
        -309.5,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -289.5000305175781,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        202.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241365432739,
        0.5000022053718567,
        -0.0
      ],
      "plane_d": -363.1293640136719,
      "bbox_min": [
        -214.49998474121094,
        1045.8167724609375,
        200.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        202.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -210.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        225.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.852865993976593,
        0.5221298933029175,
        0.0
      ],
      "plane_d": -705.1233520507812,
      "bbox_min": [
        -309.5,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -231.8271484375,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -184.49986267089844,
        1047.5096435546875,
        210.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -231.8271484375,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -184.49986267089844,
        1047.5096435546875,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241365432739,
        0.5000022053718567,
        -0.0
      ],
      "plane_d": -363.1293640136719,
      "bbox_min": [
        -185.47727966308594,
        1045.8167724609375,
        202.5
      ],
      "bbox_max": [
        -184.49986267089844,
        1047.5096435546875,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241365432739,
        0.5000022053718567,
        -0.0
      ],
      "plane_d": -363.1293640136719,
      "bbox_min": [
        -185.47727966308594,
        1045.8167724609375,
        205.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1047.5096435546875,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -185.47727966308594,
        1097.7781982421875,
        210.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -252.9062042236328,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -185.47727966308594,
        1065.5634765625,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241365432739,
        0.5000022053718567,
        -0.0
      ],
      "plane_d": -363.1293640136719,
      "bbox_min": [
        -195.90069580078125,
        1047.5096435546875,
        202.5
      ],
      "bbox_max": [
        -185.47727966308594,
        1065.5634765625,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000013709068298,
        -0.8660246133804321,
        0.0
      ],
      "plane_d": 1057.9532470703125,
      "bbox_min": [
        -289.5000305175781,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -195.90069580078125,
        1097.7781982421875,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 289.5,
      "bbox_min": [
        -289.5000305175781,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -195.90069580078125,
        1097.7781982421875,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -991.800048828125,
      "bbox_min": [
        -289.5000305175781,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -195.90069580078125,
        1097.7781982421875,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -289.5000305175781,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -252.9062042236328,
        971.800048828125,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660241365432739,
        -0.5000022053718567,
        -0.0
      ],
      "plane_d": 343.12939453125,
      "bbox_min": [
        -289.5,
        1045.6845703125,
        202.5
      ],
      "bbox_max": [
        -195.90069580078125,
        1097.7781982421875,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241365432739,
        0.5000022053718567,
        -0.0
      ],
      "plane_d": -363.1293640136719,
      "bbox_min": [
        -214.49998474121094,
        1065.5634765625,
        202.5
      ],
      "bbox_max": [
        -195.90069580078125,
        1097.7781982421875,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289881944656372,
        -0.5592660903930664,
        0.0
      ],
      "plane_d": 824.8079833984375,
      "bbox_min": [
        -289.5,
        1045.6845703125,
        202.5
      ],
      "bbox_max": [
        -279.7840576171875,
        1060.0863037109375,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.0,
      "bbox_min": [
        -290.7701110839844,
        971.800048828125,
        205.0
      ],
      "bbox_max": [
        -185.47727966308594,
        1097.7781982421875,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -289.5000305175781,
        971.800048828125,
        205.0
      ],
      "bbox_max": [
        -231.8271484375,
        971.800048828125,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642498254776001,
        -0.5030628442764282,
        -0.0
      ],
      "plane_d": 364.94061279296875,
      "bbox_min": [
        -216.7322540283203,
        1045.8394775390625,
        205.0
      ],
      "bbox_max": [
        -185.47727966308594,
        1097.7781982421875,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241365432739,
        0.5000022053718567,
        -0.0
      ],
      "plane_d": -363.1293640136719,
      "bbox_min": [
        -214.49998474121094,
        1047.5096435546875,
        205.0
      ],
      "bbox_max": [
        -185.47727966308594,
        1097.7781982421875,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -289.5000305175781,
        971.800048828125,
        210.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660241365432739,
        0.5000022053718567,
        -0.0
      ],
      "plane_d": -363.1293640136719,
      "bbox_min": [
        -214.49998474121094,
        1045.8167724609375,
        210.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6123725175857544,
        -0.3535531461238861,
        0.7071068286895752
      ],
      "plane_d": 421.4258728027344,
      "bbox_min": [
        -301.0470275878906,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -231.40599060058594,
        931.1782836914062,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123726963996887,
        0.35355326533317566,
        0.7071065902709961
      ],
      "plane_d": -222.87403869628906,
      "bbox_min": [
        -301.0470275878906,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -231.40599060058594,
        931.1782836914062,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 544.861328125,
      "bbox_min": [
        -301.0470275878906,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -277.9530029296875,
        850.556396484375,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        8.239746966864914e-05
      ],
      "plane_d": 309.45880126953125,
      "bbox_min": [
        -354.81549072265625,
        830.0,
        249.99998474121094
      ],
      "bbox_max": [
        -100.0,
        1201.7012939453125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 309.5,
      "bbox_min": [
        -339.4935607910156,
        971.800048828125,
        249.99998474121094
      ],
      "bbox_max": [
        -309.4794006347656,
        1100.6759033203125,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -339.4935607910156,
        1040.0,
        250.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        422.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        -339.4935607910156,
        1040.0,
        250.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        422.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -339.4935607910156,
        1050.0,
        250.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -339.4810485839844,
        1050.0,
        250.0
      ],
      "bbox_max": [
        -309.5,
        1100.6649169921875,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -339.4810485839844,
        1050.0,
        250.0
      ],
      "bbox_max": [
        -309.5,
        1057.8154296875,
        270.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -330.0,
        1050.0,
        250.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        -330.0,
        1050.0,
        250.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -330.0,
        1050.0,
        250.0
      ],
      "bbox_max": [
        -330.0,
        1051.800048828125,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -845.8052368164062,
      "bbox_min": [
        -339.02734375,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -309.5,
        1057.8154296875,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5592275261878967,
        -0.829014241695404,
        0.0
      ],
      "plane_d": 698.8762817382812,
      "bbox_min": [
        -310.3289794921875,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -309.5,
        1052.3592529296875,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -339.02734375,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        262.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        262.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        262.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575021624565125,
        0.5144803524017334
      ],
      "plane_d": -1036.7147216796875,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        260.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        262.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -251.0,
      "bbox_min": [
        -315.62744140625,
        1053.784423828125,
        250.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745887041091919,
        -0.4471992552280426,
        -0.44724172353744507
      ],
      "plane_d": 339.9292297363281,
      "bbox_min": [
        -315.62744140625,
        1053.784423828125,
        250.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        251.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745960354804993,
        -0.44720351696014404,
        -0.4472247362136841
      ],
      "plane_d": 825.2890625,
      "bbox_min": [
        -315.62744140625,
        1053.784423828125,
        250.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        251.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -833.8882446289062,
      "bbox_min": [
        -315.62744140625,
        1055.800048828125,
        250.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        251.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745679020881653,
        0.4472414255142212,
        -0.4472355842590332
      ],
      "plane_d": -604.416259765625,
      "bbox_min": [
        -315.62744140625,
        1055.800048828125,
        250.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        251.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745699286460876,
        0.4472425878047943,
        -0.44723090529441833
      ],
      "plane_d": -119.07372283935547,
      "bbox_min": [
        -312.425048828125,
        1055.800048828125,
        250.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        251.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -524.9769897460938,
      "bbox_min": [
        -315.0853271484375,
        1054.145263671875,
        251.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        260.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -968.1423950195312,
      "bbox_min": [
        -315.0853271484375,
        1054.145263671875,
        251.0
      ],
      "bbox_max": [
        -311.691162109375,
        1057.53955078125,
        260.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 328.459716796875,
      "bbox_min": [
        -315.0146484375,
        1054.145263671875,
        251.0
      ],
      "bbox_max": [
        -311.691162109375,
        1055.80712890625,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.010574648156762123,
        0.861408531665802
      ],
      "plane_d": -365.0315856933594,
      "bbox_min": [
        -315.0853271484375,
        1054.1455078125,
        251.0
      ],
      "bbox_max": [
        -313.3529052734375,
        1057.53955078125,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 968.1423950195312,
      "bbox_min": [
        -315.0853271484375,
        1054.145263671875,
        251.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        260.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -746.06884765625,
      "bbox_min": [
        -315.0853271484375,
        1055.80712890625,
        251.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -46.80268859863281,
      "bbox_min": [
        -313.3529052734375,
        1054.145263671875,
        251.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -332.0,
      "bbox_min": [
        -339.02734375,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -330.0,
        1057.8154296875,
        262.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        262.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        262.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575021624565125,
        0.5144803524017334
      ],
      "plane_d": -1036.7147216796875,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        260.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        262.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -251.0,
      "bbox_min": [
        -339.02734375,
        1053.784423828125,
        250.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7746033668518066,
        -0.4471936821937561,
        -0.44722193479537964
      ],
      "plane_d": 843.4059448242188,
      "bbox_min": [
        -339.02734375,
        1053.784423828125,
        250.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        251.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -833.8882446289062,
      "bbox_min": [
        -339.02734375,
        1055.800048828125,
        250.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        251.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745686173439026,
        0.44724565744400024,
        -0.44723013043403625
      ],
      "plane_d": -100.9527359008789,
      "bbox_min": [
        -339.02734375,
        1055.800048828125,
        250.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        251.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745659351348877,
        0.4472441077232361,
        -0.4472363591194153
      ],
      "plane_d": -622.5430908203125,
      "bbox_min": [
        -339.02734375,
        1055.800048828125,
        250.0
      ],
      "bbox_max": [
        -337.574951171875,
        1057.8154296875,
        251.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        -0.7070940732955933,
        0.0
      ],
      "plane_d": 984.6046752929688,
      "bbox_min": [
        -338.37939453125,
        1054.145263671875,
        251.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        260.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -508.52301025390625,
      "bbox_min": [
        -338.37939453125,
        1054.145263671875,
        251.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        260.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -376.8827209472656,
      "bbox_min": [
        -338.37939453125,
        1054.145263671875,
        251.0
      ],
      "bbox_max": [
        -336.6470947265625,
        1057.53955078125,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.489622978416264e-09,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -746.06884765625,
      "bbox_min": [
        -338.37939453125,
        1055.80712890625,
        251.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 508.52301025390625,
      "bbox_min": [
        -338.308837890625,
        1054.145263671875,
        251.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        260.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": -34.95988082885742,
      "bbox_min": [
        -336.6470947265625,
        1054.1455078125,
        251.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 328.4843444824219,
      "bbox_min": [
        -338.308837890625,
        1054.145263671875,
        251.0
      ],
      "bbox_max": [
        -334.9853515625,
        1055.80712890625,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -339.4935607910156,
        1050.0,
        300.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -339.4935607910156,
        1050.0,
        402.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 422.0,
      "bbox_min": [
        -339.4935607910156,
        1050.0,
        402.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -339.4935607910156,
        1050.0,
        402.0
      ],
      "bbox_max": [
        -309.5,
        1053.0,
        422.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 412.0,
      "bbox_min": [
        -330.0,
        1050.0,
        402.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        412.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -330.0,
        1050.0,
        402.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        412.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -330.0,
        1050.0,
        402.0
      ],
      "bbox_max": [
        -330.0,
        1051.800048828125,
        412.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        402.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        414.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -332.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        402.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        414.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        402.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        414.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575021624565125,
        0.5144803524017334
      ],
      "plane_d": -1114.9156494140625,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        412.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        414.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        402.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        414.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        402.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        414.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        402.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        414.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575021624565125,
        0.5144803524017334
      ],
      "plane_d": -1114.9156494140625,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        412.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        414.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -339.48516845703125,
        1050.0,
        300.0
      ],
      "bbox_max": [
        -309.5,
        1057.8154296875,
        320.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -330.0,
        1050.0,
        300.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -330.0,
        1050.0,
        300.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -330.0,
        1050.0,
        300.0
      ],
      "bbox_max": [
        -330.0,
        1051.800048828125,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -339.02734375,
        1051.800048828125,
        300.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        300.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        300.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575021624565125,
        0.5144803524017334
      ],
      "plane_d": -1062.438720703125,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        310.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -301.0,
      "bbox_min": [
        -315.62744140625,
        1053.784423828125,
        300.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745887041091919,
        -0.4471992552280426,
        -0.44724172353744507
      ],
      "plane_d": 362.2912902832031,
      "bbox_min": [
        -315.62744140625,
        1053.784423828125,
        300.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        301.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745960354804993,
        -0.44720351696014404,
        -0.4472247362136841
      ],
      "plane_d": 847.6503295898438,
      "bbox_min": [
        -315.62744140625,
        1053.784423828125,
        300.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        301.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -811.527587890625,
      "bbox_min": [
        -315.62744140625,
        1055.800048828125,
        300.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        301.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745679020881653,
        0.4472414255142212,
        -0.4472355842590332
      ],
      "plane_d": -582.0545043945312,
      "bbox_min": [
        -315.62744140625,
        1055.800048828125,
        300.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        301.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745699286460876,
        0.4472425878047943,
        -0.44723090529441833
      ],
      "plane_d": -96.71217346191406,
      "bbox_min": [
        -312.425048828125,
        1055.800048828125,
        300.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        301.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -524.9769897460938,
      "bbox_min": [
        -315.0853271484375,
        1054.145263671875,
        301.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        310.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -968.1423950195312,
      "bbox_min": [
        -315.0853271484375,
        1054.145263671875,
        301.0
      ],
      "bbox_max": [
        -311.691162109375,
        1057.53955078125,
        310.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 285.61871337890625,
      "bbox_min": [
        -315.0146484375,
        1054.145263671875,
        301.0
      ],
      "bbox_max": [
        -311.691162109375,
        1055.80712890625,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.010574648156762123,
        0.861408531665802
      ],
      "plane_d": -408.1020202636719,
      "bbox_min": [
        -315.0853271484375,
        1054.1455078125,
        301.0
      ],
      "bbox_max": [
        -313.3529052734375,
        1057.53955078125,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -968.1423950195312,
      "bbox_min": [
        -315.0853271484375,
        1054.145263671875,
        301.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        310.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -89.87274932861328,
      "bbox_min": [
        -313.3529052734375,
        1054.145263671875,
        301.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -789.3724365234375,
      "bbox_min": [
        -315.0853271484375,
        1055.80712890625,
        301.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -332.0,
      "bbox_min": [
        -339.02734375,
        1051.800048828125,
        300.0
      ],
      "bbox_max": [
        -330.0,
        1057.8154296875,
        312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        300.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        300.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575021624565125,
        0.5144803524017334
      ],
      "plane_d": -1062.438720703125,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        310.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -301.0,
      "bbox_min": [
        -339.02734375,
        1053.784423828125,
        300.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7746033668518066,
        -0.4471936821937561,
        -0.44722193479537964
      ],
      "plane_d": 865.7670288085938,
      "bbox_min": [
        -339.02734375,
        1053.784423828125,
        300.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        301.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745935320854187,
        -0.44718804955482483,
        -0.4472445547580719
      ],
      "plane_d": 344.15338134765625,
      "bbox_min": [
        -339.02734375,
        1053.784423828125,
        300.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        301.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -811.527587890625,
      "bbox_min": [
        -339.02734375,
        1055.800048828125,
        300.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        301.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745686173439026,
        0.44724565744400024,
        -0.44723013043403625
      ],
      "plane_d": -78.59122467041016,
      "bbox_min": [
        -339.02734375,
        1055.800048828125,
        300.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        301.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745659351348877,
        0.4472441077232361,
        -0.4472363591194153
      ],
      "plane_d": -600.1812744140625,
      "bbox_min": [
        -339.02734375,
        1055.800048828125,
        300.0
      ],
      "bbox_max": [
        -337.574951171875,
        1057.8154296875,
        301.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        -0.7070940732955933,
        0.0
      ],
      "plane_d": 984.6046752929688,
      "bbox_min": [
        -338.37939453125,
        1054.145263671875,
        301.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        310.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -508.52301025390625,
      "bbox_min": [
        -338.37939453125,
        1054.145263671875,
        301.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        310.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -419.9527893066406,
      "bbox_min": [
        -338.37939453125,
        1054.145263671875,
        301.0
      ],
      "bbox_max": [
        -336.6470947265625,
        1057.53955078125,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.489622978416264e-09,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -789.3724365234375,
      "bbox_min": [
        -338.37939453125,
        1055.80712890625,
        301.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 508.52301025390625,
      "bbox_min": [
        -338.308837890625,
        1054.145263671875,
        301.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        310.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": -78.03031158447266,
      "bbox_min": [
        -336.6470947265625,
        1054.1455078125,
        301.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 285.6433410644531,
      "bbox_min": [
        -338.308837890625,
        1054.145263671875,
        301.0
      ],
      "bbox_max": [
        -334.9853515625,
        1055.80712890625,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -335.0,
        1040.0,
        250.0
      ],
      "bbox_max": [
        -315.0,
        1050.0,
        412.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 335.0,
      "bbox_min": [
        -335.0,
        1040.0,
        250.0
      ],
      "bbox_max": [
        -315.0,
        1050.0,
        412.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 412.0,
      "bbox_min": [
        -335.0,
        1040.0,
        412.0
      ],
      "bbox_max": [
        -315.0,
        1050.0,
        412.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        250.0
      ],
      "bbox_max": [
        -309.4794006347656,
        1100.6759033203125,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8289903402328491,
        -0.5592629313468933,
        0.0
      ],
      "plane_d": 844.8052978515625,
      "bbox_min": [
        -309.5,
        971.800048828125,
        250.0
      ],
      "bbox_max": [
        -309.4794006347656,
        1100.6759033203125,
        500.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -309.4794006347656,
        1100.6759033203125,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -309.4794006347656,
        1100.6759033203125,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -845.8052368164062,
      "bbox_min": [
        -309.5,
        1053.5880126953125,
        250.0
      ],
      "bbox_max": [
        -309.4794006347656,
        1053.6185302734375,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        320.0
      ],
      "bbox_max": [
        -309.48516845703125,
        1100.6734619140625,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        320.0
      ],
      "bbox_max": [
        -309.48516845703125,
        1100.6734619140625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 422.0,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        422.0
      ],
      "bbox_max": [
        -309.4935607910156,
        1100.668701171875,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -339.5,
        1051.800048828125,
        402.0
      ],
      "bbox_max": [
        -339.4919128417969,
        1083.34912109375,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 422.0,
      "bbox_min": [
        -339.5,
        1051.800048828125,
        402.0
      ],
      "bbox_max": [
        -339.4919128417969,
        1083.34814453125,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -339.5,
        1051.800048828125,
        402.0
      ],
      "bbox_max": [
        -339.4919128417969,
        1051.800048828125,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -339.5,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -339.4794006347656,
        1083.35546875,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -339.5,
        1051.800048828125,
        300.0
      ],
      "bbox_max": [
        -339.4835205078125,
        1083.35400390625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -339.5,
        1051.800048828125,
        300.0
      ],
      "bbox_max": [
        -339.4835205078125,
        1051.800048828125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -339.5,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -339.4794006347656,
        1051.800048828125,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -306.7905578613281,
      "bbox_min": [
        -354.81549072265625,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        422.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -354.81549072265625,
        1051.800048828125,
        270.0
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -354.81549072265625,
        1051.800048828125,
        402.0
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 422.0,
      "bbox_min": [
        -354.81549072265625,
        1051.800048828125,
        422.0
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -354.81549072265625,
        1051.800048828125,
        270.0
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -354.81549072265625,
        1051.800048828125,
        270.0
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -309.4935607910156,
        1066.027587890625,
        250.0
      ],
      "bbox_max": [
        -119.4999771118164,
        1201.7012939453125,
        422.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -309.4810485839844,
        1066.0347900390625,
        250.0
      ],
      "bbox_max": [
        -119.4999771118164,
        1201.7012939453125,
        300.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.3826856315135956,
        0.9238786101341248,
        -0.0
      ],
      "plane_d": -1008.5560302734375,
      "bbox_min": [
        -175.0,
        1160.0,
        270.0
      ],
      "bbox_max": [
        -155.0,
        1177.071044921875,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1134.84228515625,
      "bbox_min": [
        -175.0,
        1160.0,
        270.0
      ],
      "bbox_max": [
        -155.0,
        1177.071044921875,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 609.4187622070312,
      "bbox_min": [
        -175.0,
        1162.928955078125,
        270.0
      ],
      "bbox_max": [
        -155.0,
        1177.071044921875,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -0.0
      ],
      "plane_d": -286.0609436035156,
      "bbox_min": [
        -175.0,
        1162.928955078125,
        270.0
      ],
      "bbox_max": [
        -155.0,
        1177.071044921875,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -590.941162109375,
      "bbox_min": [
        -157.92892456054688,
        1162.928955078125,
        270.0
      ],
      "bbox_max": [
        -155.0,
        1177.071044921875,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 304.5385437011719,
      "bbox_min": [
        -157.92892456054688,
        1170.0,
        270.0
      ],
      "bbox_max": [
        -155.0,
        1177.071044921875,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 484.36981201171875,
      "bbox_min": [
        -295.7579040527344,
        1073.9578857421875,
        250.0
      ],
      "bbox_max": [
        -119.49998474121094,
        1201.7012939453125,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826856315135956,
        0.9238786101341248,
        -0.0
      ],
      "plane_d": -1008.5560302734375,
      "bbox_min": [
        -295.7579040527344,
        1073.9578857421875,
        250.0
      ],
      "bbox_max": [
        -139.6277313232422,
        1192.1351318359375,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5592275261878967,
        0.829014241695404,
        0.0
      ],
      "plane_d": -726.9810791015625,
      "bbox_min": [
        -295.7579040527344,
        1073.9578857421875,
        250.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.6578369140625,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -845.8052368164062,
      "bbox_min": [
        -295.7579040527344,
        1073.9578857421875,
        250.0
      ],
      "bbox_max": [
        -294.61102294921875,
        1075.6578369140625,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 609.4187622070312,
      "bbox_min": [
        -175.0,
        1160.0,
        250.0
      ],
      "bbox_max": [
        -139.6277313232422,
        1192.1351318359375,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -0.0
      ],
      "plane_d": -286.0609436035156,
      "bbox_min": [
        -175.0,
        1160.0,
        250.0
      ],
      "bbox_max": [
        -139.6277313232422,
        1192.1351318359375,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1134.84228515625,
      "bbox_min": [
        -172.07107543945312,
        1160.0,
        250.0
      ],
      "bbox_max": [
        -139.6277313232422,
        1192.1351318359375,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 268.0,
      "bbox_min": [
        -143.64317321777344,
        1161.7813720703125,
        268.0
      ],
      "bbox_max": [
        -139.6277313232422,
        1170.0335693359375,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9806883931159973,
        -0.1955767273902893,
        -0.0
      ],
      "plane_d": 88.77314758300781,
      "bbox_min": [
        -143.64317321777344,
        1161.7813720703125,
        268.0
      ],
      "bbox_max": [
        -141.7489013671875,
        1169.25341796875,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8372545838356018,
        0.5468133091926575,
        0.0
      ],
      "plane_d": -755.5433959960938,
      "bbox_min": [
        -143.64317321777344,
        1161.7813720703125,
        268.0
      ],
      "bbox_max": [
        -141.7489013671875,
        1164.6817626953125,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1153.3199462890625,
      "bbox_min": [
        -172.07107543945312,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -140.77679443359375,
        1192.1351318359375,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 268.0,
      "bbox_min": [
        -152.89796447753906,
        1186.9576416015625,
        268.0
      ],
      "bbox_max": [
        -146.14324951171875,
        1192.1351318359375,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6597175598144531,
        -0.7515136003494263,
        -0.0
      ],
      "plane_d": 794.2427368164062,
      "bbox_min": [
        -152.89796447753906,
        1186.9576416015625,
        268.0
      ],
      "bbox_max": [
        -148.2029571533203,
        1191.0792236328125,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1027.03369140625,
      "bbox_min": [
        -165.0,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -140.77679443359375,
        1187.810791015625,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 268.0,
      "bbox_min": [
        -159.23541259765625,
        1170.0,
        250.0
      ],
      "bbox_max": [
        -140.77679443359375,
        1187.810791015625,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6597175598144531,
        -0.7515136003494263,
        -0.0
      ],
      "plane_d": 794.2427368164062,
      "bbox_min": [
        -148.2029571533203,
        1184.8170166015625,
        268.0
      ],
      "bbox_max": [
        -145.76443481445312,
        1186.9576416015625,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38270488381385803,
        0.9238706231117249,
        0.0
      ],
      "plane_d": -1148.9014892578125,
      "bbox_min": [
        -159.23541259765625,
        1176.5299072265625,
        250.0
      ],
      "bbox_max": [
        -156.6223907470703,
        1178.3775634765625,
        261.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238695502281189,
        0.3827075660228729,
        0.0
      ],
      "plane_d": -305.5682678222656,
      "bbox_min": [
        -159.23541259765625,
        1176.5299072265625,
        250.0
      ],
      "bbox_max": [
        -156.6223907470703,
        1178.3775634765625,
        261.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826913833618164,
        -0.9238762259483337,
        0.0
      ],
      "plane_d": 1147.906005859375,
      "bbox_min": [
        -159.23541259765625,
        1176.5299072265625,
        250.0
      ],
      "bbox_max": [
        -156.6223907470703,
        1178.3775634765625,
        261.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -157.92892456054688,
        1176.5299072265625,
        260.0
      ],
      "bbox_max": [
        -156.6223907470703,
        1177.4537353515625,
        261.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        -157.92892456054688,
        1176.5299072265625,
        260.0
      ],
      "bbox_max": [
        -156.62240600585938,
        1177.4537353515625,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -590.941162109375,
      "bbox_min": [
        -157.92892456054688,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -140.85781860351562,
        1177.071044921875,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826940953731537,
        -0.923875093460083,
        0.0
      ],
      "plane_d": 1139.25146484375,
      "bbox_min": [
        -155.54116821289062,
        1168.6934814453125,
        250.0
      ],
      "bbox_max": [
        -140.85781860351562,
        1171.3065185546875,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238695502281189,
        0.3827075958251953,
        -0.0
      ],
      "plane_d": -305.568115234375,
      "bbox_min": [
        -155.54116821289062,
        1168.6934814453125,
        250.0
      ],
      "bbox_max": [
        -153.6934356689453,
        1171.3065185546875,
        261.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826913833618164,
        0.9238762259483337,
        0.0
      ],
      "plane_d": -1140.2523193359375,
      "bbox_min": [
        -155.54116821289062,
        1168.6934814453125,
        250.0
      ],
      "bbox_max": [
        -153.6934356689453,
        1171.3065185546875,
        261.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -155.54116821289062,
        1168.6934814453125,
        261.0
      ],
      "bbox_max": [
        -153.6934356689453,
        1170.3826904296875,
        261.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -155.0,
        1170.0,
        261.0
      ],
      "bbox_max": [
        -154.07614135742188,
        1171.3065185546875,
        261.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9806883931159973,
        -0.1955767273902893,
        -0.0
      ],
      "plane_d": 88.77314758300781,
      "bbox_min": [
        -142.9852294921875,
        1169.25341796875,
        268.0
      ],
      "bbox_max": [
        -140.85781860351562,
        1170.8812255859375,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 268.0,
      "bbox_min": [
        -142.9852294921875,
        1169.25341796875,
        268.0
      ],
      "bbox_max": [
        -140.85781860351562,
        1170.8812255859375,
        268.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -157.92892456054688,
        1170.0,
        260.0
      ],
      "bbox_max": [
        -154.4587860107422,
        1177.071044921875,
        261.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        -157.92892456054688,
        1170.0,
        260.0
      ],
      "bbox_max": [
        -154.4587860107422,
        1177.071044921875,
        261.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -2.5911433112923987e-05
      ],
      "plane_d": -305.53179931640625,
      "bbox_min": [
        -156.62240600585938,
        1171.3065185546875,
        260.0
      ],
      "bbox_max": [
        -154.4587860107422,
        1176.5299072265625,
        261.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -309.4935607910156,
        1066.027587890625,
        300.0
      ],
      "bbox_max": [
        -119.49998474121094,
        1201.7012939453125,
        422.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 422.0,
      "bbox_min": [
        -309.4935607910156,
        1066.027587890625,
        402.0
      ],
      "bbox_max": [
        -207.17942810058594,
        1151.0794677734375,
        422.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -309.4919128417969,
        1066.0284423828125,
        402.0
      ],
      "bbox_max": [
        -207.17942810058594,
        1151.0794677734375,
        422.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 383.1253662109375,
      "bbox_min": [
        -222.17942810058594,
        1125.0986328125,
        402.0
      ],
      "bbox_max": [
        -207.17942810058594,
        1151.0794677734375,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 484.36981201171875,
      "bbox_min": [
        -175.0,
        1160.0,
        300.0
      ],
      "bbox_max": [
        -119.49998474121094,
        1201.7012939453125,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9806874394416809,
        0.1955816149711609,
        -0.0
      ],
      "plane_d": -90.7790298461914,
      "bbox_min": [
        -175.0,
        1160.0,
        300.0
      ],
      "bbox_max": [
        -139.6277313232422,
        1192.1351318359375,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826856315135956,
        0.9238786101341248,
        -0.0
      ],
      "plane_d": -1008.5560302734375,
      "bbox_min": [
        -175.0,
        1160.0,
        300.0
      ],
      "bbox_max": [
        -139.6277313232422,
        1192.1351318359375,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 609.4187622070312,
      "bbox_min": [
        -175.0,
        1160.0,
        300.0
      ],
      "bbox_max": [
        -139.6277313232422,
        1192.1351318359375,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -0.0
      ],
      "plane_d": -286.0609436035156,
      "bbox_min": [
        -175.0,
        1160.0,
        300.0
      ],
      "bbox_max": [
        -139.6277313232422,
        1192.1351318359375,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1134.84228515625,
      "bbox_min": [
        -172.07107543945312,
        1160.0,
        300.0
      ],
      "bbox_max": [
        -139.6277313232422,
        1192.1351318359375,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -143.64317321777344,
        1161.7813720703125,
        318.0
      ],
      "bbox_max": [
        -139.6277313232422,
        1170.0335693359375,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9806883931159973,
        -0.1955767273902893,
        -0.0
      ],
      "plane_d": 88.77314758300781,
      "bbox_min": [
        -143.64317321777344,
        1161.7813720703125,
        318.0
      ],
      "bbox_max": [
        -139.6277313232422,
        1169.25341796875,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8372541666030884,
        -0.5468139052391052,
        0.0
      ],
      "plane_d": 753.5440063476562,
      "bbox_min": [
        -139.8084716796875,
        1163.9952392578125,
        318.0
      ],
      "bbox_max": [
        -139.6277313232422,
        1164.27197265625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8372545838356018,
        0.5468133091926575,
        0.0
      ],
      "plane_d": -755.5433959960938,
      "bbox_min": [
        -143.64317321777344,
        1161.7813720703125,
        318.0
      ],
      "bbox_max": [
        -141.7489013671875,
        1164.6817626953125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1153.3199462890625,
      "bbox_min": [
        -172.07107543945312,
        1162.928955078125,
        300.0
      ],
      "bbox_max": [
        -140.77679443359375,
        1192.1351318359375,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6597223877906799,
        0.7515093684196472,
        -0.0
      ],
      "plane_d": -796.2369384765625,
      "bbox_min": [
        -152.89796447753906,
        1186.9576416015625,
        318.0
      ],
      "bbox_max": [
        -146.14324951171875,
        1192.1351318359375,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -152.89796447753906,
        1186.9576416015625,
        318.0
      ],
      "bbox_max": [
        -146.14324951171875,
        1192.1351318359375,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6597175598144531,
        -0.7515136003494263,
        -0.0
      ],
      "plane_d": 794.2427368164062,
      "bbox_min": [
        -152.89796447753906,
        1186.9576416015625,
        318.0
      ],
      "bbox_max": [
        -148.2029571533203,
        1191.0792236328125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1027.03369140625,
      "bbox_min": [
        -165.0,
        1162.928955078125,
        300.0
      ],
      "bbox_max": [
        -140.77679443359375,
        1187.810791015625,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -159.23541259765625,
        1170.0,
        300.0
      ],
      "bbox_max": [
        -140.77679443359375,
        1187.810791015625,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6597223877906799,
        0.7515093684196472,
        -0.0
      ],
      "plane_d": -796.2369384765625,
      "bbox_min": [
        -146.14324951171875,
        1185.872802734375,
        318.0
      ],
      "bbox_max": [
        -143.93565368652344,
        1187.810791015625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6597175598144531,
        -0.7515136003494263,
        -0.0
      ],
      "plane_d": 794.2427368164062,
      "bbox_min": [
        -148.2029571533203,
        1184.8170166015625,
        318.0
      ],
      "bbox_max": [
        -145.76443481445312,
        1186.9576416015625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38270488381385803,
        0.9238706231117249,
        0.0
      ],
      "plane_d": -1148.9014892578125,
      "bbox_min": [
        -159.23541259765625,
        1176.5299072265625,
        300.0
      ],
      "bbox_max": [
        -156.6223907470703,
        1178.3775634765625,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238695502281189,
        0.3827075660228729,
        0.0
      ],
      "plane_d": -305.5682678222656,
      "bbox_min": [
        -159.23541259765625,
        1176.5299072265625,
        300.0
      ],
      "bbox_max": [
        -156.6223907470703,
        1178.3775634765625,
        311.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826913833618164,
        -0.9238762259483337,
        0.0
      ],
      "plane_d": 1147.906005859375,
      "bbox_min": [
        -159.23541259765625,
        1176.5299072265625,
        300.0
      ],
      "bbox_max": [
        -156.6223907470703,
        1178.3775634765625,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -157.92892456054688,
        1176.5299072265625,
        310.0
      ],
      "bbox_max": [
        -156.6223907470703,
        1177.4537353515625,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -157.92892456054688,
        1176.5299072265625,
        310.0
      ],
      "bbox_max": [
        -156.62240600585938,
        1177.4537353515625,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -590.941162109375,
      "bbox_min": [
        -157.92892456054688,
        1162.928955078125,
        300.0
      ],
      "bbox_max": [
        -140.85781860351562,
        1177.071044921875,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826940953731537,
        -0.923875093460083,
        0.0
      ],
      "plane_d": 1139.25146484375,
      "bbox_min": [
        -155.54116821289062,
        1168.6934814453125,
        300.0
      ],
      "bbox_max": [
        -140.85781860351562,
        1171.3065185546875,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238695502281189,
        0.3827075958251953,
        -0.0
      ],
      "plane_d": -305.568115234375,
      "bbox_min": [
        -155.54116821289062,
        1168.6934814453125,
        300.0
      ],
      "bbox_max": [
        -153.6934356689453,
        1171.3065185546875,
        311.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826913833618164,
        0.9238762259483337,
        0.0
      ],
      "plane_d": -1140.2523193359375,
      "bbox_min": [
        -155.54116821289062,
        1168.6934814453125,
        300.0
      ],
      "bbox_max": [
        -153.6934356689453,
        1171.3065185546875,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -155.54116821289062,
        1168.6934814453125,
        311.0
      ],
      "bbox_max": [
        -153.6934356689453,
        1170.3826904296875,
        311.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -155.0,
        1170.0,
        311.0
      ],
      "bbox_max": [
        -154.07614135742188,
        1171.3065185546875,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9806883931159973,
        -0.1955767273902893,
        -0.0
      ],
      "plane_d": 88.77314758300781,
      "bbox_min": [
        -142.9852294921875,
        1169.25341796875,
        318.0
      ],
      "bbox_max": [
        -140.85781860351562,
        1170.8812255859375,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -142.9852294921875,
        1169.25341796875,
        318.0
      ],
      "bbox_max": [
        -140.85781860351562,
        1170.8812255859375,
        318.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -157.92892456054688,
        1170.0,
        310.0
      ],
      "bbox_max": [
        -154.4587860107422,
        1177.071044921875,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -157.92892456054688,
        1170.0,
        310.0
      ],
      "bbox_max": [
        -154.4587860107422,
        1177.071044921875,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -2.5911433112923987e-05
      ],
      "plane_d": -305.530517578125,
      "bbox_min": [
        -156.62240600585938,
        1171.3065185546875,
        310.0
      ],
      "bbox_max": [
        -154.4587860107422,
        1176.5299072265625,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660251498222351,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 674.0302734375,
      "bbox_min": [
        -309.5,
        830.0,
        249.99998474121094
      ],
      "bbox_max": [
        -100.0,
        1175.720458984375,
        500.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.7781982421875,
      "bbox_min": [
        -309.5,
        850.556396484375,
        249.99998474121094
      ],
      "bbox_max": [
        -109.5,
        1175.720458984375,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660245537757874,
        -0.5000016093254089,
        0.0
      ],
      "plane_d": 363.12860107421875,
      "bbox_min": [
        -254.4998779296875,
        1097.7781982421875,
        250.0
      ],
      "bbox_max": [
        -109.5,
        1175.720458984375,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -171.99993896484375,
        1097.7781982421875,
        250.0
      ],
      "bbox_max": [
        -109.5,
        1175.720458984375,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -171.99990844726562,
        1097.7781982421875,
        250.0
      ],
      "bbox_max": [
        -109.5,
        1175.720458984375,
        320.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -171.99990844726562,
        1097.7781982421875,
        250.0
      ],
      "bbox_max": [
        -109.5,
        1175.720458984375,
        270.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 484.36981201171875,
      "bbox_min": [
        -158.62744140625,
        1117.582763671875,
        250.0
      ],
      "bbox_max": [
        -109.5,
        1175.720458984375,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660236597061157,
        0.5000030398368835,
        0.0
      ],
      "plane_d": -678.0347900390625,
      "bbox_min": [
        -158.62744140625,
        1117.582763671875,
        250.0
      ],
      "bbox_max": [
        -120.56786346435547,
        1163.9952392578125,
        270.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 252.0,
      "bbox_min": [
        -136.531982421875,
        1117.582763671875,
        250.0
      ],
      "bbox_max": [
        -120.56786346435547,
        1141.2333984375,
        252.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -252.5,
      "bbox_min": [
        -136.531982421875,
        1117.582763671875,
        252.0
      ],
      "bbox_max": [
        -120.56786346435547,
        1141.2333984375,
        252.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000218152999878,
        -0.8660128116607666,
        -0.0
      ],
      "plane_d": 901.3041381835938,
      "bbox_min": [
        -136.531982421875,
        1117.582763671875,
        252.0
      ],
      "bbox_max": [
        -120.56786346435547,
        1141.2333984375,
        252.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49997854232788086,
        0.8660377860069275,
        -0.0
      ],
      "plane_d": -926.3379516601562,
      "bbox_min": [
        -124.03195190429688,
        1139.2335205078125,
        252.0
      ],
      "bbox_max": [
        -120.56786346435547,
        1141.2333984375,
        252.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999972879886627,
        0.8660269379615784,
        -0.0
      ],
      "plane_d": -906.3233032226562,
      "bbox_min": [
        -134.53196716308594,
        1121.0469970703125,
        250.0
      ],
      "bbox_max": [
        -122.5678482055664,
        1137.7694091796875,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.499977707862854,
        -0.8660382628440857,
        -0.0
      ],
      "plane_d": 905.3385620117188,
      "bbox_min": [
        -134.53196716308594,
        1121.0469970703125,
        250.0
      ],
      "bbox_max": [
        -131.06787109375,
        1123.046875,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000218152999878,
        0.8660128116607666,
        -0.0
      ],
      "plane_d": -922.3041381835938,
      "bbox_min": [
        -126.53194427490234,
        1134.9033203125,
        250.0
      ],
      "bbox_max": [
        -122.5678482055664,
        1137.7694091796875,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999981224536896,
        -0.8660264611244202,
        -0.0
      ],
      "plane_d": 921.3226318359375,
      "bbox_min": [
        -126.53194427490234,
        1134.9033203125,
        250.0
      ],
      "bbox_max": [
        -123.06782531738281,
        1136.9033203125,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 268.0,
      "bbox_min": [
        -158.62744140625,
        1124.784423828125,
        250.0
      ],
      "bbox_max": [
        -139.8084716796875,
        1163.9952392578125,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8372545838356018,
        0.5468133091926575,
        0.0
      ],
      "plane_d": -755.5433959960938,
      "bbox_min": [
        -151.5,
        1147.8099365234375,
        268.0
      ],
      "bbox_max": [
        -143.64317321777344,
        1161.7813720703125,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660296201705933,
        -0.499992698431015,
        0.0
      ],
      "plane_d": 443.6637878417969,
      "bbox_min": [
        -151.5,
        1147.8099365234375,
        268.0
      ],
      "bbox_max": [
        -150.379150390625,
        1149.7513427734375,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -253.0,
      "bbox_min": [
        -158.62744140625,
        1124.784423828125,
        250.0
      ],
      "bbox_max": [
        -153.97265625,
        1128.8154296875,
        262.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542450070381165,
        -0.49318787455558777,
        -0.16441157460212708
      ],
      "plane_d": 461.81353759765625,
      "bbox_min": [
        -158.62744140625,
        1124.784423828125,
        250.0
      ],
      "bbox_max": [
        -153.97265625,
        1128.8154296875,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": 728.849609375,
      "bbox_min": [
        -158.62744140625,
        1124.784423828125,
        250.0
      ],
      "bbox_max": [
        -153.97265625,
        1128.8154296875,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": -1071.86376953125,
      "bbox_min": [
        -158.62744140625,
        1124.784423828125,
        250.0
      ],
      "bbox_max": [
        -153.97265625,
        1128.8154296875,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": 1151.073486328125,
      "bbox_min": [
        -158.62744140625,
        1124.784423828125,
        250.0
      ],
      "bbox_max": [
        -153.97265625,
        1128.8154296875,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -382.65362548828125,
      "bbox_min": [
        -158.62744140625,
        1126.800048828125,
        250.0
      ],
      "bbox_max": [
        -153.97265625,
        1128.8154296875,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542195558547974,
        0.4932328760623932,
        -0.1644088178873062
      ],
      "plane_d": -649.6820678710938,
      "bbox_min": [
        -158.62744140625,
        1126.800048828125,
        250.0
      ],
      "bbox_max": [
        -157.175048828125,
        1128.8154296875,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -686.1984252929688,
      "bbox_min": [
        -158.0853271484375,
        1125.145263671875,
        253.0
      ],
      "bbox_max": [
        -154.62060546875,
        1128.53955078125,
        262.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -907.3312377929688,
      "bbox_min": [
        -158.0853271484375,
        1125.145263671875,
        253.0
      ],
      "bbox_max": [
        -154.691162109375,
        1128.53955078125,
        262.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 363.3607177734375,
      "bbox_min": [
        -158.0146484375,
        1125.145263671875,
        253.0
      ],
      "bbox_max": [
        -154.691162109375,
        1126.80712890625,
        254.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.010574648156762123,
        0.861408531665802
      ],
      "plane_d": -286.2785949707031,
      "bbox_min": [
        -158.0853271484375,
        1125.1455078125,
        253.0
      ],
      "bbox_max": [
        -156.3529052734375,
        1128.53955078125,
        254.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -907.3312377929688,
      "bbox_min": [
        -158.0853271484375,
        1125.145263671875,
        253.0
      ],
      "bbox_max": [
        -154.62060546875,
        1128.53955078125,
        262.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -127.50304412841797,
      "bbox_min": [
        -156.3529052734375,
        1125.145263671875,
        253.0
      ],
      "bbox_max": [
        -154.62060546875,
        1128.53955078125,
        254.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -783.2952880859375,
      "bbox_min": [
        -158.0853271484375,
        1126.80712890625,
        253.0
      ],
      "bbox_max": [
        -154.62060546875,
        1128.53955078125,
        254.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253286361694,
        0.5000001192092896,
        0.0
      ],
      "plane_d": -423.7485656738281,
      "bbox_min": [
        -171.99990844726562,
        1097.7781982421875,
        300.0
      ],
      "bbox_max": [
        -109.5,
        1175.720458984375,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 484.36981201171875,
      "bbox_min": [
        -158.62744140625,
        1117.582763671875,
        300.0
      ],
      "bbox_max": [
        -109.5,
        1175.720458984375,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660236597061157,
        0.5000030398368835,
        0.0
      ],
      "plane_d": -678.0347900390625,
      "bbox_min": [
        -158.62744140625,
        1117.582763671875,
        300.0
      ],
      "bbox_max": [
        -120.56786346435547,
        1163.9952392578125,
        320.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 302.0,
      "bbox_min": [
        -136.531982421875,
        1117.582763671875,
        300.0
      ],
      "bbox_max": [
        -120.56786346435547,
        1141.2333984375,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -302.5,
      "bbox_min": [
        -136.531982421875,
        1117.582763671875,
        302.0
      ],
      "bbox_max": [
        -120.56786346435547,
        1141.2333984375,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000218152999878,
        -0.8660128116607666,
        -0.0
      ],
      "plane_d": 901.3041381835938,
      "bbox_min": [
        -136.531982421875,
        1117.582763671875,
        302.0
      ],
      "bbox_max": [
        -120.56786346435547,
        1141.2333984375,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49997854232788086,
        0.8660377860069275,
        -0.0
      ],
      "plane_d": -926.3379516601562,
      "bbox_min": [
        -124.03195190429688,
        1139.2335205078125,
        302.0
      ],
      "bbox_max": [
        -120.56786346435547,
        1141.2333984375,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999972879886627,
        0.8660269379615784,
        -0.0
      ],
      "plane_d": -906.3233032226562,
      "bbox_min": [
        -134.53196716308594,
        1121.0469970703125,
        300.0
      ],
      "bbox_max": [
        -122.5678482055664,
        1137.7694091796875,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.499977707862854,
        -0.8660382628440857,
        -0.0
      ],
      "plane_d": 905.3385620117188,
      "bbox_min": [
        -134.53196716308594,
        1121.0469970703125,
        300.0
      ],
      "bbox_max": [
        -131.06787109375,
        1123.046875,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000218152999878,
        0.8660128116607666,
        -0.0
      ],
      "plane_d": -922.3041381835938,
      "bbox_min": [
        -126.53194427490234,
        1134.9033203125,
        300.0
      ],
      "bbox_max": [
        -122.5678482055664,
        1137.7694091796875,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999981224536896,
        -0.8660264611244202,
        -0.0
      ],
      "plane_d": 921.3226318359375,
      "bbox_min": [
        -126.53194427490234,
        1134.9033203125,
        300.0
      ],
      "bbox_max": [
        -123.06782531738281,
        1136.9033203125,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8372541666030884,
        -0.5468139052391052,
        0.0
      ],
      "plane_d": 753.5440063476562,
      "bbox_min": [
        -158.62744140625,
        1124.784423828125,
        300.0
      ],
      "bbox_max": [
        -139.8084716796875,
        1163.9952392578125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -151.5,
        1147.8099365234375,
        318.0
      ],
      "bbox_max": [
        -139.8084716796875,
        1163.9952392578125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8372545838356018,
        0.5468133091926575,
        0.0
      ],
      "plane_d": -755.5433959960938,
      "bbox_min": [
        -151.5,
        1147.8099365234375,
        318.0
      ],
      "bbox_max": [
        -143.64317321777344,
        1161.7813720703125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660296201705933,
        -0.499992698431015,
        -0.0
      ],
      "plane_d": 443.6637878417969,
      "bbox_min": [
        -151.5,
        1147.8099365234375,
        318.0
      ],
      "bbox_max": [
        -150.379150390625,
        1149.7513427734375,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -303.0,
      "bbox_min": [
        -158.62744140625,
        1124.784423828125,
        300.0
      ],
      "bbox_max": [
        -153.97265625,
        1128.8154296875,
        312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542450070381165,
        -0.49318787455558777,
        -0.16441157460212708
      ],
      "plane_d": 470.03411865234375,
      "bbox_min": [
        -158.62744140625,
        1124.784423828125,
        300.0
      ],
      "bbox_max": [
        -153.97265625,
        1128.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": 737.0697631835938,
      "bbox_min": [
        -158.62744140625,
        1124.784423828125,
        300.0
      ],
      "bbox_max": [
        -153.97265625,
        1128.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": -1063.643798828125,
      "bbox_min": [
        -158.62744140625,
        1124.784423828125,
        300.0
      ],
      "bbox_max": [
        -153.97265625,
        1128.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": 1159.29345703125,
      "bbox_min": [
        -158.62744140625,
        1124.784423828125,
        300.0
      ],
      "bbox_max": [
        -153.97265625,
        1128.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -374.43328857421875,
      "bbox_min": [
        -158.62744140625,
        1126.800048828125,
        300.0
      ],
      "bbox_max": [
        -153.97265625,
        1128.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542195558547974,
        0.4932328760623932,
        -0.1644088178873062
      ],
      "plane_d": -641.4616088867188,
      "bbox_min": [
        -158.62744140625,
        1126.800048828125,
        300.0
      ],
      "bbox_max": [
        -157.175048828125,
        1128.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -686.1984252929688,
      "bbox_min": [
        -158.0853271484375,
        1125.145263671875,
        303.0
      ],
      "bbox_max": [
        -154.62060546875,
        1128.53955078125,
        312.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -907.3312377929688,
      "bbox_min": [
        -158.0853271484375,
        1125.145263671875,
        303.0
      ],
      "bbox_max": [
        -154.691162109375,
        1128.53955078125,
        312.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 320.51971435546875,
      "bbox_min": [
        -158.0146484375,
        1125.145263671875,
        303.0
      ],
      "bbox_max": [
        -154.691162109375,
        1126.80712890625,
        304.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.010574648156762123,
        0.861408531665802
      ],
      "plane_d": -329.3490295410156,
      "bbox_min": [
        -158.0853271484375,
        1125.1455078125,
        303.0
      ],
      "bbox_max": [
        -156.3529052734375,
        1128.53955078125,
        304.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -907.3312377929688,
      "bbox_min": [
        -158.0853271484375,
        1125.145263671875,
        303.0
      ],
      "bbox_max": [
        -154.62060546875,
        1128.53955078125,
        312.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -170.57310485839844,
      "bbox_min": [
        -156.3529052734375,
        1125.145263671875,
        303.0
      ],
      "bbox_max": [
        -154.62060546875,
        1128.53955078125,
        304.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -826.598876953125,
      "bbox_min": [
        -158.0853271484375,
        1126.80712890625,
        303.0
      ],
      "bbox_max": [
        -154.62060546875,
        1128.53955078125,
        304.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -254.4998779296875,
        1097.7781982421875,
        300.0
      ],
      "bbox_max": [
        -214.49998474121094,
        1115.0986328125,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 675.9923706054688,
      "bbox_min": [
        -309.5,
        850.556396484375,
        249.99998474121094
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660255670547485,
        0.4999997019767761,
        -0.0
      ],
      "plane_d": -235.18533325195312,
      "bbox_min": [
        -309.5,
        911.17822265625,
        249.99998474121094
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        249.99998474121094
      ],
      "bbox_max": [
        -289.5,
        1006.4124755859375,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.4835205078125,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -289.5000305175781,
        1006.4124755859375,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289903402328491,
        -0.5592629313468933,
        0.0
      ],
      "plane_d": 844.8052978515625,
      "bbox_min": [
        -309.5,
        971.800048828125,
        250.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        500.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -309.4935607910156,
        1051.8095703125,
        300.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -309.48516845703125,
        1051.822021484375,
        300.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -309.4835205078125,
        1051.824462890625,
        300.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 422.0,
      "bbox_min": [
        -309.4935607910156,
        1051.8095703125,
        422.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289903402328491,
        0.5592629313468933,
        8.722665256755135e-09
      ],
      "plane_d": -845.8052368164062,
      "bbox_min": [
        -309.4810485839844,
        1053.6160888671875,
        250.0
      ],
      "bbox_max": [
        -295.75787353515625,
        1073.9578857421875,
        270.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 262.5,
      "bbox_min": [
        -306.134521484375,
        1058.0174560546875,
        250.0
      ],
      "bbox_max": [
        -297.97650146484375,
        1069.4404296875,
        262.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5592275261878967,
        -0.829014241695404,
        0.0
      ],
      "plane_d": 719.4810791015625,
      "bbox_min": [
        -306.134521484375,
        1058.0174560546875,
        250.0
      ],
      "bbox_max": [
        -297.97650146484375,
        1069.4404296875,
        262.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5592275261878967,
        0.829014241695404,
        0.0
      ],
      "plane_d": -706.3762817382812,
      "bbox_min": [
        -306.134521484375,
        1058.0174560546875,
        250.0
      ],
      "bbox_max": [
        -305.3055419921875,
        1058.57666015625,
        262.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.4835205078125,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -289.5000305175781,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241365432739,
        0.5000022053718567,
        0.0
      ],
      "plane_d": -363.1293640136719,
      "bbox_min": [
        -214.49998474121094,
        1045.8167724609375,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        -160.0,
        830.0,
        250.00001525878906
      ],
      "bbox_max": [
        -100.0,
        980.0,
        260.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        -160.0,
        830.0,
        250.00001525878906
      ],
      "bbox_max": [
        -100.0,
        980.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        -110.0,
        920.0,
        250.00001525878906
      ],
      "bbox_max": [
        -100.0,
        980.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -110.0,
        920.0,
        250.00001525878906
      ],
      "bbox_max": [
        -100.0,
        920.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -160.0,
        830.0,
        250.00001525878906
      ],
      "bbox_max": [
        -110.0,
        942.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        -160.0,
        840.0,
        250.00001525878906
      ],
      "bbox_max": [
        -110.0,
        942.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -942.0,
      "bbox_min": [
        -160.0,
        942.0,
        250.00001525878906
      ],
      "bbox_max": [
        -150.0,
        942.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        -50.0,
        830.0,
        80.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        -50.0,
        1000.0,
        80.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -50.0,
        1050.0,
        80.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        -50.0,
        1000.0,
        102.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -104.0,
      "bbox_min": [
        -50.0,
        1027.272705078125,
        102.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -50.0,
        1050.0,
        102.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -50.0,
        1050.0,
        124.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -50.0,
        1050.0,
        144.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660242557525635,
        0.5000020861625671,
        0.0
      ],
      "plane_d": -363.1293029785156,
      "bbox_min": [
        -539.5,
        1074.5020751953125,
        60.0
      ],
      "bbox_max": [
        -119.50043487548828,
        1210.361328125,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999701976776,
        0.8660255074501038,
        0.0
      ],
      "plane_d": -783.4539794921875,
      "bbox_min": [
        -539.5,
        1074.5020751953125,
        60.0
      ],
      "bbox_max": [
        -239.49996948242188,
        1210.361328125,
        500.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -249.99998474121094,
      "bbox_min": [
        -539.5,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1201.7012939453125,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1259.215087890625,
      "bbox_min": [
        -528.278564453125,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1201.0435791015625,
        250.00001525878906
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -520.1583862304688,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1171.51123046875,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -409.6885070800781,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1141.04345703125,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 335.5,
      "bbox_min": [
        -335.5,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1098.3555908203125,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1100.646484375,
      "bbox_min": [
        -409.6885070800781,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -339.4679260253906,
        1141.04345703125,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648231029510498,
        -0.5020767450332642,
        0.0
      ],
      "plane_d": 926.982421875,
      "bbox_min": [
        -409.6885070800781,
        1140.611083984375,
        75.0
      ],
      "bbox_max": [
        -409.4375,
        1141.04345703125,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999403953552,
        0.866025447845459,
        0.0
      ],
      "plane_d": -753.4537963867188,
      "bbox_min": [
        -424.6260986328125,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -336.5,
        1140.611083984375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648231029510498,
        -0.5020767450332642,
        0.0
      ],
      "plane_d": 926.982421875,
      "bbox_min": [
        -424.6260986328125,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -336.5,
        1140.611083984375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5020793676376343,
        -0.8648215532302856,
        -0.0
      ],
      "plane_d": 773.7288208007812,
      "bbox_min": [
        -417.09478759765625,
        1134.5572509765625,
        75.0
      ],
      "bbox_max": [
        -413.2030944824219,
        1136.816650390625,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -336.5,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -336.5,
        1098.3555908203125,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -520.1583862304688,
        1097.7781982421875,
        78.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1171.51123046875,
        225.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 845.1761474609375,
      "bbox_min": [
        -342.1239318847656,
        1097.7781982421875,
        205.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1100.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -342.1239318847656,
        1097.7781982421875,
        205.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1100.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -342.1239318847656,
        1097.7781982421875,
        225.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1100.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2419619858264923,
        0.41677382588386536,
        -0.8762156963348389
      ],
      "plane_d": -247.24679565429688,
      "bbox_min": [
        -520.1583862304688,
        1100.0,
        120.0
      ],
      "bbox_max": [
        -338.3482360839844,
        1171.51123046875,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        -500.0,
        1100.0,
        120.0
      ],
      "bbox_max": [
        -338.3482360839844,
        1120.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 845.1761474609375,
      "bbox_min": [
        -340.8411865234375,
        1100.0,
        205.0
      ],
      "bbox_max": [
        -338.3482360839844,
        1101.0794677734375,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -340.8411865234375,
        1100.0,
        205.0
      ],
      "bbox_max": [
        -338.3482360839844,
        1101.0794677734375,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -340.8411865234375,
        1100.0,
        225.0
      ],
      "bbox_max": [
        -338.3482360839844,
        1101.0794677734375,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4167734682559967,
        0.24196158349514008,
        -0.8762159943580627
      ],
      "plane_d": -356.0429992675781,
      "bbox_min": [
        -496.9107666015625,
        1122.90625,
        120.0
      ],
      "bbox_max": [
        -435.4183654785156,
        1171.51123046875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -496.9107666015625,
        1122.90625,
        120.0
      ],
      "bbox_max": [
        -450.44464111328125,
        1171.51123046875,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.1574774533510208,
        0.5934208035469055,
        -0.7893368005752563
      ],
      "plane_d": -646.87548828125,
      "bbox_min": [
        -477.7826843261719,
        1122.90625,
        120.0
      ],
      "bbox_max": [
        -450.44464111328125,
        1140.20263671875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        -490.0,
        1110.0,
        94.0
      ],
      "bbox_max": [
        -487.30767822265625,
        1110.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648231029510498,
        -0.5020767450332642,
        0.0
      ],
      "plane_d": 926.982421875,
      "bbox_min": [
        -413.2030944824219,
        1097.7781982421875,
        78.0
      ],
      "bbox_max": [
        -335.5,
        1141.04345703125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -336.5,
        1097.7781982421875,
        78.0
      ],
      "bbox_max": [
        -335.5,
        1098.9329833984375,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -336.5,
        1098.6800537109375,
        78.5
      ],
      "bbox_max": [
        -336.0618896484375,
        1098.9329833984375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5020793676376343,
        0.8648215532302856,
        -0.0
      ],
      "plane_d": -758.7286987304688,
      "bbox_min": [
        -446.6790466308594,
        1121.5848388671875,
        78.0
      ],
      "bbox_max": [
        -420.7344055175781,
        1136.647216796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        -520.1583862304688,
        1097.7781982421875,
        95.0
      ],
      "bbox_max": [
        -394.5001220703125,
        1147.5079345703125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999999403953552,
        0.866025447845459,
        -0.0
      ],
      "plane_d": -753.4537963867188,
      "bbox_min": [
        -398.348388671875,
        1097.7781982421875,
        95.0
      ],
      "bbox_max": [
        -394.5001220703125,
        1100.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5020800828933716,
        0.8648211359977722,
        0.0
      ],
      "plane_d": -731.2279052734375,
      "bbox_min": [
        -520.1583862304688,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -398.348388671875,
        1147.5079345703125,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.34818652272224426,
        0.0,
        0.9374252557754517
      ],
      "plane_d": -259.66680908203125,
      "bbox_min": [
        -500.0,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -455.0,
        1135.8046875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        -490.0,
        1110.0,
        95.0
      ],
      "bbox_max": [
        -455.5519104003906,
        1110.0,
        107.79500579833984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        -500.0,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1135.8046875,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -500.0,
        1120.0,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1135.8046875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        -490.0,
        1120.0,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1129.9991455078125,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999403953552,
        0.866025447845459,
        -0.0
      ],
      "plane_d": -753.4537963867188,
      "bbox_min": [
        -477.7826843261719,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -398.348388671875,
        1140.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2564944922924042,
        0.9665457010269165,
        0.0
      ],
      "plane_d": -1207.8887939453125,
      "bbox_min": [
        -477.7826843261719,
        1109.6795654296875,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1130.134765625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -455.5519104003906,
        1109.6795654296875,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1121.160888671875,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -455.5519104003906,
        1109.6795654296875,
        105.0
      ],
      "bbox_max": [
        -430.0,
        1121.160888671875,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        -455.5519104003906,
        1109.6795654296875,
        106.79500579833984
      ],
      "bbox_max": [
        -455.0,
        1110.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34818652272224426,
        0.0,
        0.9374252557754517
      ],
      "plane_d": -259.66680908203125,
      "bbox_min": [
        -455.5519104003906,
        1109.6795654296875,
        107.79500579833984
      ],
      "bbox_max": [
        -455.0,
        1110.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5020793676376343,
        0.8648215532302856,
        0.0
      ],
      "plane_d": -751.2286376953125,
      "bbox_min": [
        -450.54339599609375,
        1115.0986328125,
        95.0
      ],
      "bbox_max": [
        -411.8999938964844,
        1140.7320556640625,
        120.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.2564944922924042,
        0.9665457010269165,
        0.0
      ],
      "plane_d": -1207.8887939453125,
      "bbox_min": [
        -450.54339599609375,
        1118.2740478515625,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1130.1610107421875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -435.0,
        1118.2740478515625,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1121.1944580078125,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -435.0,
        1118.2740478515625,
        105.0
      ],
      "bbox_max": [
        -430.0,
        1121.1944580078125,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.855134904384613,
        0.518405556678772,
        -0.0
      ],
      "plane_d": -238.23387145996094,
      "bbox_min": [
        -416.1000061035156,
        1137.2679443359375,
        95.0
      ],
      "bbox_max": [
        -411.8999938964844,
        1140.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.855134904384613,
        -0.518405556678772,
        0.0
      ],
      "plane_d": 942.6939697265625,
      "bbox_min": [
        -416.1000061035156,
        1137.2679443359375,
        95.0
      ],
      "bbox_max": [
        -411.8999938964844,
        1140.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551415801048279,
        0.5183945298194885,
        0.0
      ],
      "plane_d": -946.2757568359375,
      "bbox_min": [
        -416.1000061035156,
        1137.2679443359375,
        95.0
      ],
      "bbox_max": [
        -415.0500183105469,
        1140.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551415801048279,
        -0.5183945298194885,
        0.0
      ],
      "plane_d": 234.626953125,
      "bbox_min": [
        -416.1000061035156,
        1137.2679443359375,
        95.0
      ],
      "bbox_max": [
        -415.0500183105469,
        1139.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551415801048279,
        0.5183945298194885,
        0.0
      ],
      "plane_d": -945.8328247070312,
      "bbox_min": [
        -435.0,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -423.95001220703125,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1121.7320556640625,
      "bbox_min": [
        -427.1000061035156,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -423.95001220703125,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551415801048279,
        -0.5183945298194885,
        0.0
      ],
      "plane_d": 215.3708953857422,
      "bbox_min": [
        -427.1000061035156,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -426.0500183105469,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -435.0,
        1118.291748046875,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1121.1944580078125,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -435.0,
        1118.291748046875,
        105.0
      ],
      "bbox_max": [
        -430.0,
        1121.1944580078125,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -891.2019653320312,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -462.2093505859375,
        1201.0435791015625,
        250.00001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -482.9289245605469,
        1162.928955078125,
        95.0
      ],
      "bbox_max": [
        -462.2093505859375,
        1179.5086669921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -482.9289245605469,
        1162.928955078125,
        131.0
      ],
      "bbox_max": [
        -462.2093505859375,
        1179.5086669921875,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 4.277719497680664,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -476.0613098144531,
        1201.0435791015625,
        250.00001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -486.4145812988281,
        1170.0,
        95.0
      ],
      "bbox_max": [
        -476.0613098144531,
        1185.486083984375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -486.41455078125,
        1170.0,
        131.0
      ],
      "bbox_max": [
        -476.0613098144531,
        1185.486083984375,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -489.9999694824219,
        1175.7572021484375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5934197306632996,
        0.1574786901473999,
        -0.7893373966217041
      ],
      "plane_d": 223.11911010742188,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1175.7572021484375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2419619858264923,
        0.41677382588386536,
        -0.8762156963348389
      ],
      "plane_d": -247.24679565429688,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1175.7572021484375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648213148117065,
        -0.5020797848701477,
        0.0
      ],
      "plane_d": 1046.985107421875,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1175.7572021484375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41677308082580566,
        -0.24196134507656097,
        -0.8762162327766418
      ],
      "plane_d": 609.7070922851562,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1175.7572021484375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -521.0237426757812,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1168.0350341796875,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5020800828933716,
        0.8648211359977722,
        0.0
      ],
      "plane_d": -731.2279052734375,
      "bbox_min": [
        -521.0237426757812,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -520.1583862304688,
        1148.01025390625,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 902.6608276367188,
      "bbox_min": [
        -528.0411376953125,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -479.9999694824219,
        1201.0435791015625,
        250.00001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -518.680908203125,
        1177.071044921875,
        95.0
      ],
      "bbox_max": [
        -482.9289245605469,
        1201.0435791015625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648213148117065,
        -0.5020797848701477,
        0.0
      ],
      "plane_d": 1046.985107421875,
      "bbox_min": [
        -518.680908203125,
        1177.071044921875,
        95.0
      ],
      "bbox_max": [
        -482.9289245605469,
        1201.0435791015625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41677308082580566,
        -0.24196134507656097,
        -0.8762162327766418
      ],
      "plane_d": 609.7070922851562,
      "bbox_min": [
        -518.680908203125,
        1177.071044921875,
        120.0
      ],
      "bbox_max": [
        -482.9289245605469,
        1201.0435791015625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -500.037841796875,
        1177.071044921875,
        131.0
      ],
      "bbox_max": [
        -482.9289245605469,
        1191.0435791015625,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1277.6927490234375,
      "bbox_min": [
        -528.0411376953125,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -479.9999694824219,
        1191.8800048828125,
        250.00001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -528.0411376953125,
        1170.0,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1191.8800048828125,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.41677308082580566,
        -0.24196134507656097,
        -0.8762162327766418
      ],
      "plane_d": 609.7070922851562,
      "bbox_min": [
        -528.0411376953125,
        1170.0,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1191.8800048828125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238695502281189,
        0.3827075958251953,
        0.0
      ],
      "plane_d": -910.702880859375,
      "bbox_min": [
        -498.377685546875,
        1176.52978515625,
        95.0
      ],
      "bbox_max": [
        -495.76458740234375,
        1178.3775634765625,
        106.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38268598914146423,
        -0.9238784909248352,
        0.0
      ],
      "plane_d": 897.2484741210938,
      "bbox_min": [
        -498.377685546875,
        1176.52978515625,
        95.0
      ],
      "bbox_max": [
        -495.76458740234375,
        1178.3775634765625,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        -497.9949645996094,
        1177.071044921875,
        106.0
      ],
      "bbox_max": [
        -495.76458740234375,
        1178.3775634765625,
        106.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        -498.37762451171875,
        1176.5299072265625,
        106.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.4537353515625,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 909.6795654296875,
      "bbox_min": [
        -514.1420288085938,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -479.9999694824219,
        1180.0,
        250.00001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -514.1420288085938,
        1165.0,
        95.0
      ],
      "bbox_max": [
        -497.071044921875,
        1177.0711669921875,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -514.1420288085938,
        1165.0,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238695502281189,
        0.3827075660228729,
        0.0
      ],
      "plane_d": -910.70263671875,
      "bbox_min": [
        -514.1420288085938,
        1168.0350341796875,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826913833618164,
        -0.9238762259483337,
        -0.0
      ],
      "plane_d": 888.5895385742188,
      "bbox_min": [
        -501.30657958984375,
        1169.076171875,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268598914146423,
        0.9238784909248352,
        0.0
      ],
      "plane_d": -889.5948486328125,
      "bbox_min": [
        -500.92388916015625,
        1170.0,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -500.92388916015625,
        1170.0,
        105.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41677308082580566,
        -0.24196134507656097,
        -0.8762162327766418
      ],
      "plane_d": 609.7070922851562,
      "bbox_min": [
        -514.1420288085938,
        1168.0350341796875,
        128.200927734375
      ],
      "bbox_max": [
        -506.3941345214844,
        1173.2093505859375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -0.0
      ],
      "plane_d": 14.199869155883789,
      "bbox_min": [
        -502.0710754394531,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -479.9999694824219,
        1180.0,
        250.00001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -502.0710754394531,
        1162.928955078125,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1170.0,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        -500.3826599121094,
        1168.6934814453125,
        95.0
      ],
      "bbox_max": [
        -499.4588317871094,
        1170.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -500.3826599121094,
        1168.6934814453125,
        95.0
      ],
      "bbox_max": [
        -499.4588317871094,
        1170.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -502.071044921875,
        1162.928955078125,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1169.076171875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -500.0,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -479.9999694824219,
        1180.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -539.5,
        1097.7781982421875,
        250.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1201.7012939453125,
        422.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 845.1761474609375,
      "bbox_min": [
        -342.1239318847656,
        1097.7781982421875,
        250.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1101.0794677734375,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -342.1239318847656,
        1097.7781982421875,
        270.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1101.0794677734375,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 902.6608276367188,
      "bbox_min": [
        -500.0,
        1160.0,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1180.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1277.6927490234375,
      "bbox_min": [
        -500.0,
        1160.0,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1180.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826856315135956,
        0.9238786101341248,
        -0.0
      ],
      "plane_d": -884.1832275390625,
      "bbox_min": [
        -500.0,
        1160.0,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 909.6795654296875,
      "bbox_min": [
        -500.0,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -0.0
      ],
      "plane_d": 14.199869155883789,
      "bbox_min": [
        -500.0,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -891.2019653320312,
      "bbox_min": [
        -482.9289245605469,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 4.277719497680664,
      "bbox_min": [
        -482.9289245605469,
        1170.0,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -539.5,
        1097.7781982421875,
        300.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1201.7012939453125,
        422.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 845.1761474609375,
      "bbox_min": [
        -342.1239318847656,
        1097.7781982421875,
        402.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1101.0794677734375,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 422.0,
      "bbox_min": [
        -342.1239318847656,
        1097.7781982421875,
        402.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1101.0794677734375,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -342.1239318847656,
        1097.7781982421875,
        402.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1101.0794677734375,
        402.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999916553497314,
        0.8660258650779724,
        0.0
      ],
      "plane_d": -753.4545288085938,
      "bbox_min": [
        -539.5,
        1097.7781982421875,
        300.0
      ],
      "bbox_max": [
        -394.5002136230469,
        1201.7012939453125,
        320.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.8660251498222351,
        0.5000004768371582,
        -0.0
      ],
      "plane_d": -111.97993469238281,
      "bbox_min": [
        -539.5,
        1097.7781982421875,
        300.0
      ],
      "bbox_max": [
        -477.0000915527344,
        1175.72021484375,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660253286361694,
        0.5000001192092896,
        0.0
      ],
      "plane_d": -985.7990112304688,
      "bbox_min": [
        -539.5,
        1097.7781982421875,
        300.0
      ],
      "bbox_max": [
        -477.0000915527344,
        1175.72021484375,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 1046.42041015625,
      "bbox_min": [
        -539.5,
        1117.582763671875,
        300.0
      ],
      "bbox_max": [
        -490.37255859375,
        1175.72021484375,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660241961479187,
        0.5000021457672119,
        0.0
      ],
      "plane_d": -115.98413848876953,
      "bbox_min": [
        -528.43212890625,
        1117.582763671875,
        300.0
      ],
      "bbox_max": [
        -490.37255859375,
        1141.2333984375,
        312.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 302.0,
      "bbox_min": [
        -528.43212890625,
        1117.582763671875,
        300.0
      ],
      "bbox_max": [
        -512.468017578125,
        1141.2333984375,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -302.5,
      "bbox_min": [
        -528.43212890625,
        1117.582763671875,
        302.0
      ],
      "bbox_max": [
        -512.468017578125,
        1141.2333984375,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000218152999878,
        -0.8660128116607666,
        0.0
      ],
      "plane_d": 1225.818359375,
      "bbox_min": [
        -528.43212890625,
        1117.582763671875,
        302.0
      ],
      "bbox_max": [
        -512.468017578125,
        1141.2333984375,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999760687351227,
        0.8660392165184021,
        0.0
      ],
      "plane_d": -1250.8243408203125,
      "bbox_min": [
        -528.43212890625,
        1139.2335205078125,
        302.0
      ],
      "bbox_max": [
        -524.968017578125,
        1141.2333984375,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999895691871643,
        0.866025984287262,
        0.0
      ],
      "plane_d": -1230.8212890625,
      "bbox_min": [
        -526.43212890625,
        1121.0469970703125,
        300.0
      ],
      "bbox_max": [
        -514.468017578125,
        1137.7694091796875,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999760687351227,
        -0.8660392165184021,
        0.0
      ],
      "plane_d": 1229.8243408203125,
      "bbox_min": [
        -517.93212890625,
        1121.0469970703125,
        300.0
      ],
      "bbox_max": [
        -514.468017578125,
        1123.046875,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000218152999878,
        0.8660128116607666,
        0.0
      ],
      "plane_d": -1246.818359375,
      "bbox_min": [
        -526.43212890625,
        1134.9033203125,
        300.0
      ],
      "bbox_max": [
        -522.4680786132812,
        1137.7694091796875,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        -0.866025984287262,
        0.0
      ],
      "plane_d": 1245.8212890625,
      "bbox_min": [
        -525.9321899414062,
        1134.9033203125,
        300.0
      ],
      "bbox_max": [
        -522.4680786132812,
        1136.9033203125,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -303.0,
      "bbox_min": [
        -495.02734375,
        1124.784423828125,
        300.0
      ],
      "bbox_max": [
        -490.37255859375,
        1128.8154296875,
        312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542529940605164,
        -0.49317699670791626,
        -0.16440272331237793
      ],
      "plane_d": 1024.4281005859375,
      "bbox_min": [
        -495.02734375,
        1124.784423828125,
        300.0
      ],
      "bbox_max": [
        -490.37255859375,
        1128.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542515635490417,
        -0.4931761622428894,
        -0.16441284120082855
      ],
      "plane_d": 182.65013122558594,
      "bbox_min": [
        -495.02734375,
        1124.784423828125,
        300.0
      ],
      "bbox_max": [
        -490.37255859375,
        1128.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": -1063.643798828125,
      "bbox_min": [
        -495.02734375,
        1124.784423828125,
        300.0
      ],
      "bbox_max": [
        -490.37255859375,
        1128.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": 1159.29345703125,
      "bbox_min": [
        -495.02734375,
        1124.784423828125,
        300.0
      ],
      "bbox_max": [
        -490.37255859375,
        1128.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.854218065738678,
        0.4932362735271454,
        -0.16440637409687042
      ],
      "plane_d": -87.07843017578125,
      "bbox_min": [
        -495.02734375,
        1126.800048828125,
        300.0
      ],
      "bbox_max": [
        -490.37255859375,
        1128.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542176485061646,
        0.49323606491088867,
        -0.16440916061401367
      ],
      "plane_d": -928.8235473632812,
      "bbox_min": [
        -495.02734375,
        1126.800048828125,
        300.0
      ],
      "bbox_max": [
        -493.574951171875,
        1128.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        -0.7070940732955933,
        0.0
      ],
      "plane_d": 1145.1190185546875,
      "bbox_min": [
        -494.37939453125,
        1125.145263671875,
        303.0
      ],
      "bbox_max": [
        -490.9146728515625,
        1128.53955078125,
        312.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -448.4189453125,
      "bbox_min": [
        -494.37939453125,
        1125.145263671875,
        303.0
      ],
      "bbox_max": [
        -490.9146728515625,
        1128.53955078125,
        312.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -500.14532470703125,
      "bbox_min": [
        -494.37939453125,
        1125.145263671875,
        303.0
      ],
      "bbox_max": [
        -492.6470947265625,
        1128.53955078125,
        304.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.489622978416264e-09,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -826.598876953125,
      "bbox_min": [
        -494.37939453125,
        1126.80712890625,
        303.0
      ],
      "bbox_max": [
        -490.9146728515625,
        1128.53955078125,
        304.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -448.4189453125,
      "bbox_min": [
        -494.308837890625,
        1125.145263671875,
        303.0
      ],
      "bbox_max": [
        -490.9146728515625,
        1128.53955078125,
        312.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 320.5442810058594,
      "bbox_min": [
        -494.308837890625,
        1125.145263671875,
        303.0
      ],
      "bbox_max": [
        -490.9853515625,
        1126.80712890625,
        304.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": 0.2148820161819458,
      "bbox_min": [
        -492.6470947265625,
        1125.1455078125,
        303.0
      ],
      "bbox_max": [
        -490.9146728515625,
        1128.53955078125,
        304.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 1046.42041015625,
      "bbox_min": [
        -529.5001220703125,
        1160.0,
        300.0
      ],
      "bbox_max": [
        -480.0,
        1201.7012939453125,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 902.6608276367188,
      "bbox_min": [
        -501.30657958984375,
        1160.0,
        300.0
      ],
      "bbox_max": [
        -480.0,
        1180.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826856315135956,
        0.9238786101341248,
        -0.0
      ],
      "plane_d": -884.1832275390625,
      "bbox_min": [
        -501.30657958984375,
        1160.0,
        300.0
      ],
      "bbox_max": [
        -480.0,
        1180.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1259.215087890625,
      "bbox_min": [
        -501.30657958984375,
        1160.0,
        300.0
      ],
      "bbox_max": [
        -480.0,
        1180.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -891.2019653320312,
      "bbox_min": [
        -501.30657958984375,
        1162.928955078125,
        300.0
      ],
      "bbox_max": [
        -480.0,
        1180.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 4.277719497680664,
      "bbox_min": [
        -501.30657958984375,
        1162.928955078125,
        300.0
      ],
      "bbox_max": [
        -480.0,
        1180.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1277.6927490234375,
      "bbox_min": [
        -501.30657958984375,
        1162.928955078125,
        300.0
      ],
      "bbox_max": [
        -490.0,
        1180.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38270217180252075,
        0.9238717555999756,
        -0.0
      ],
      "plane_d": -898.232421875,
      "bbox_min": [
        -498.377685546875,
        1176.52978515625,
        300.0
      ],
      "bbox_max": [
        -495.76458740234375,
        1178.3775634765625,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238695502281189,
        0.3827075958251953,
        0.0
      ],
      "plane_d": -910.702880859375,
      "bbox_min": [
        -498.377685546875,
        1176.52978515625,
        300.0
      ],
      "bbox_max": [
        -495.76458740234375,
        1178.3775634765625,
        311.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38268598914146423,
        -0.9238784909248352,
        0.0
      ],
      "plane_d": 897.2484741210938,
      "bbox_min": [
        -498.377685546875,
        1176.52978515625,
        300.0
      ],
      "bbox_max": [
        -495.76458740234375,
        1178.3775634765625,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -497.9949645996094,
        1177.071044921875,
        311.0
      ],
      "bbox_max": [
        -495.76458740234375,
        1178.3775634765625,
        311.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -498.37762451171875,
        1176.5299072265625,
        311.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.4537353515625,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -0.0
      ],
      "plane_d": 14.199869155883789,
      "bbox_min": [
        -501.30657958984375,
        1162.928955078125,
        300.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826913833618164,
        -0.9238762259483337,
        -0.0
      ],
      "plane_d": 888.5895385742188,
      "bbox_min": [
        -501.30657958984375,
        1168.6934814453125,
        300.0
      ],
      "bbox_max": [
        -499.4588317871094,
        1171.306640625,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238695502281189,
        0.3827075660228729,
        0.0
      ],
      "plane_d": -910.70263671875,
      "bbox_min": [
        -501.30657958984375,
        1168.6934814453125,
        300.0
      ],
      "bbox_max": [
        -499.4588317871094,
        1171.306640625,
        311.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38268598914146423,
        0.9238784909248352,
        0.0
      ],
      "plane_d": -889.5948486328125,
      "bbox_min": [
        -501.30657958984375,
        1168.6934814453125,
        300.0
      ],
      "bbox_max": [
        -499.4588317871094,
        1171.306640625,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -500.92388916015625,
        1170.0,
        310.0
      ],
      "bbox_max": [
        -500.0,
        1171.306640625,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -500.92388916015625,
        1170.0,
        310.0
      ],
      "bbox_max": [
        -500.0,
        1171.3065185546875,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -500.54119873046875,
        1170.0,
        310.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -500.54119873046875,
        1170.0,
        310.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        2.5911433112923987e-05
      ],
      "plane_d": -910.6876220703125,
      "bbox_min": [
        -500.54119873046875,
        1171.3065185546875,
        310.0
      ],
      "bbox_max": [
        -498.37762451171875,
        1176.5299072265625,
        311.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -249.99998474121094,
      "bbox_min": [
        -394.5002136230469,
        1074.5020751953125,
        75.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -394.5001220703125,
        1074.5020751953125,
        75.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 845.1761474609375,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        205.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        205.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        205.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -306.7905578613281,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        205.0
      ],
      "bbox_max": [
        -354.81549072265625,
        1075.0986328125,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -394.5001220703125,
        1074.5020751953125,
        75.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999999403953552,
        0.866025447845459,
        -0.0
      ],
      "plane_d": -753.4537963867188,
      "bbox_min": [
        -394.5001220703125,
        1074.5020751953125,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1097.7781982421875,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8289903402328491,
        0.5592629313468933,
        -0.0
      ],
      "plane_d": -306.7905578613281,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        75.0
      ],
      "bbox_max": [
        -354.81549072265625,
        1075.0986328125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.6800537109375,
      "bbox_min": [
        -336.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 335.5,
      "bbox_min": [
        -336.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -336.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -336.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -394.5002136230469,
        1074.5020751953125,
        250.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 845.1761474609375,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        402.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        402.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 422.0,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        402.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -306.7905578613281,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        402.0
      ],
      "bbox_max": [
        -354.81549072265625,
        1075.0986328125,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -394.5002136230469,
        1074.5020751953125,
        250.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 845.1761474609375,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        250.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        250.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -306.7905578613281,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        250.0
      ],
      "bbox_max": [
        -354.81549072265625,
        1075.0986328125,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999916553497314,
        0.8660258650779724,
        0.0
      ],
      "plane_d": -753.4545288085938,
      "bbox_min": [
        -394.5002136230469,
        1074.5020751953125,
        300.0
      ],
      "bbox_max": [
        -354.81549072265625,
        1097.7781982421875,
        320.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -306.7905578613281,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        300.0
      ],
      "bbox_max": [
        -354.81549072265625,
        1075.0986328125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1130.4095458984375,
      "bbox_min": [
        -514.4999389648438,
        1092.0047607421875,
        60.0
      ],
      "bbox_max": [
        -239.49996948242188,
        1210.361328125,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -249.99998474121094,
      "bbox_min": [
        -391.0191650390625,
        1092.0047607421875,
        60.0
      ],
      "bbox_max": [
        -257.9808044433594,
        1130.4095458984375,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1101.0794677734375,
      "bbox_min": [
        -391.0191650390625,
        1092.0047607421875,
        60.0
      ],
      "bbox_max": [
        -257.9808044433594,
        1130.4095458984375,
        250.00003051757812
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -340.21795654296875,
        1092.0047607421875,
        225.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.0794677734375,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -340.21795654296875,
        1092.0047607421875,
        75.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -322.5,
      "bbox_min": [
        -340.21795654296875,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -322.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 313.5,
      "bbox_min": [
        -314.5,
        1097.7783203125,
        75.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -314.5,
        1097.7783203125,
        78.04911804199219
      ],
      "bbox_max": [
        -313.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -314.5,
        1097.7783203125,
        78.04911804199219
      ],
      "bbox_max": [
        -313.5,
        1098.6800537109375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1100.646484375,
      "bbox_min": [
        -313.5,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -313.5,
        1100.646484375,
        78.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.6800537109375,
      "bbox_min": [
        -322.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -321.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -322.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -321.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -322.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -321.5,
        1098.6800537109375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -328.5,
      "bbox_min": [
        -340.21795654296875,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -322.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 327.5,
      "bbox_min": [
        -328.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -322.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.6800537109375,
      "bbox_min": [
        -328.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -327.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -328.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -327.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -328.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -327.5,
        1098.6800537109375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1100.646484375,
      "bbox_min": [
        -327.5,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -322.5,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -327.5,
        1100.646484375,
        78.0
      ],
      "bbox_max": [
        -322.5,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 335.5,
      "bbox_min": [
        -340.21795654296875,
        1098.3555908203125,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -340.21795654296875,
        1098.3555908203125,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -336.5,
        1098.3555908203125,
        78.33779907226562
      ],
      "bbox_max": [
        -335.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -336.0618896484375,
        1098.3555908203125,
        78.33779907226562
      ],
      "bbox_max": [
        -335.5,
        1098.6800537109375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1100.646484375,
      "bbox_min": [
        -340.21795654296875,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -336.5,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -340.21795654296875,
        1100.646484375,
        78.0
      ],
      "bbox_max": [
        -336.5,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        -391.0191650390625,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -257.9808044433594,
        1130.4095458984375,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -391.0191650390625,
        1101.0794677734375,
        118.0
      ],
      "bbox_max": [
        -257.9808349609375,
        1130.4095458984375,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -344.8478088378906,
        1122.0,
        118.0
      ],
      "bbox_max": [
        -305.1521911621094,
        1130.4095458984375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882259011268616,
        0.965924859046936,
        0.0
      ],
      "plane_d": -999.6503295898438,
      "bbox_min": [
        -344.8478088378906,
        1122.0,
        118.0
      ],
      "bbox_max": [
        -305.1521911621094,
        1130.4095458984375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882259011268616,
        0.965924859046936,
        0.0
      ],
      "plane_d": -1167.885009765625,
      "bbox_min": [
        -344.8478088378906,
        1122.0,
        118.0
      ],
      "bbox_max": [
        -305.1521911621094,
        1130.4095458984375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -555.4788208007812,
      "bbox_min": [
        -344.8478088378906,
        1126.186767578125,
        118.0
      ],
      "bbox_max": [
        -305.1521911621094,
        1130.4095458984375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -1015.0970458984375,
      "bbox_min": [
        -309.375,
        1126.186767578125,
        118.0
      ],
      "bbox_max": [
        -305.1521911621094,
        1130.4095458984375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -322.5,
      "bbox_min": [
        -336.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -313.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -322.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -313.5,
        1122.0,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 313.5,
      "bbox_min": [
        -314.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -313.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -314.5,
        1101.080078125,
        63.5
      ],
      "bbox_max": [
        -313.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 321.5,
      "bbox_min": [
        -322.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -321.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -322.5,
        1101.080078125,
        63.5
      ],
      "bbox_max": [
        -321.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -328.5,
      "bbox_min": [
        -336.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -327.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.5,
      "bbox_min": [
        -328.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -327.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -328.5,
        1101.080078125,
        63.5
      ],
      "bbox_max": [
        -327.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -336.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -335.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 335.5,
      "bbox_min": [
        -336.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -335.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -336.5,
        1101.080078125,
        63.5
      ],
      "bbox_max": [
        -335.5,
        1122.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1101.0794677734375,
      "bbox_min": [
        -391.0191650390625,
        1092.0047607421875,
        250.0
      ],
      "bbox_max": [
        -257.9808349609375,
        1130.4095458984375,
        500.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -340.21795654296875,
        1092.0047607421875,
        270.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.0794677734375,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -340.21795654296875,
        1092.0047607421875,
        270.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.0794677734375,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -391.0191650390625,
        1101.0794677734375,
        400.0
      ],
      "bbox_max": [
        -257.9808349609375,
        1130.4095458984375,
        422.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660229444503784,
        0.500004231929779,
        0.0
      ],
      "plane_d": -333.132080078125,
      "bbox_min": [
        -267.9807434082031,
        1126.0794677734375,
        402.0
      ],
      "bbox_max": [
        -257.9808349609375,
        1130.4095458984375,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -267.9807434082031,
        1126.0794677734375,
        402.0
      ],
      "bbox_max": [
        -257.9808349609375,
        1130.4095458984375,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660242557525635,
        0.5000020861625671,
        0.0
      ],
      "plane_d": -925.1790161132812,
      "bbox_min": [
        -514.4999389648438,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -409.5,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        432.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 432.0,
      "bbox_min": [
        -375.0001220703125,
        1130.4095458984375,
        400.0
      ],
      "bbox_max": [
        -320.5,
        1190.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 375.0,
      "bbox_min": [
        -375.0001220703125,
        1130.4095458984375,
        400.0
      ],
      "bbox_max": [
        -320.5,
        1190.0,
        432.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -375.0001220703125,
        1130.4095458984375,
        400.0
      ],
      "bbox_max": [
        -320.5,
        1190.0,
        432.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        -329.5,
        1140.0,
        400.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        402.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 329.5,
      "bbox_min": [
        -329.5,
        1140.0,
        400.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        402.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1190.0,
      "bbox_min": [
        -375.0001220703125,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1190.0,
        432.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        -375.0001220703125,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1190.0,
        432.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        -340.0,
        1145.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1182.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1158.0,
      "bbox_min": [
        -340.0,
        1145.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1158.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 338.0,
      "bbox_min": [
        -340.0,
        1145.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1158.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1145.0,
      "bbox_min": [
        -340.0,
        1145.0,
        402.0
      ],
      "bbox_max": [
        -338.0,
        1145.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1150.0,
      "bbox_min": [
        -338.0,
        1150.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1158.0,
        413.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -413.5,
      "bbox_min": [
        -338.0,
        1150.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1158.0,
        413.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        1150.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1158.0,
        413.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -405.5,
      "bbox_min": [
        -325.0,
        1154.0,
        405.0
      ],
      "bbox_max": [
        -320.5,
        1158.0,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 405.0,
      "bbox_min": [
        -325.0,
        1154.0,
        405.0
      ],
      "bbox_max": [
        -320.5,
        1158.0,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1154.0,
      "bbox_min": [
        -325.0,
        1154.0,
        405.0
      ],
      "bbox_max": [
        -320.5,
        1154.0,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -6.10351571594947e-06,
        0.0
      ],
      "plane_d": 336.7071533203125,
      "bbox_min": [
        -340.0,
        1160.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1182.0,
        407.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -404.0,
      "bbox_min": [
        -340.0,
        1170.0,
        402.0
      ],
      "bbox_max": [
        -336.699951171875,
        1182.0,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1182.0,
      "bbox_min": [
        -340.0,
        1170.0,
        402.0
      ],
      "bbox_max": [
        -336.699951171875,
        1182.0,
        404.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        -340.0,
        1170.0,
        402.0
      ],
      "bbox_max": [
        -336.70001220703125,
        1170.0,
        404.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -407.0,
      "bbox_min": [
        -340.0,
        1170.0,
        404.0
      ],
      "bbox_max": [
        -336.699951171875,
        1182.0,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1171.0,
      "bbox_min": [
        -340.0,
        1170.0,
        404.0
      ],
      "bbox_max": [
        -336.699951171875,
        1182.0,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1181.0,
      "bbox_min": [
        -340.0,
        1171.0,
        404.0
      ],
      "bbox_max": [
        -336.699951171875,
        1182.0,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805746078491211,
        -0.0,
        0.19614683091640472
      ],
      "plane_d": 252.77923583984375,
      "bbox_min": [
        -339.2000732421875,
        1171.0,
        404.0
      ],
      "bbox_max": [
        -338.5999755859375,
        1181.0,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -404.3999938964844,
      "bbox_min": [
        -340.0,
        1181.0,
        404.0
      ],
      "bbox_max": [
        -336.699951171875,
        1182.0,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -1237.9027099609375,
      "bbox_min": [
        -340.0,
        1181.0,
        404.0
      ],
      "bbox_max": [
        -336.699951171875,
        1182.0,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 875.7257080078125,
      "bbox_min": [
        -340.0,
        1181.0,
        404.0
      ],
      "bbox_max": [
        -336.699951171875,
        1181.199951171875,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -404.3999938964844,
      "bbox_min": [
        -340.0,
        1170.0,
        404.0
      ],
      "bbox_max": [
        -336.70001220703125,
        1171.0,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944681882858276,
        0.4471317231655121
      ],
      "plane_d": 865.8865966796875,
      "bbox_min": [
        -340.0,
        1170.0,
        404.0
      ],
      "bbox_max": [
        -336.70001220703125,
        1171.0,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944681882858276,
        0.4471317231655121
      ],
      "plane_d": -1228.0634765625,
      "bbox_min": [
        -340.0,
        1170.800048828125,
        404.0
      ],
      "bbox_max": [
        -336.70001220703125,
        1171.0,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 404.0,
      "bbox_min": [
        -330.0,
        1160.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1180.0,
        407.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -330.0,
      "bbox_min": [
        -330.0,
        1160.0,
        404.0
      ],
      "bbox_max": [
        -320.5,
        1180.0,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        -330.0,
        1160.0,
        404.0
      ],
      "bbox_max": [
        -320.5,
        1180.0,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -404.5,
      "bbox_min": [
        -330.0,
        1170.0,
        404.0
      ],
      "bbox_max": [
        -320.5,
        1180.0,
        404.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        -330.0,
        1180.0,
        404.0
      ],
      "bbox_max": [
        -320.5,
        1180.0,
        404.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -407.0,
      "bbox_min": [
        -326.0,
        1160.0,
        404.0
      ],
      "bbox_max": [
        -320.5,
        1163.300048828125,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -325.0,
      "bbox_min": [
        -326.0,
        1160.0,
        404.0
      ],
      "bbox_max": [
        -320.5,
        1163.300048828125,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9805746078491211,
        0.19614683091640472
      ],
      "plane_d": -1218.0826416015625,
      "bbox_min": [
        -325.0,
        1160.7999267578125,
        404.0
      ],
      "bbox_max": [
        -320.5,
        1161.4000244140625,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -404.3999938964844,
      "bbox_min": [
        -326.0,
        1160.0,
        404.0
      ],
      "bbox_max": [
        -325.0,
        1163.300048828125,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944682478904724,
        0.0,
        0.4471317529678345
      ],
      "plane_d": -472.2378845214844,
      "bbox_min": [
        -326.0,
        1160.0,
        404.0
      ],
      "bbox_max": [
        -325.0,
        1163.300048828125,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944682478904724,
        -0.0,
        0.4471317529678345
      ],
      "plane_d": 110.06094360351562,
      "bbox_min": [
        -326.0,
        1160.0,
        404.0
      ],
      "bbox_max": [
        -325.0,
        1163.300048828125,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1163.300048828125,
      "bbox_min": [
        -326.0,
        1163.300048828125,
        404.0
      ],
      "bbox_max": [
        -325.0,
        1163.300048828125,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1163.300048828125,
      "bbox_min": [
        -326.0,
        1160.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1178.0,
        404.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -326.0,
      "bbox_min": [
        -326.0,
        1160.0,
        402.0
      ],
      "bbox_max": [
        -326.0,
        1163.300048828125,
        404.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -322.0,
      "bbox_min": [
        -322.0,
        1172.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1178.0,
        404.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1172.0,
      "bbox_min": [
        -322.0,
        1172.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1178.0,
        404.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1178.0,
      "bbox_min": [
        -322.0,
        1178.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1178.0,
        404.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17549332976341248,
        -0.9844806790351868,
        0.0
      ],
      "plane_d": 1232.252685546875,
      "bbox_min": [
        -375.0001220703125,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -346.0,
        1190.0,
        428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 406.0,
      "bbox_min": [
        -371.0,
        1185.9000244140625,
        406.0
      ],
      "bbox_max": [
        -346.0,
        1190.0,
        428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -428.0,
      "bbox_min": [
        -371.0,
        1185.9000244140625,
        406.0
      ],
      "bbox_max": [
        -346.0,
        1190.0,
        428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8987674713134766,
        -0.43842577934265137,
        -0.0
      ],
      "plane_d": 188.28396606445312,
      "bbox_min": [
        -371.0,
        1185.9000244140625,
        406.0
      ],
      "bbox_max": [
        -369.0,
        1190.0,
        428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -422.20001220703125,
      "bbox_min": [
        -375.0001220703125,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -357.0,
        1180.0,
        422.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 372.0000915527344,
      "bbox_min": [
        -375.0001220703125,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -357.0,
        1180.0,
        422.20001220703125
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -406.20001220703125,
      "bbox_min": [
        -375.0001220703125,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -372.0,
        1180.0,
        422.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        -375.0001220703125,
        1180.0,
        402.0
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        406.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -405.5,
      "bbox_min": [
        -375.0,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -372.0001220703125,
        1136.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1136.5,
      "bbox_min": [
        -375.0,
        1136.5,
        402.0
      ],
      "bbox_max": [
        -372.0001220703125,
        1136.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 419.20001220703125,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        406.20001220703125
      ],
      "bbox_max": [
        -372.0,
        1180.0,
        422.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        419.20001220703125
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        422.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        419.20001220703125
      ],
      "bbox_max": [
        -372.0001220703125,
        1147.0,
        422.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -413.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        406.20001220703125
      ],
      "bbox_max": [
        -372.0,
        1180.0,
        419.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -409.5,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        406.20001220703125
      ],
      "bbox_max": [
        -372.0,
        1180.0,
        413.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 409.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        406.20001220703125
      ],
      "bbox_max": [
        -372.0,
        1180.0,
        409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        409.0
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        409.0
      ],
      "bbox_max": [
        -372.0001220703125,
        1147.0,
        409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        -375.0001220703125,
        1177.0,
        409.0
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1177.0,
      "bbox_min": [
        -375.0001220703125,
        1177.0,
        409.0
      ],
      "bbox_max": [
        -372.0001220703125,
        1177.0,
        409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        406.20001220703125
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        409.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        406.20001220703125
      ],
      "bbox_max": [
        -372.0001220703125,
        1147.0,
        409.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1177.0,
      "bbox_min": [
        -375.0001220703125,
        1177.0,
        406.20001220703125
      ],
      "bbox_max": [
        -372.0001220703125,
        1177.0,
        409.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 412.5,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        409.5
      ],
      "bbox_max": [
        -372.0,
        1180.0,
        413.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        412.5
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        413.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        412.5
      ],
      "bbox_max": [
        -372.0001220703125,
        1147.0,
        413.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        -375.0001220703125,
        1177.0,
        412.5
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        413.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1177.0,
      "bbox_min": [
        -375.0001220703125,
        1177.0,
        412.5
      ],
      "bbox_max": [
        -372.0001220703125,
        1177.0,
        413.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        409.5
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        412.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        409.5
      ],
      "bbox_max": [
        -372.0001220703125,
        1147.0,
        412.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        -375.0001220703125,
        1177.0,
        409.5
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        412.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1177.0,
      "bbox_min": [
        -375.0001220703125,
        1177.0,
        409.5
      ],
      "bbox_max": [
        -372.0001220703125,
        1177.0,
        412.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 416.1000061035156,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        413.0
      ],
      "bbox_max": [
        -372.0,
        1180.0,
        419.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -416.6000061035156,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        416.1000061035156
      ],
      "bbox_max": [
        -372.0,
        1180.0,
        419.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        416.1000061035156
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        416.6000061035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        416.1000061035156
      ],
      "bbox_max": [
        -372.0001220703125,
        1147.0,
        416.6000061035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        -375.0001220703125,
        1177.0,
        416.1000061035156
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        416.6000061035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1177.0,
      "bbox_min": [
        -375.0001220703125,
        1177.0,
        416.1000061035156
      ],
      "bbox_max": [
        -372.0001220703125,
        1177.0,
        416.6000061035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        416.6000061035156
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        419.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        416.6000061035156
      ],
      "bbox_max": [
        -372.0001220703125,
        1147.0,
        419.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        -375.0001220703125,
        1177.0,
        416.6000061035156
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        419.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1177.0,
      "bbox_min": [
        -375.0001220703125,
        1177.0,
        416.6000061035156
      ],
      "bbox_max": [
        -372.0001220703125,
        1177.0,
        419.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        413.0
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        416.1000061035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        413.0
      ],
      "bbox_max": [
        -372.0001220703125,
        1147.0,
        416.1000061035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        -375.0001220703125,
        1177.0,
        413.0
      ],
      "bbox_max": [
        -372.0001220703125,
        1180.0,
        416.1000061035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1177.0,
      "bbox_min": [
        -375.0001220703125,
        1177.0,
        413.0
      ],
      "bbox_max": [
        -372.0001220703125,
        1177.0,
        416.1000061035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 357.0,
      "bbox_min": [
        -372.0001220703125,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -357.0,
        1180.0,
        406.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -406.20001220703125,
      "bbox_min": [
        -372.0001220703125,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -357.0,
        1180.0,
        406.20001220703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -360.0,
      "bbox_min": [
        -372.0001220703125,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -357.0,
        1180.0,
        406.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238834381103516,
        0.3826742470264435,
        0.0
      ],
      "plane_d": -118.28515625,
      "bbox_min": [
        -360.0,
        1150.0,
        402.0
      ],
      "bbox_max": [
        -357.0,
        1177.5147705078125,
        406.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1150.0,
      "bbox_min": [
        -360.0,
        1150.0,
        402.0
      ],
      "bbox_max": [
        -357.0,
        1177.5147705078125,
        406.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826742470264435,
        0.9238834381103516,
        0.0
      ],
      "plane_d": -950.1236572265625,
      "bbox_min": [
        -360.0,
        1177.364013671875,
        402.0
      ],
      "bbox_max": [
        -359.635986328125,
        1177.5147705078125,
        406.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1136.5,
      "bbox_min": [
        -372.0001220703125,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -360.0,
        1180.0,
        406.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -405.5,
      "bbox_min": [
        -372.0001220703125,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -362.5,
        1136.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 362.5,
      "bbox_min": [
        -362.5,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -362.5,
        1136.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826742470264435,
        0.9238834381103516,
        0.0
      ],
      "plane_d": -950.1236572265625,
      "bbox_min": [
        -372.0001220703125,
        1171.0,
        402.0
      ],
      "bbox_max": [
        -360.0,
        1180.0,
        406.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1177.0,
      "bbox_min": [
        -372.0001220703125,
        1171.0,
        402.0
      ],
      "bbox_max": [
        -360.0,
        1180.0,
        406.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        -372.0001220703125,
        1180.0,
        402.0
      ],
      "bbox_max": [
        -366.0,
        1180.0,
        406.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826742172241211,
        -0.9238833785057068,
        0.0
      ],
      "plane_d": 947.35205078125,
      "bbox_min": [
        -366.0,
        1171.0,
        402.0
      ],
      "bbox_max": [
        -360.0,
        1177.0,
        406.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        -0.3826742172241211,
        0.0
      ],
      "plane_d": 115.51348876953125,
      "bbox_min": [
        -361.75732421875,
        1171.0,
        402.0
      ],
      "bbox_max": [
        -360.0,
        1175.24267578125,
        406.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        -409.5,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -409.5,
        1130.4095458984375,
        95.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -293.9911193847656,
      "bbox_min": [
        -376.25,
        1185.25,
        110.0
      ],
      "bbox_max": [
        -357.96875,
        1195.25,
        114.68749237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1195.25,
      "bbox_min": [
        -376.25,
        1195.25,
        110.0
      ],
      "bbox_max": [
        -357.96875,
        1195.25,
        114.68749237060547
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 376.25,
      "bbox_min": [
        -409.4998474121094,
        1141.04345703125,
        95.0
      ],
      "bbox_max": [
        -353.0,
        1195.25,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5020793676376343,
        -0.8648215532302856,
        0.0
      ],
      "plane_d": 781.2288818359375,
      "bbox_min": [
        -409.4998474121094,
        1141.04345703125,
        95.0
      ],
      "bbox_max": [
        -409.4375,
        1141.07958984375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1195.25,
      "bbox_min": [
        -376.25,
        1195.25,
        114.68749237060547
      ],
      "bbox_max": [
        -353.0,
        1195.25,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -409.4998474121094,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 376.25,
      "bbox_min": [
        -409.4998474121094,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -340.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5020793676376343,
        -0.8648215532302856,
        0.0
      ],
      "plane_d": 781.2288818359375,
      "bbox_min": [
        -409.4998474121094,
        1141.04345703125,
        118.0
      ],
      "bbox_max": [
        -409.4375,
        1141.07958984375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6844431757926941,
        -0.7290661931037903,
        0.0
      ],
      "plane_d": 1093.154541015625,
      "bbox_min": [
        -376.25,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -340.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1195.25,
      "bbox_min": [
        -376.25,
        1185.25,
        118.0
      ],
      "bbox_max": [
        -350.0,
        1195.25,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -293.9911193847656,
      "bbox_min": [
        -353.0,
        1185.25,
        118.0
      ],
      "bbox_max": [
        -350.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659258127212524,
        -0.2588190734386444,
        0.0
      ],
      "plane_d": 642.5941772460938,
      "bbox_min": [
        -356.25,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -344.8478088378906,
        1168.875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659258127212524,
        0.2588190734386444,
        0.0
      ],
      "plane_d": 45.62797546386719,
      "bbox_min": [
        -356.25,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -344.8478088378906,
        1153.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -555.4788208007812,
      "bbox_min": [
        -352.06329345703125,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -344.8478088378906,
        1137.625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -387.80487060546875,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866144061088562,
        -0.4997943639755249,
        0.0
      ],
      "plane_d": 914.9912109375,
      "bbox_min": [
        -387.80487060546875,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 827.0648193359375,
      "bbox_min": [
        -387.80487060546875,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -379.152587890625,
        1178.65625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -355.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.4000244140625,
      "bbox_min": [
        -355.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -340.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648214340209961,
        -0.5020795464515686,
        0.0
      ],
      "plane_d": 926.9849243164062,
      "bbox_min": [
        -409.4375,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.361328125,
      "bbox_min": [
        -377.73565673828125,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -340.0,
        1200.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -377.73565673828125,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1187.7750244140625,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -329.5,
      "bbox_min": [
        -377.73565673828125,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -329.5,
        1187.7750244140625,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1175.0,
      "bbox_min": [
        -377.73565673828125,
        1140.0,
        65.0
      ],
      "bbox_max": [
        -329.5,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 364.75,
      "bbox_min": [
        -377.73565673828125,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429112732410431,
        -0.3468084931373596,
        0.8730038404464722
      ],
      "plane_d": 465.1109619140625,
      "bbox_min": [
        -377.73565673828125,
        1175.0,
        77.30587768554688
      ],
      "bbox_max": [
        -364.75,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291085600852966,
        -0.34680885076522827,
        0.8730038404464722
      ],
      "plane_d": 214.91290283203125,
      "bbox_min": [
        -375.151611328125,
        1175.0,
        77.30587768554688
      ],
      "bbox_max": [
        -364.75,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34291166067123413,
        -0.34680986404418945,
        0.8730031847953796
      ],
      "plane_d": 459.7413635253906,
      "bbox_min": [
        -375.151611328125,
        1175.0,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1185.219970703125,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429098427295685,
        -0.3468110263347626,
        0.8730034232139587
      ],
      "plane_d": 209.54443359375,
      "bbox_min": [
        -373.08441162109375,
        1175.0,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1185.219970703125,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429108262062073,
        -0.3468044102191925,
        0.8730056285858154
      ],
      "plane_d": 455.4119567871094,
      "bbox_min": [
        -373.08441162109375,
        1175.0,
        88.40995788574219
      ],
      "bbox_max": [
        -364.75,
        1183.176025390625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429117500782013,
        -0.34680870175361633,
        0.8730036020278931
      ],
      "plane_d": 205.21852111816406,
      "bbox_min": [
        -364.8154296875,
        1175.0,
        88.40995788574219
      ],
      "bbox_max": [
        -364.75,
        1183.176025390625,
        91.68366241455078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291085600852966,
        -0.34680885076522827,
        0.8730038404464722
      ],
      "plane_d": 214.91290283203125,
      "bbox_min": [
        -364.75,
        1175.0,
        77.33158111572266
      ],
      "bbox_max": [
        -351.8951721191406,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429098427295685,
        -0.3468110263347626,
        0.8730034232139587
      ],
      "plane_d": 209.54443359375,
      "bbox_min": [
        -364.75,
        1175.0,
        83.4843978881836
      ],
      "bbox_max": [
        -354.479248046875,
        1185.219970703125,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429117500782013,
        -0.34680870175361633,
        0.8730036020278931
      ],
      "plane_d": 205.21852111816406,
      "bbox_min": [
        -364.75,
        1175.0,
        88.43566131591797
      ],
      "bbox_max": [
        -356.54644775390625,
        1183.176025390625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 364.75,
      "bbox_min": [
        -377.73565673828125,
        1140.0,
        65.0
      ],
      "bbox_max": [
        -329.5,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429112732410431,
        -0.3468084931373596,
        -0.8730038404464722
      ],
      "plane_d": 349.88897705078125,
      "bbox_min": [
        -377.73565673828125,
        1162.2249755859375,
        77.30587768554688
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34291085600852966,
        -0.34680885076522827,
        -0.8730038404464722
      ],
      "plane_d": 600.087890625,
      "bbox_min": [
        -375.151611328125,
        1162.2249755859375,
        77.30587768554688
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291166067123413,
        -0.34680986404418945,
        -0.8730031847953796
      ],
      "plane_d": 355.2618408203125,
      "bbox_min": [
        -375.151611328125,
        1164.780029296875,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429098427295685,
        -0.3468110263347626,
        -0.8730034232139587
      ],
      "plane_d": 605.4614868164062,
      "bbox_min": [
        -373.08441162109375,
        1164.780029296875,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429108262062073,
        -0.3468044102191925,
        -0.8730056285858154
      ],
      "plane_d": 359.5783996582031,
      "bbox_min": [
        -373.08441162109375,
        1166.823974609375,
        88.40995788574219
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429117500782013,
        -0.34680870175361633,
        -0.8730036020278931
      ],
      "plane_d": 609.7819213867188,
      "bbox_min": [
        -364.8154296875,
        1166.823974609375,
        88.40995788574219
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        91.68366241455078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34291085600852966,
        -0.34680885076522827,
        -0.8730038404464722
      ],
      "plane_d": 600.087890625,
      "bbox_min": [
        -364.75,
        1140.0,
        70.0
      ],
      "bbox_max": [
        -329.5,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429098427295685,
        -0.3468110263347626,
        -0.8730034232139587
      ],
      "plane_d": 605.4614868164062,
      "bbox_min": [
        -364.75,
        1164.780029296875,
        83.4843978881836
      ],
      "bbox_max": [
        -354.479248046875,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429117500782013,
        -0.34680870175361633,
        -0.8730036020278931
      ],
      "plane_d": 609.7819213867188,
      "bbox_min": [
        -364.75,
        1166.823974609375,
        88.43566131591797
      ],
      "bbox_max": [
        -356.54644775390625,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        -344.0,
        1140.0,
        70.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660255670547485,
        0.4999997019767761,
        -0.0
      ],
      "plane_d": -233.22239685058594,
      "bbox_min": [
        -514.4999389648438,
        1141.0794677734375,
        60.00611877441406
      ],
      "bbox_max": [
        -369.4998779296875,
        1210.361328125,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -514.4999389648438,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -399.4999694824219,
        1210.361328125,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -514.4999389648438,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -399.4999694824219,
        1210.361328125,
        320.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.24196197092533112,
        -0.4167741537094116,
        -0.8762155771255493
      ],
      "plane_d": 491.27337646484375,
      "bbox_min": [
        -513.3609008789062,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -399.4999694824219,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5110283493995667,
        0.8595638275146484,
        -0.0
      ],
      "plane_d": -776.1936645507812,
      "bbox_min": [
        -407.63079833984375,
        1145.0887451171875,
        128.45095825195312
      ],
      "bbox_max": [
        -407.18524169921875,
        1145.3536376953125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5020793676376343,
        -0.8648215532302856,
        0.0
      ],
      "plane_d": 781.2288818359375,
      "bbox_min": [
        -513.3609008789062,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -399.4999694824219,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9665453433990479,
        -0.25649577379226685,
        -0.0
      ],
      "plane_d": -124.28031921386719,
      "bbox_min": [
        -513.216064453125,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -399.4999694824219,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -417.67535400390625,
        1141.0794677734375,
        120.0
      ],
      "bbox_max": [
        -399.4999694824219,
        1158.6741943359375,
        128.45394897460938
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.5110283493995667,
        0.8595638275146484,
        -0.0
      ],
      "plane_d": -776.1936645507812,
      "bbox_min": [
        -407.63079833984375,
        1145.0887451171875,
        120.0
      ],
      "bbox_max": [
        -407.18524169921875,
        1145.3536376953125,
        128.45394897460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2564944922924042,
        -0.9665457010269165,
        0.0
      ],
      "plane_d": 1292.7418212890625,
      "bbox_min": [
        -513.216064453125,
        1156.1058349609375,
        95.0
      ],
      "bbox_max": [
        -435.38214111328125,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15747740864753723,
        -0.5934206247329712,
        -0.7893369793891907
      ],
      "plane_d": 888.4124755859375,
      "bbox_min": [
        -513.216064453125,
        1156.1058349609375,
        120.0
      ],
      "bbox_max": [
        -435.38214111328125,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5934202671051025,
        -0.1574781984090805,
        -0.7893370985984802
      ],
      "plane_d": 18.417329788208008,
      "bbox_min": [
        -452.6785583496094,
        1156.1058349609375,
        120.0
      ],
      "bbox_max": [
        -435.38214111328125,
        1183.44384765625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -513.3609008789062,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -409.4998474121094,
        1201.2930908203125,
        131.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -513.3609008789062,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -409.4998474121094,
        1201.2930908203125,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.41677308082580566,
        -0.24196134507656097,
        -0.8762162327766418
      ],
      "plane_d": 609.7070922851562,
      "bbox_min": [
        -513.3609008789062,
        1156.04345703125,
        120.0
      ],
      "bbox_max": [
        -435.38214111328125,
        1201.2930908203125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4167734682559967,
        0.24196158349514008,
        -0.8762159943580627
      ],
      "plane_d": -356.0429992675781,
      "bbox_min": [
        -452.7389221191406,
        1156.04345703125,
        120.0
      ],
      "bbox_max": [
        -435.38214111328125,
        1166.1474609375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648213148117065,
        -0.5020797848701477,
        0.0
      ],
      "plane_d": 1046.985107421875,
      "bbox_min": [
        -513.3609008789062,
        1201.0435791015625,
        95.0
      ],
      "bbox_max": [
        -513.216064453125,
        1201.2930908203125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660252690315247,
        0.5000002384185791,
        0.0
      ],
      "plane_d": -985.7991333007812,
      "bbox_min": [
        -514.4999389648438,
        1171.3902587890625,
        300.0
      ],
      "bbox_max": [
        -439.5000915527344,
        1210.361328125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 1046.42041015625,
      "bbox_min": [
        -514.4999389648438,
        1201.7012939453125,
        300.0
      ],
      "bbox_max": [
        -509.5000915527344,
        1210.361328125,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355278849601746,
        0.7071075439453125
      ],
      "plane_d": -221.48585510253906,
      "bbox_min": [
        -429.4999084472656,
        1158.39990234375,
        60.00611877441406
      ],
      "bbox_max": [
        -369.4998779296875,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 827.0648193359375,
      "bbox_min": [
        -399.5027770996094,
        1158.39990234375,
        80.0
      ],
      "bbox_max": [
        -369.4998779296875,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -396.4754638671875,
        1178.65625,
        120.0
      ],
      "bbox_max": [
        -369.4998779296875,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -387.8139953613281,
        1178.65625,
        120.0
      ],
      "bbox_max": [
        -369.4998779296875,
        1210.361328125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.900126576423645,
        -0.43562841415405273,
        0.0
      ],
      "plane_d": 271.16888427734375,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        402.0
      ],
      "bbox_max": [
        -248.16021728515625,
        1190.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 353.1321105957031,
      "bbox_min": [
        -250.66021728515625,
        1135.89697265625,
        402.0
      ],
      "bbox_max": [
        -248.16021728515625,
        1140.4095458984375,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 422.0,
      "bbox_min": [
        -250.66021728515625,
        1135.89697265625,
        422.0
      ],
      "bbox_max": [
        -248.16021728515625,
        1140.4095458984375,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1190.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        402.0
      ],
      "bbox_max": [
        -248.47630310058594,
        1190.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        402.0
      ],
      "bbox_max": [
        -248.47630310058594,
        1190.0,
        432.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1158.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        402.0
      ],
      "bbox_max": [
        -248.47630310058594,
        1160.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        -280.0,
        1158.0,
        402.0
      ],
      "bbox_max": [
        -280.0,
        1160.0,
        432.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -282.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        402.0
      ],
      "bbox_max": [
        -248.47630310058594,
        1158.0,
        432.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        -282.0,
        1130.4095458984375,
        402.0
      ],
      "bbox_max": [
        -248.47630310058594,
        1158.0,
        432.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -406.0,
      "bbox_min": [
        -282.0,
        1140.0,
        406.0
      ],
      "bbox_max": [
        -280.0,
        1150.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 410.0,
      "bbox_min": [
        -282.0,
        1140.0,
        406.0
      ],
      "bbox_max": [
        -280.0,
        1150.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1150.0,
      "bbox_min": [
        -282.0,
        1140.0,
        406.0
      ],
      "bbox_max": [
        -280.0,
        1150.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        -282.0,
        1140.0,
        406.0
      ],
      "bbox_max": [
        -280.0,
        1140.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999964237213135,
        0.8660256862640381,
        0.0
      ],
      "plane_d": -1112.9539794921875,
      "bbox_min": [
        -267.9807434082031,
        1130.4095458984375,
        422.0
      ],
      "bbox_max": [
        -248.47630310058594,
        1140.4095458984375,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 422.0,
      "bbox_min": [
        -267.9807434082031,
        1130.4095458984375,
        422.0
      ],
      "bbox_max": [
        -248.47630310058594,
        1140.4095458984375,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1152.0,
      "bbox_min": [
        -320.5,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -282.0,
        1158.0,
        412.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -405.5,
      "bbox_min": [
        -320.5,
        1152.0,
        402.0
      ],
      "bbox_max": [
        -282.0,
        1158.0,
        412.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 405.0,
      "bbox_min": [
        -320.5,
        1152.0,
        402.0
      ],
      "bbox_max": [
        -305.0,
        1158.0,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1154.0,
      "bbox_min": [
        -320.5,
        1152.0,
        405.0
      ],
      "bbox_max": [
        -305.0,
        1158.0,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -305.0,
      "bbox_min": [
        -305.0,
        1154.0,
        405.0
      ],
      "bbox_max": [
        -305.0,
        1158.0,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -305.0,
      "bbox_min": [
        -305.0,
        1152.0,
        405.0
      ],
      "bbox_max": [
        -305.0,
        1154.0,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -305.0,
      "bbox_min": [
        -305.0,
        1152.0,
        402.0
      ],
      "bbox_max": [
        -305.0,
        1158.0,
        405.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.24253565073013306,
        0.9701426029205322
      ],
      "plane_d": -118.84246826171875,
      "bbox_min": [
        -305.0,
        1152.0,
        410.0
      ],
      "bbox_max": [
        -297.5,
        1158.0,
        412.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 410.0,
      "bbox_min": [
        -305.0,
        1152.0,
        410.0
      ],
      "bbox_max": [
        -297.5,
        1158.0,
        412.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 297.5,
      "bbox_min": [
        -305.0,
        1152.0,
        410.0
      ],
      "bbox_max": [
        -297.5,
        1158.0,
        412.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -305.0,
      "bbox_min": [
        -305.0,
        1152.0,
        410.0
      ],
      "bbox_max": [
        -305.0,
        1158.0,
        412.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1135.0,
      "bbox_min": [
        -305.5,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -282.0,
        1143.5,
        409.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -287.0,
      "bbox_min": [
        -287.0,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -282.0,
        1135.0,
        409.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -409.0,
      "bbox_min": [
        -287.0,
        1130.5,
        409.0
      ],
      "bbox_max": [
        -282.0,
        1135.0,
        409.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 405.0,
      "bbox_min": [
        -305.5,
        1137.0,
        402.0
      ],
      "bbox_max": [
        -297.5,
        1143.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -405.5,
      "bbox_min": [
        -305.5,
        1137.0,
        405.0
      ],
      "bbox_max": [
        -297.5,
        1143.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1143.5,
      "bbox_min": [
        -305.5,
        1137.0,
        405.0
      ],
      "bbox_max": [
        -297.5,
        1143.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1137.0,
      "bbox_min": [
        -305.5,
        1137.0,
        405.0
      ],
      "bbox_max": [
        -297.5,
        1143.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 297.5,
      "bbox_min": [
        -305.5,
        1137.0,
        405.0
      ],
      "bbox_max": [
        -297.5,
        1143.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -305.5,
      "bbox_min": [
        -305.5,
        1137.0,
        405.0
      ],
      "bbox_max": [
        -305.5,
        1143.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8626818656921387,
        0.5057471394538879,
        0.0
      ],
      "plane_d": -837.2601318359375,
      "bbox_min": [
        -302.5,
        1139.5,
        402.0
      ],
      "bbox_max": [
        -300.5,
        1141.2369384765625,
        405.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1139.5,
      "bbox_min": [
        -302.5,
        1139.5,
        402.0
      ],
      "bbox_max": [
        -300.5,
        1141.2369384765625,
        405.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705688118934631,
        0.49204668402671814,
        0.0
      ],
      "plane_d": -299.0812683105469,
      "bbox_min": [
        -301.4817199707031,
        1139.5,
        402.0
      ],
      "bbox_max": [
        -300.5,
        1141.2369384765625,
        405.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -303.29998779296875,
      "bbox_min": [
        -320.5,
        1160.0,
        402.0
      ],
      "bbox_max": [
        -300.0,
        1182.0,
        407.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -303.29998779296875,
        1170.0,
        402.0
      ],
      "bbox_max": [
        -300.0,
        1182.0,
        407.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -404.0,
      "bbox_min": [
        -303.29998779296875,
        1170.0,
        402.0
      ],
      "bbox_max": [
        -300.0,
        1182.0,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        -303.29998779296875,
        1170.0,
        402.0
      ],
      "bbox_max": [
        -300.0,
        1182.0,
        404.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1182.0,
      "bbox_min": [
        -303.29998779296875,
        1182.0,
        402.0
      ],
      "bbox_max": [
        -300.0,
        1182.0,
        404.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -407.0,
      "bbox_min": [
        -303.29998779296875,
        1170.0,
        404.0
      ],
      "bbox_max": [
        -300.0,
        1182.0,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1171.0,
      "bbox_min": [
        -303.29998779296875,
        1170.0,
        404.0
      ],
      "bbox_max": [
        -300.0,
        1182.0,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1181.0,
      "bbox_min": [
        -303.29998779296875,
        1171.0,
        404.0
      ],
      "bbox_max": [
        -300.0,
        1182.0,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805746078491211,
        0.0,
        0.19614683091640472
      ],
      "plane_d": -374.78851318359375,
      "bbox_min": [
        -301.4000244140625,
        1171.0,
        404.0
      ],
      "bbox_max": [
        -300.7999267578125,
        1181.0,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -404.3999938964844,
      "bbox_min": [
        -303.29998779296875,
        1181.0,
        404.0
      ],
      "bbox_max": [
        -300.0,
        1182.0,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944681882858276,
        0.4471317231655121
      ],
      "plane_d": -1237.902587890625,
      "bbox_min": [
        -303.29998779296875,
        1181.0,
        404.0
      ],
      "bbox_max": [
        -300.0,
        1182.0,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944681882858276,
        0.4471317231655121
      ],
      "plane_d": 875.7257080078125,
      "bbox_min": [
        -303.29998779296875,
        1181.0,
        404.0
      ],
      "bbox_max": [
        -300.0,
        1181.199951171875,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -404.3999938964844,
      "bbox_min": [
        -303.29998779296875,
        1170.0,
        404.0
      ],
      "bbox_max": [
        -300.0,
        1171.0,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944681882858276,
        0.4471317231655121
      ],
      "plane_d": 865.8865966796875,
      "bbox_min": [
        -303.29998779296875,
        1170.0,
        404.0
      ],
      "bbox_max": [
        -300.0,
        1171.0,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -1228.0635986328125,
      "bbox_min": [
        -303.29998779296875,
        1170.800048828125,
        404.0
      ],
      "bbox_max": [
        -300.0,
        1171.0,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 404.0,
      "bbox_min": [
        -320.5,
        1160.0,
        402.0
      ],
      "bbox_max": [
        -310.0,
        1180.0,
        407.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        -320.5,
        1160.0,
        404.0
      ],
      "bbox_max": [
        -310.0,
        1180.0,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -404.5,
      "bbox_min": [
        -320.5,
        1170.0,
        404.0
      ],
      "bbox_max": [
        -310.0,
        1180.0,
        404.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        -320.5,
        1170.0,
        404.0
      ],
      "bbox_max": [
        -310.0,
        1180.0,
        404.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -310.0,
        1170.0,
        404.0
      ],
      "bbox_max": [
        -310.0,
        1180.0,
        404.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -407.0,
      "bbox_min": [
        -320.5,
        1160.0,
        404.0
      ],
      "bbox_max": [
        -314.0,
        1163.300048828125,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 315.0,
      "bbox_min": [
        -320.5,
        1160.0,
        404.0
      ],
      "bbox_max": [
        -314.0,
        1163.300048828125,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9805746078491211,
        0.19614683091640472
      ],
      "plane_d": -1218.0826416015625,
      "bbox_min": [
        -320.5,
        1160.7999267578125,
        404.0
      ],
      "bbox_max": [
        -315.0,
        1161.4000244140625,
        407.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -404.3999938964844,
      "bbox_min": [
        -315.0,
        1160.0,
        404.0
      ],
      "bbox_max": [
        -314.0,
        1163.300048828125,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944135308265686,
        -0.0,
        0.4472408890724182
      ],
      "plane_d": 100.16053771972656,
      "bbox_min": [
        -315.0,
        1160.0,
        404.0
      ],
      "bbox_max": [
        -314.0,
        1163.300048828125,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944135308265686,
        0.0,
        0.4472408890724182
      ],
      "plane_d": -462.42559814453125,
      "bbox_min": [
        -315.0,
        1160.0,
        404.0
      ],
      "bbox_max": [
        -314.0,
        1163.300048828125,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1163.300048828125,
      "bbox_min": [
        -315.0,
        1163.300048828125,
        404.0
      ],
      "bbox_max": [
        -314.0,
        1163.300048828125,
        404.3999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1163.300048828125,
      "bbox_min": [
        -320.5,
        1160.0,
        402.0
      ],
      "bbox_max": [
        -314.0,
        1178.0,
        404.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 314.0,
      "bbox_min": [
        -314.0,
        1160.0,
        402.0
      ],
      "bbox_max": [
        -314.0,
        1163.300048828125,
        404.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -320.5,
        1172.0,
        402.0
      ],
      "bbox_max": [
        -318.0,
        1178.0,
        404.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1172.0,
      "bbox_min": [
        -320.5,
        1172.0,
        402.0
      ],
      "bbox_max": [
        -318.0,
        1178.0,
        404.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1178.0,
      "bbox_min": [
        -320.5,
        1178.0,
        402.0
      ],
      "bbox_max": [
        -318.0,
        1178.0,
        404.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -239.49996948242188,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        95.0
      ],
      "bbox_max": [
        -239.54287719726562,
        1210.361328125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5455361604690552,
        -0.838087260723114,
        0.0
      ],
      "plane_d": 1087.0657958984375,
      "bbox_min": [
        -257.3829040527344,
        1140.2772216796875,
        95.0
      ],
      "bbox_max": [
        -239.54287719726562,
        1158.412353515625,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        -257.3829040527344,
        1144.0999755859375,
        110.0
      ],
      "bbox_max": [
        -244.0028076171875,
        1158.412353515625,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -239.54287719726562,
        1210.361328125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6844431757926941,
        -0.7290661931037903,
        -0.0
      ],
      "plane_d": 648.2664794921875,
      "bbox_min": [
        -310.0,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -239.54287719726562,
        1180.199951171875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5455361604690552,
        -0.838087260723114,
        0.0
      ],
      "plane_d": 1087.0657958984375,
      "bbox_min": [
        -240.8894805908203,
        1140.2772216796875,
        118.0
      ],
      "bbox_max": [
        -239.54287719726562,
        1141.15380859375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -1015.0970458984375,
      "bbox_min": [
        -305.1521911621094,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -297.93670654296875,
        1137.625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -310.0,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -261.195068359375,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866144061088562,
        -0.4997943639755249,
        0.0
      ],
      "plane_d": 352.86370849609375,
      "bbox_min": [
        -310.0,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -261.195068359375,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 1151.4305419921875,
      "bbox_min": [
        -269.847412109375,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -261.195068359375,
        1178.65625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -310.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.4000244140625,
      "bbox_min": [
        -310.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -310.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380874395370483,
        -0.5455358624458313,
        0.0
      ],
      "plane_d": 420.1756591796875,
      "bbox_min": [
        -320.5,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -240.8894805908203,
        1210.361328125,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.361328125,
      "bbox_min": [
        -320.5,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -272.26434326171875,
        1210.361328125,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        1200.361328125,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1210.361328125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1175.0,
      "bbox_min": [
        -320.5,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -272.26434326171875,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.25,
      "bbox_min": [
        -298.1048278808594,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -272.26434326171875,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291085600852966,
        -0.34680885076522827,
        0.8730038404464722
      ],
      "plane_d": 244.40170288085938,
      "bbox_min": [
        -285.25,
        1175.0,
        74.80587768554688
      ],
      "bbox_max": [
        -272.26434326171875,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429105877876282,
        -0.34680861234664917,
        0.8730040788650513
      ],
      "plane_d": 439.9870910644531,
      "bbox_min": [
        -285.25,
        1175.0,
        74.80587768554688
      ],
      "bbox_max": [
        -274.848388671875,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291136264801025,
        -0.34681081771850586,
        0.8730028867721558
      ],
      "plane_d": 239.03250122070312,
      "bbox_min": [
        -285.25,
        1175.0,
        80.95869445800781
      ],
      "bbox_max": [
        -274.848388671875,
        1185.219970703125,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34291166067123413,
        -0.34680986404418945,
        0.8730031847953796
      ],
      "plane_d": 434.61749267578125,
      "bbox_min": [
        -285.25,
        1175.0,
        80.95869445800781
      ],
      "bbox_max": [
        -276.91558837890625,
        1185.219970703125,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429136872291565,
        -0.34680843353271484,
        0.8730029463768005
      ],
      "plane_d": 234.70657348632812,
      "bbox_min": [
        -285.25,
        1175.0,
        85.90995788574219
      ],
      "bbox_max": [
        -276.91558837890625,
        1183.176025390625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429108262062073,
        -0.3468044102191925,
        0.8730056285858154
      ],
      "plane_d": 430.2881774902344,
      "bbox_min": [
        -285.25,
        1175.0,
        85.90995788574219
      ],
      "bbox_max": [
        -285.1845703125,
        1183.176025390625,
        89.18366241455078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429105877876282,
        -0.34680861234664917,
        0.8730040788650513
      ],
      "plane_d": 439.9870910644531,
      "bbox_min": [
        -298.1048278808594,
        1175.0,
        74.83158111572266
      ],
      "bbox_max": [
        -285.25,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34291166067123413,
        -0.34680986404418945,
        0.8730031847953796
      ],
      "plane_d": 434.61749267578125,
      "bbox_min": [
        -295.520751953125,
        1175.0,
        80.9843978881836
      ],
      "bbox_max": [
        -285.25,
        1185.219970703125,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429108262062073,
        -0.3468044102191925,
        0.8730056285858154
      ],
      "plane_d": 430.2881774902344,
      "bbox_min": [
        -293.45355224609375,
        1175.0,
        85.93566131591797
      ],
      "bbox_max": [
        -285.25,
        1183.176025390625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.25,
      "bbox_min": [
        -320.5,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -272.26434326171875,
        1175.0,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34291085600852966,
        -0.34680885076522827,
        -0.8730038404464722
      ],
      "plane_d": 570.59912109375,
      "bbox_min": [
        -285.25,
        1162.2249755859375,
        74.80587768554688
      ],
      "bbox_max": [
        -272.26434326171875,
        1175.0,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429105877876282,
        -0.34680861234664917,
        -0.8730040788650513
      ],
      "plane_d": 375.0131530761719,
      "bbox_min": [
        -285.25,
        1162.2249755859375,
        74.80587768554688
      ],
      "bbox_max": [
        -274.848388671875,
        1175.0,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34291136264801025,
        -0.34681081771850586,
        -0.8730028867721558
      ],
      "plane_d": 575.972900390625,
      "bbox_min": [
        -285.25,
        1164.780029296875,
        80.95869445800781
      ],
      "bbox_max": [
        -274.848388671875,
        1175.0,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291166067123413,
        -0.34680986404418945,
        -0.8730031847953796
      ],
      "plane_d": 380.38568115234375,
      "bbox_min": [
        -285.25,
        1164.780029296875,
        80.95869445800781
      ],
      "bbox_max": [
        -276.91558837890625,
        1175.0,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429136872291565,
        -0.34680843353271484,
        -0.8730029463768005
      ],
      "plane_d": 580.2932739257812,
      "bbox_min": [
        -285.25,
        1166.823974609375,
        85.90995788574219
      ],
      "bbox_max": [
        -276.91558837890625,
        1175.0,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429108262062073,
        -0.3468044102191925,
        -0.8730056285858154
      ],
      "plane_d": 384.7021789550781,
      "bbox_min": [
        -285.25,
        1166.823974609375,
        85.90995788574219
      ],
      "bbox_max": [
        -285.1845703125,
        1175.0,
        89.18366241455078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -320.5,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429105877876282,
        -0.34680861234664917,
        -0.8730040788650513
      ],
      "plane_d": 375.0131530761719,
      "bbox_min": [
        -320.5,
        1140.0,
        70.0
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291166067123413,
        -0.34680986404418945,
        -0.8730031847953796
      ],
      "plane_d": 380.38568115234375,
      "bbox_min": [
        -295.520751953125,
        1164.780029296875,
        80.9843978881836
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429108262062073,
        -0.3468044102191925,
        -0.8730056285858154
      ],
      "plane_d": 384.7021789550781,
      "bbox_min": [
        -293.45355224609375,
        1166.823974609375,
        85.93566131591797
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        -320.5,
        1140.0,
        70.0
      ],
      "bbox_max": [
        -306.0,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -279.5001220703125,
        1158.2647705078125,
        60.00611877441406
      ],
      "bbox_max": [
        -249.42201232910156,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6122787594795227,
        0.3534991443157196,
        0.7072150111198425
      ],
      "plane_d": -618.8341064453125,
      "bbox_min": [
        -261.0470275878906,
        1158.4000244140625,
        60.00611877441406
      ],
      "bbox_max": [
        -249.5,
        1178.4073486328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -274.516845703125,
        1178.65625,
        120.0
      ],
      "bbox_max": [
        -261.18597412109375,
        1201.738525390625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 1151.4305419921875,
      "bbox_min": [
        -261.195068359375,
        1178.65625,
        120.0
      ],
      "bbox_max": [
        -261.18597412109375,
        1178.6614990234375,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660251498222351,
        0.5000004768371582,
        0.0
      ],
      "plane_d": -795.2738647460938,
      "bbox_min": [
        -274.502197265625,
        1141.0794677734375,
        60.00611877441406
      ],
      "bbox_max": [
        -119.50043487548828,
        1210.361328125,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -249.50003051757812,
        1141.0794677734375,
        62.68523025512695
      ],
      "bbox_max": [
        -119.50043487548828,
        1210.361328125,
        422.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.49999964237213135,
        -0.8660256862640381,
        0.0
      ],
      "plane_d": 1117.9541015625,
      "bbox_min": [
        -235.83969116210938,
        1146.0794677734375,
        402.0
      ],
      "bbox_max": [
        -222.17942810058594,
        1159.73974609375,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -235.83969116210938,
        1146.0794677734375,
        402.0
      ],
      "bbox_max": [
        -222.17942810058594,
        1159.73974609375,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 422.0,
      "bbox_min": [
        -235.83969116210938,
        1146.0794677734375,
        422.0
      ],
      "bbox_max": [
        -222.17942810058594,
        1159.73974609375,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -250.0,
      "bbox_min": [
        -249.50003051757812,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -134.50001525878906,
        1210.361328125,
        320.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.26290374994277954,
        -0.4038907289505005,
        -0.8762156367301941
      ],
      "plane_d": 638.6624755859375,
      "bbox_min": [
        -249.50003051757812,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -136.8179473876953,
        1210.361328125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5455361604690552,
        -0.838087260723114,
        0.0
      ],
      "plane_d": 1087.0657958984375,
      "bbox_min": [
        -249.50003051757812,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -136.8179473876953,
        1210.361328125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20686259865760803,
        -0.9783700108528137,
        -0.0
      ],
      "plane_d": 1150.6346435546875,
      "bbox_min": [
        -249.50003051757812,
        1141.15380859375,
        95.0
      ],
      "bbox_max": [
        -140.31898498535156,
        1210.361328125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5444650053977966,
        -0.8387835621833801,
        0.0
      ],
      "plane_d": 1107.505126953125,
      "bbox_min": [
        -249.50003051757812,
        1141.15380859375,
        95.0
      ],
      "bbox_max": [
        -140.31898498535156,
        1210.361328125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783695936203003,
        -0.20686452090740204,
        0.0
      ],
      "plane_d": 450.3486022949219,
      "bbox_min": [
        -209.94268798828125,
        1184.0941162109375,
        95.0
      ],
      "bbox_max": [
        -209.80831909179688,
        1184.3157958984375,
        120.08821868896484
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6006800532341003,
        -0.1270068734884262,
        -0.7893369197845459
      ],
      "plane_d": 371.2169189453125,
      "bbox_min": [
        -209.94268798828125,
        1184.0941162109375,
        120.0
      ],
      "bbox_max": [
        -209.80831909179688,
        1184.3157958984375,
        120.08821868896484
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        -249.50003051757812,
        1141.15380859375,
        95.0
      ],
      "bbox_max": [
        -140.31898498535156,
        1210.361328125,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -249.50003051757812,
        1141.15380859375,
        120.0
      ],
      "bbox_max": [
        -239.5428924560547,
        1158.40478515625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12700533866882324,
        -0.600679874420166,
        -0.7893372774124146
      ],
      "plane_d": 801.1639404296875,
      "bbox_min": [
        -215.74685668945312,
        1156.643310546875,
        110.0
      ],
      "bbox_max": [
        -140.31898498535156,
        1210.361328125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783694744110107,
        -0.20686496794223785,
        0.0
      ],
      "plane_d": 450.34912109375,
      "bbox_min": [
        -215.74685668945312,
        1156.643310546875,
        110.0
      ],
      "bbox_max": [
        -209.94268798828125,
        1184.0941162109375,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9783695936203003,
        -0.20686452090740204,
        0.0
      ],
      "plane_d": 450.3486328125,
      "bbox_min": [
        -225.0891571044922,
        1156.643310546875,
        95.0
      ],
      "bbox_max": [
        -209.94268798828125,
        1184.0941162109375,
        110.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.39391928911209106,
        -0.9191450476646423,
        0.0
      ],
      "plane_d": 1167.984375,
      "bbox_min": [
        -225.0891571044922,
        1163.9810791015625,
        95.0
      ],
      "bbox_max": [
        -214.19537353515625,
        1178.0123291015625,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20686061680316925,
        0.9783704280853271,
        0.0
      ],
      "plane_d": -1094.49609375,
      "bbox_min": [
        -219.08721923828125,
        1163.9810791015625,
        95.0
      ],
      "bbox_max": [
        -214.19537353515625,
        1165.015380859375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -239.54290771484375,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -136.8179473876953,
        1205.7415771484375,
        131.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -239.54290771484375,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -136.8179473876953,
        1205.7415771484375,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4038896858692169,
        0.26290363073349,
        -0.8762161731719971
      ],
      "plane_d": -111.8018569946289,
      "bbox_min": [
        -215.74685668945312,
        1155.2987060546875,
        120.0
      ],
      "bbox_max": [
        -197.52635192871094,
        1167.5540771484375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380875587463379,
        -0.5455357432365417,
        0.0
      ],
      "plane_d": 540.175537109375,
      "bbox_min": [
        -140.31898498535156,
        1200.363037109375,
        95.0
      ],
      "bbox_max": [
        -136.8179473876953,
        1205.7415771484375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -209.49990844726562,
        1171.3902587890625,
        250.0
      ],
      "bbox_max": [
        -134.50001525878906,
        1210.361328125,
        320.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -209.49990844726562,
        1171.3902587890625,
        250.0
      ],
      "bbox_max": [
        -134.50001525878906,
        1210.361328125,
        270.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 484.36981201171875,
      "bbox_min": [
        -192.62744140625,
        1183.784423828125,
        250.0
      ],
      "bbox_max": [
        -134.50001525878906,
        1210.361328125,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 268.0,
      "bbox_min": [
        -192.62744140625,
        1183.784423828125,
        250.0
      ],
      "bbox_max": [
        -151.06922912597656,
        1200.404052734375,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.054927099496126175,
        -0.9984903931617737,
        0.0
      ],
      "plane_d": 1205.4071044921875,
      "bbox_min": [
        -180.120849609375,
        1191.0792236328125,
        268.0
      ],
      "bbox_max": [
        -152.89796447753906,
        1199.3240966796875,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660296201705933,
        -0.499992698431015,
        -0.0
      ],
      "plane_d": 443.6632995605469,
      "bbox_min": [
        -180.120849609375,
        1197.3826904296875,
        268.0
      ],
      "bbox_max": [
        -179.0,
        1199.3240966796875,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6597175598144531,
        -0.7515136003494263,
        -0.0
      ],
      "plane_d": 794.2427368164062,
      "bbox_min": [
        -161.1943359375,
        1191.0792236328125,
        268.0
      ],
      "bbox_max": [
        -152.89796447753906,
        1198.3621826171875,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -253.0,
      "bbox_min": [
        -192.62744140625,
        1183.784423828125,
        250.0
      ],
      "bbox_max": [
        -187.97265625,
        1187.8154296875,
        262.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542450070381165,
        -0.49318787455558777,
        -0.16441157460212708
      ],
      "plane_d": 461.8673095703125,
      "bbox_min": [
        -192.62744140625,
        1183.784423828125,
        250.0
      ],
      "bbox_max": [
        -187.97265625,
        1187.8154296875,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": 786.9920654296875,
      "bbox_min": [
        -192.62744140625,
        1183.784423828125,
        250.0
      ],
      "bbox_max": [
        -187.97265625,
        1187.8154296875,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": 1209.270751953125,
      "bbox_min": [
        -192.62744140625,
        1183.784423828125,
        250.0
      ],
      "bbox_max": [
        -187.97265625,
        1187.8154296875,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": -1130.06103515625,
      "bbox_min": [
        -192.62744140625,
        1185.800048828125,
        250.0
      ],
      "bbox_max": [
        -187.97265625,
        1187.8154296875,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -382.7109069824219,
      "bbox_min": [
        -192.62744140625,
        1185.800048828125,
        250.0
      ],
      "bbox_max": [
        -187.97265625,
        1187.8154296875,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542195558547974,
        0.4932328760623932,
        -0.1644088178873062
      ],
      "plane_d": -707.8262939453125,
      "bbox_min": [
        -192.62744140625,
        1185.800048828125,
        250.0
      ],
      "bbox_max": [
        -191.175048828125,
        1187.8154296875,
        253.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -703.8748779296875,
      "bbox_min": [
        -192.0853271484375,
        1184.145263671875,
        253.0
      ],
      "bbox_max": [
        -188.62060546875,
        1187.53955078125,
        262.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 973.0921630859375,
      "bbox_min": [
        -192.0853271484375,
        1184.145263671875,
        253.0
      ],
      "bbox_max": [
        -188.691162109375,
        1187.53955078125,
        262.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.010574648156762123,
        0.861408531665802
      ],
      "plane_d": -302.91998291015625,
      "bbox_min": [
        -192.0853271484375,
        1184.1455078125,
        253.0
      ],
      "bbox_max": [
        -190.3529052734375,
        1187.53955078125,
        254.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 393.7807312011719,
      "bbox_min": [
        -192.0146484375,
        1184.145263671875,
        253.0
      ],
      "bbox_max": [
        -188.691162109375,
        1185.80712890625,
        254.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 973.0921630859375,
      "bbox_min": [
        -192.0853271484375,
        1184.145263671875,
        253.0
      ],
      "bbox_max": [
        -188.62060546875,
        1187.53955078125,
        262.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -812.79052734375,
      "bbox_min": [
        -192.0853271484375,
        1185.80712890625,
        253.0
      ],
      "bbox_max": [
        -188.62060546875,
        1187.53955078125,
        254.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -109.6145248413086,
      "bbox_min": [
        -190.3529052734375,
        1184.145263671875,
        253.0
      ],
      "bbox_max": [
        -188.62060546875,
        1187.53955078125,
        254.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5000000596046448,
        -0.0
      ],
      "plane_d": -423.7485046386719,
      "bbox_min": [
        -209.49990844726562,
        1171.3902587890625,
        300.0
      ],
      "bbox_max": [
        -134.50001525878906,
        1210.361328125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 484.36981201171875,
      "bbox_min": [
        -192.62744140625,
        1183.784423828125,
        300.0
      ],
      "bbox_max": [
        -134.50001525878906,
        1210.361328125,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.05492633581161499,
        0.9984903931617737,
        0.0
      ],
      "plane_d": -1207.406982421875,
      "bbox_min": [
        -192.62744140625,
        1183.784423828125,
        300.0
      ],
      "bbox_max": [
        -151.06922912597656,
        1200.404052734375,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -192.62744140625,
        1183.784423828125,
        300.0
      ],
      "bbox_max": [
        -151.06922912597656,
        1200.404052734375,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.054927099496126175,
        -0.9984903931617737,
        0.0
      ],
      "plane_d": 1205.4071044921875,
      "bbox_min": [
        -180.120849609375,
        1191.0792236328125,
        318.0
      ],
      "bbox_max": [
        -151.06922912597656,
        1200.404052734375,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6597223877906799,
        0.7515093684196472,
        -0.0
      ],
      "plane_d": -796.2369384765625,
      "bbox_min": [
        -180.120849609375,
        1197.3826904296875,
        318.0
      ],
      "bbox_max": [
        -158.34146118164062,
        1200.404052734375,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660296201705933,
        -0.499992698431015,
        -0.0
      ],
      "plane_d": 443.6632995605469,
      "bbox_min": [
        -180.120849609375,
        1197.3826904296875,
        318.0
      ],
      "bbox_max": [
        -179.0,
        1199.3240966796875,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6597175598144531,
        -0.7515136003494263,
        -0.0
      ],
      "plane_d": 794.2427368164062,
      "bbox_min": [
        -161.1943359375,
        1191.0792236328125,
        318.0
      ],
      "bbox_max": [
        -151.06922912597656,
        1198.5191650390625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6597223877906799,
        0.7515093684196472,
        -0.0
      ],
      "plane_d": -796.2369384765625,
      "bbox_min": [
        -158.34146118164062,
        1192.1351318359375,
        318.0
      ],
      "bbox_max": [
        -151.06922912597656,
        1198.5191650390625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -303.0,
      "bbox_min": [
        -192.62744140625,
        1183.784423828125,
        300.0
      ],
      "bbox_max": [
        -187.97265625,
        1187.8154296875,
        312.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542450070381165,
        -0.49318787455558777,
        -0.16441157460212708
      ],
      "plane_d": 470.087890625,
      "bbox_min": [
        -192.62744140625,
        1183.784423828125,
        300.0
      ],
      "bbox_max": [
        -187.97265625,
        1187.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": 795.2122802734375,
      "bbox_min": [
        -192.62744140625,
        1183.784423828125,
        300.0
      ],
      "bbox_max": [
        -187.97265625,
        1187.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": 1217.49072265625,
      "bbox_min": [
        -192.62744140625,
        1183.784423828125,
        300.0
      ],
      "bbox_max": [
        -187.97265625,
        1187.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": -1121.841064453125,
      "bbox_min": [
        -192.62744140625,
        1185.800048828125,
        300.0
      ],
      "bbox_max": [
        -187.97265625,
        1187.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -374.4905700683594,
      "bbox_min": [
        -192.62744140625,
        1185.800048828125,
        300.0
      ],
      "bbox_max": [
        -187.97265625,
        1187.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542195558547974,
        0.4932328760623932,
        -0.1644088178873062
      ],
      "plane_d": -699.6058349609375,
      "bbox_min": [
        -192.62744140625,
        1185.800048828125,
        300.0
      ],
      "bbox_max": [
        -191.175048828125,
        1187.8154296875,
        303.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -703.8748779296875,
      "bbox_min": [
        -192.0853271484375,
        1184.145263671875,
        303.0
      ],
      "bbox_max": [
        -188.62060546875,
        1187.53955078125,
        312.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 973.0921630859375,
      "bbox_min": [
        -192.0853271484375,
        1184.145263671875,
        303.0
      ],
      "bbox_max": [
        -188.691162109375,
        1187.53955078125,
        312.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.010574648156762123,
        0.861408531665802
      ],
      "plane_d": -345.9903869628906,
      "bbox_min": [
        -192.0853271484375,
        1184.1455078125,
        303.0
      ],
      "bbox_max": [
        -190.3529052734375,
        1187.53955078125,
        304.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 350.9397277832031,
      "bbox_min": [
        -192.0146484375,
        1184.145263671875,
        303.0
      ],
      "bbox_max": [
        -188.691162109375,
        1185.80712890625,
        304.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 973.0921630859375,
      "bbox_min": [
        -192.0853271484375,
        1184.145263671875,
        303.0
      ],
      "bbox_max": [
        -188.62060546875,
        1187.53955078125,
        312.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -856.0941162109375,
      "bbox_min": [
        -192.0853271484375,
        1185.80712890625,
        303.0
      ],
      "bbox_max": [
        -188.62060546875,
        1187.53955078125,
        304.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -152.68458557128906,
      "bbox_min": [
        -190.3529052734375,
        1184.145263671875,
        303.0
      ],
      "bbox_max": [
        -188.62060546875,
        1187.53955078125,
        304.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122787594795227,
        0.3534991443157196,
        0.7072150111198425
      ],
      "plane_d": -618.8341064453125,
      "bbox_min": [
        -274.502197265625,
        1158.4000244140625,
        60.00611877441406
      ],
      "bbox_max": [
        -219.50009155273438,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -274.502197265625,
        1178.6612548828125,
        120.0
      ],
      "bbox_max": [
        -252.5245361328125,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -262.07373046875,
        1178.6612548828125,
        120.0
      ],
      "bbox_max": [
        -261.18597412109375,
        1180.199951171875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -261.186279296875,
        1158.4000244140625,
        95.0
      ],
      "bbox_max": [
        -249.484375,
        1178.6614990234375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5444650053977966,
        -0.8387835621833801,
        0.0
      ],
      "plane_d": 1107.505126953125,
      "bbox_min": [
        -249.50714111328125,
        1158.4000244140625,
        95.0
      ],
      "bbox_max": [
        -249.484375,
        1158.4271240234375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9700985550880432,
        -0.2427113950252533,
        0.0
      ],
      "plane_d": 924.297119140625,
      "bbox_min": [
        -625.0554809570312,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -299.5,
        1430.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9863939881324768,
        -0.0,
        0.16439899802207947
      ],
      "plane_d": 512.9248657226562,
      "bbox_min": [
        -550.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -299.5,
        1430.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9863938689231873,
        0.16439898312091827
      ],
      "plane_d": 1380.951416015625,
      "bbox_min": [
        -540.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -299.5,
        1430.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -540.0,
        1420.0,
        120.0
      ],
      "bbox_max": [
        -400.42303466796875,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -918.5513916015625,
      "bbox_min": [
        -516.0469970703125,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -299.5,
        1270.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -422.9655456542969,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1239.02783203125,
        60.02788162231445
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355278849601746,
        0.7071075439453125
      ],
      "plane_d": -221.48585510253906,
      "bbox_min": [
        -422.9655456542969,
        1239.0,
        60.00611877441406
      ],
      "bbox_max": [
        -422.9404602050781,
        1239.021728515625,
        60.02784729003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1239.02783203125,
        60.02788162231445
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -310.0,
        1239.0,
        125.0
      ],
      "bbox_max": [
        -299.5,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -350.5,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -350.5,
        1239.0,
        125.0
      ],
      "bbox_max": [
        -340.0,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -340.0,
        1239.0,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        85.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -85.0,
      "bbox_min": [
        -340.0,
        1239.0,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1240.0,
        85.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        -335.0,
        1240.0,
        65.0
      ],
      "bbox_max": [
        -315.0,
        1240.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660255670547485,
        0.4999997019767761,
        -0.0
      ],
      "plane_d": -233.22239685058594,
      "bbox_min": [
        -516.034423828125,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1239.0,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -918.5513916015625,
      "bbox_min": [
        -516.034423828125,
        1210.361328125,
        60.02784729003906
      ],
      "bbox_max": [
        -434.5,
        1239.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1219.021728515625,
      "bbox_min": [
        -509.5000915527344,
        1210.361328125,
        300.0
      ],
      "bbox_max": [
        -434.5,
        1219.021728515625,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -509.5000915527344,
        1210.361328125,
        300.0
      ],
      "bbox_max": [
        -434.5,
        1219.021728515625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -509.5000915527344,
        1210.361328125,
        300.0
      ],
      "bbox_max": [
        -434.5,
        1219.021728515625,
        320.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 302.0,
      "bbox_min": [
        -509.5000915527344,
        1210.361328125,
        300.0
      ],
      "bbox_max": [
        -434.5,
        1219.021728515625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -302.5,
      "bbox_min": [
        -509.5000915527344,
        1210.361328125,
        302.0
      ],
      "bbox_max": [
        -434.5,
        1219.021728515625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -509.5000915527344,
        1210.361328125,
        302.0
      ],
      "bbox_max": [
        -434.5,
        1219.021728515625,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 1046.42041015625,
      "bbox_min": [
        -506.82196044921875,
        1215.0,
        302.0
      ],
      "bbox_max": [
        -434.5,
        1219.021728515625,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660252690315247,
        0.5000002384185791,
        0.0
      ],
      "plane_d": -985.7991333007812,
      "bbox_min": [
        -484.0,
        1215.0,
        302.0
      ],
      "bbox_max": [
        -434.5,
        1219.021728515625,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 459.0,
      "bbox_min": [
        -484.0,
        1215.0,
        302.0
      ],
      "bbox_max": [
        -459.0,
        1219.0,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -484.0,
      "bbox_min": [
        -484.0,
        1215.0,
        302.0
      ],
      "bbox_max": [
        -484.0,
        1219.0,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 1046.42041015625,
      "bbox_min": [
        -509.5000915527344,
        1210.361328125,
        302.0
      ],
      "bbox_max": [
        -436.82196044921875,
        1215.0,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660252690315247,
        0.5000002384185791,
        0.0
      ],
      "plane_d": -985.7991333007812,
      "bbox_min": [
        -439.5000915527344,
        1210.361328125,
        302.0
      ],
      "bbox_max": [
        -436.82196044921875,
        1215.0,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660252690315247,
        0.5000002384185791,
        0.0
      ],
      "plane_d": -985.7991333007812,
      "bbox_min": [
        -509.5000915527344,
        1210.361328125,
        302.5
      ],
      "bbox_max": [
        -434.5,
        1219.021728515625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 1046.42041015625,
      "bbox_min": [
        -509.5000915527344,
        1210.361328125,
        302.5
      ],
      "bbox_max": [
        -504.5,
        1219.021728515625,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660252690315247,
        0.5000002384185791,
        0.0
      ],
      "plane_d": -985.7991333007812,
      "bbox_min": [
        -480.0,
        1210.361328125,
        300.0
      ],
      "bbox_max": [
        -434.5,
        1219.021728515625,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 463.0,
      "bbox_min": [
        -464.0,
        1215.0,
        300.0
      ],
      "bbox_max": [
        -463.0,
        1219.0,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -464.0,
        1215.0,
        300.0
      ],
      "bbox_max": [
        -463.0,
        1215.0,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        -480.0,
        1215.0,
        300.0
      ],
      "bbox_max": [
        -479.0,
        1219.0,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 479.0,
      "bbox_min": [
        -480.0,
        1215.0,
        300.0
      ],
      "bbox_max": [
        -479.0,
        1219.0,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -480.0,
        1215.0,
        300.0
      ],
      "bbox_max": [
        -479.0,
        1215.0,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -446.0344543457031,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1239.0,
        125.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355278849601746,
        0.7071075439453125
      ],
      "plane_d": -221.48585510253906,
      "bbox_min": [
        -446.0344543457031,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1239.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -918.5513916015625,
      "bbox_min": [
        -446.0344543457031,
        1219.021728515625,
        60.02784729003906
      ],
      "bbox_max": [
        -422.9655456542969,
        1239.0,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -369.522216796875,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1230.0,
      "bbox_min": [
        -355.0,
        1230.0,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1230.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -355.0,
        1210.361328125,
        125.0
      ],
      "bbox_max": [
        -340.0,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1239.0,
        125.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -310.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1239.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1230.0,
      "bbox_min": [
        -310.0,
        1230.0,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1230.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -310.0,
        1210.361328125,
        125.0
      ],
      "bbox_max": [
        -295.0,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -85.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1239.0,
        118.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        -340.0,
        1235.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1239.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -340.0,
        1235.0,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1239.0,
        65.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        100.0
      ],
      "bbox_max": [
        -310.0,
        1230.0,
        118.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        118.0
      ],
      "bbox_max": [
        -310.0,
        1210.4000244140625,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        -406.1922912597656,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -400.42303466796875,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -50.843994140625,
        1430.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -350.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -350.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -350.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9863938689231873,
        0.0,
        0.16439898312091827
      ],
      "plane_d": -78.91150665283203,
      "bbox_min": [
        -313.88458251953125,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -50.843994140625,
        1420.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -70.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -50.843994140625,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7069985866546631,
        0.7072149515151978
      ],
      "plane_d": -918.423828125,
      "bbox_min": [
        -313.88458251953125,
        1239.0,
        60.00611877441406
      ],
      "bbox_max": [
        -132.94044494628906,
        1270.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122788786888123,
        0.35349905490875244,
        0.7072149515151978
      ],
      "plane_d": -399.02593994140625,
      "bbox_min": [
        -226.05955505371094,
        1239.0,
        60.00611877441406
      ],
      "bbox_max": [
        -132.94044494628906,
        1239.021728515625,
        60.02783966064453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122787594795227,
        0.3534991443157196,
        0.7072150111198425
      ],
      "plane_d": -618.8341064453125,
      "bbox_min": [
        -226.05955505371094,
        1239.0,
        60.00611877441406
      ],
      "bbox_max": [
        -226.0344696044922,
        1239.021728515625,
        60.02783966064453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -313.88458251953125,
        1263.2667236328125,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660251498222351,
        0.5000004768371582,
        0.0
      ],
      "plane_d": -795.2738647460938,
      "bbox_min": [
        -242.59410095214844,
        1210.361328125,
        60.00611877441406
      ],
      "bbox_max": [
        -117.17955017089844,
        1239.0,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.7069985866546631,
        0.7072149515151978
      ],
      "plane_d": -918.423828125,
      "bbox_min": [
        -214.5,
        1210.361328125,
        60.00611877441406
      ],
      "bbox_max": [
        -117.17955017089844,
        1239.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122788786888123,
        0.35349905490875244,
        0.7072149515151978
      ],
      "plane_d": -399.02593994140625,
      "bbox_min": [
        -144.5,
        1210.361328125,
        60.00611877441406
      ],
      "bbox_max": [
        -117.17955017089844,
        1239.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -214.5,
        1210.361328125,
        95.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -214.5,
        1210.361328125,
        95.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        320.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -214.5,
        1210.361328125,
        300.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        320.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1219.021728515625,
      "bbox_min": [
        -214.5,
        1210.361328125,
        300.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        320.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 302.0,
      "bbox_min": [
        -214.5,
        1210.361328125,
        300.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -302.5,
      "bbox_min": [
        -214.5,
        1210.361328125,
        302.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -214.5,
        1210.361328125,
        302.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660255670547485,
        -0.4999997019767761,
        -0.0
      ],
      "plane_d": 484.36981201171875,
      "bbox_min": [
        -214.5,
        1215.0,
        302.0
      ],
      "bbox_max": [
        -142.1780548095703,
        1219.021728515625,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5000000596046448,
        -0.0
      ],
      "plane_d": -423.7485046386719,
      "bbox_min": [
        -214.5,
        1215.0,
        302.0
      ],
      "bbox_max": [
        -165.0,
        1219.021728515625,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 165.0,
      "bbox_min": [
        -190.0,
        1215.0,
        302.0
      ],
      "bbox_max": [
        -165.0,
        1219.0,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        -190.0,
        1215.0,
        302.0
      ],
      "bbox_max": [
        -190.0,
        1219.0,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660255670547485,
        -0.4999997019767761,
        -0.0
      ],
      "plane_d": 484.36981201171875,
      "bbox_min": [
        -212.1780548095703,
        1210.361328125,
        302.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1215.0,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5000000596046448,
        -0.0
      ],
      "plane_d": -423.7485046386719,
      "bbox_min": [
        -212.1780548095703,
        1210.361328125,
        302.0
      ],
      "bbox_max": [
        -209.49990844726562,
        1215.0,
        302.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5000000596046448,
        -0.0
      ],
      "plane_d": -423.7485046386719,
      "bbox_min": [
        -214.5,
        1210.361328125,
        302.5
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 484.36981201171875,
      "bbox_min": [
        -144.5,
        1210.361328125,
        302.5
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5000000596046448,
        -0.0
      ],
      "plane_d": -423.7485046386719,
      "bbox_min": [
        -214.5,
        1210.361328125,
        300.0
      ],
      "bbox_max": [
        -169.0,
        1219.021728515625,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -186.0,
      "bbox_min": [
        -186.0,
        1215.0,
        300.0
      ],
      "bbox_max": [
        -185.0,
        1219.0,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -186.0,
        1215.0,
        300.0
      ],
      "bbox_max": [
        -185.0,
        1215.0,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 169.0,
      "bbox_min": [
        -170.0,
        1215.0,
        300.0
      ],
      "bbox_max": [
        -169.0,
        1219.0,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        -170.0,
        1215.0,
        300.0
      ],
      "bbox_max": [
        -169.0,
        1219.0,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -170.0,
        1215.0,
        300.0
      ],
      "bbox_max": [
        -169.0,
        1215.0,
        302.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -250.0,
      "bbox_min": [
        -214.5,
        1210.361328125,
        95.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        270.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.20686259865760803,
        -0.9783700108528137,
        -0.0
      ],
      "plane_d": 1150.6346435546875,
      "bbox_min": [
        -169.88290405273438,
        1210.361328125,
        95.0
      ],
      "bbox_max": [
        -162.16839599609375,
        1211.592529296875,
        120.8079833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5455349087715149,
        -0.8380880951881409,
        0.0
      ],
      "plane_d": 1107.0665283203125,
      "bbox_min": [
        -169.88290405273438,
        1210.361328125,
        95.0
      ],
      "bbox_max": [
        -162.16839599609375,
        1211.592529296875,
        120.8079833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -169.88290405273438,
        1210.361328125,
        95.0
      ],
      "bbox_max": [
        -162.16839599609375,
        1211.592529296875,
        120.8079833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12700533866882324,
        -0.600679874420166,
        -0.7893372774124146
      ],
      "plane_d": 801.1639404296875,
      "bbox_min": [
        -169.88290405273438,
        1210.361328125,
        120.0
      ],
      "bbox_max": [
        -162.16839599609375,
        1211.592529296875,
        120.8079833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26290374994277954,
        -0.4038907289505005,
        -0.8762156367301941
      ],
      "plane_d": 638.6624755859375,
      "bbox_min": [
        -169.88290405273438,
        1210.361328125,
        120.0
      ],
      "bbox_max": [
        -167.1900177001953,
        1211.592529296875,
        120.8079833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1219.021728515625,
      "bbox_min": [
        -214.5,
        1210.361328125,
        250.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        270.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 252.0,
      "bbox_min": [
        -214.5,
        1210.361328125,
        250.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -252.5,
      "bbox_min": [
        -214.5,
        1210.361328125,
        252.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -214.5,
        1210.361328125,
        252.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        252.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660255670547485,
        -0.4999997019767761,
        -0.0
      ],
      "plane_d": 484.36981201171875,
      "bbox_min": [
        -214.5,
        1215.0,
        252.0
      ],
      "bbox_max": [
        -142.1780548095703,
        1219.021728515625,
        252.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5000000596046448,
        -0.0
      ],
      "plane_d": -423.7485046386719,
      "bbox_min": [
        -214.5,
        1215.0,
        252.0
      ],
      "bbox_max": [
        -165.0,
        1219.021728515625,
        252.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 165.0,
      "bbox_min": [
        -190.0,
        1215.0,
        252.0
      ],
      "bbox_max": [
        -165.0,
        1219.0,
        252.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        -190.0,
        1215.0,
        252.0
      ],
      "bbox_max": [
        -190.0,
        1219.0,
        252.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660255670547485,
        -0.4999997019767761,
        -0.0
      ],
      "plane_d": 484.36981201171875,
      "bbox_min": [
        -212.1780548095703,
        1210.361328125,
        252.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1215.0,
        252.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5000000596046448,
        -0.0
      ],
      "plane_d": -423.7485046386719,
      "bbox_min": [
        -212.1780548095703,
        1210.361328125,
        252.0
      ],
      "bbox_max": [
        -209.49990844726562,
        1215.0,
        252.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5000000596046448,
        -0.0
      ],
      "plane_d": -423.7485046386719,
      "bbox_min": [
        -214.5,
        1210.361328125,
        252.5
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660255670547485,
        -0.4999997019767761,
        0.0
      ],
      "plane_d": 484.36981201171875,
      "bbox_min": [
        -144.5,
        1210.361328125,
        252.5
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5000000596046448,
        -0.0
      ],
      "plane_d": -423.7485046386719,
      "bbox_min": [
        -214.5,
        1210.361328125,
        250.0
      ],
      "bbox_max": [
        -169.0,
        1219.021728515625,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -186.0,
      "bbox_min": [
        -186.0,
        1215.0,
        250.0
      ],
      "bbox_max": [
        -185.0,
        1219.0,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -186.0,
        1215.0,
        250.0
      ],
      "bbox_max": [
        -185.0,
        1215.0,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 169.0,
      "bbox_min": [
        -170.0,
        1215.0,
        250.0
      ],
      "bbox_max": [
        -169.0,
        1219.0,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        -170.0,
        1215.0,
        250.0
      ],
      "bbox_max": [
        -169.0,
        1219.0,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        -170.0,
        1215.0,
        250.0
      ],
      "bbox_max": [
        -169.0,
        1215.0,
        252.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122787594795227,
        0.3534991443157196,
        0.7072150111198425
      ],
      "plane_d": -618.8341064453125,
      "bbox_min": [
        -242.59410095214844,
        1210.361328125,
        60.00611877441406
      ],
      "bbox_max": [
        -202.96554565429688,
        1239.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7069985866546631,
        0.7072149515151978
      ],
      "plane_d": -918.423828125,
      "bbox_min": [
        -226.0344696044922,
        1219.021728515625,
        60.02783966064453
      ],
      "bbox_max": [
        -202.96554565429688,
        1239.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 180.0,
      "bbox_min": [
        120.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        190.0,
        1500.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        180.0,
        820.0,
        120.0
      ],
      "bbox_max": [
        190.0,
        1500.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -303.1000061035156,
      "bbox_min": [
        183.3708953857422,
        820.0,
        120.0
      ],
      "bbox_max": [
        190.0,
        829.921142578125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -303.1000061035156,
      "bbox_min": [
        183.3708953857422,
        820.0,
        130.0
      ],
      "bbox_max": [
        190.0,
        829.921142578125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        120.0,
        1490.0,
        60.0
      ],
      "bbox_max": [
        120.01652526855469,
        1490.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        190.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1703.2535400390625,
        420.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        190.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1703.2535400390625,
        340.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.8314701318740845,
        0.5555695295333862,
        0.0
      ],
      "plane_d": -674.9655151367188,
      "bbox_min": [
        190.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        377.2901611328125,
        1703.2535400390625,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9797557592391968,
        0.2001969814300537,
        0.0
      ],
      "plane_d": -75.3988037109375,
      "bbox_min": [
        190.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        377.2901611328125,
        1703.2535400390625,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999943971633911,
        0.003364049829542637,
        0.0
      ],
      "plane_d": 225.0872039794922,
      "bbox_min": [
        221.37026977539062,
        1460.0,
        120.0
      ],
      "bbox_max": [
        377.2901611328125,
        1703.2535400390625,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903832912445,
        0.0
      ],
      "plane_d": -37.63140869140625,
      "bbox_min": [
        230.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        377.2901611328125,
        1703.2535400390625,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314698934555054,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -645.5426635742188,
      "bbox_min": [
        252.04348754882812,
        1460.0,
        140.0
      ],
      "bbox_max": [
        377.2901611328125,
        1703.2535400390625,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        252.04348754882812,
        1460.0,
        140.0
      ],
      "bbox_max": [
        377.2901611328125,
        1703.2535400390625,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        252.04348754882812,
        1460.0,
        140.0
      ],
      "bbox_max": [
        260.0,
        1500.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        274.462890625,
        1572.7098388671875,
        240.0
      ],
      "bbox_max": [
        358.3660888671875,
        1698.2799072265625,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        250.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        274.462890625,
        1576.6116943359375,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 250.0,
      "bbox_min": [
        250.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        250.0,
        1500.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        221.37026977539062,
        1460.0,
        120.0
      ],
      "bbox_max": [
        230.14447021484375,
        1502.9405517578125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        190.0,
        1460.0,
        130.0
      ],
      "bbox_max": [
        200.0,
        1500.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        190.0,
        1499.262939453125,
        120.0
      ],
      "bbox_max": [
        246.7465362548828,
        1596.1207275390625,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        190.0,
        1499.262939453125,
        130.0
      ],
      "bbox_max": [
        190.4924774169922,
        1500.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        190.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        270.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1415.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        400.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        450.0,
        1415.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 250.0,
      "bbox_min": [
        190.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        300.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        250.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        300.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        270.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        270.0,
        1415.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        270.0,
        1310.0,
        140.0
      ],
      "bbox_max": [
        300.0,
        1460.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        300.0,
        1415.0,
        190.0
      ],
      "bbox_max": [
        300.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        190.0,
        1310.0,
        130.0
      ],
      "bbox_max": [
        200.0,
        1460.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        190.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1310.0,
        420.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 440.0,
      "bbox_min": [
        250.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1310.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        440.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1110.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        440.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        440.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        440.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        250.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        440.0,
        1310.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        260.0,
        921.8181762695312,
        60.0
      ],
      "bbox_max": [
        440.0,
        1310.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        270.0,
        1300.0,
        120.0
      ],
      "bbox_max": [
        270.0,
        1310.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        260.0,
        921.8181762695312,
        60.0
      ],
      "bbox_max": [
        440.0,
        1000.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        350.0,
        921.8181762695312,
        60.0
      ],
      "bbox_max": [
        440.0,
        930.0,
        76.36363983154297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        260.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        260.0,
        1000.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        260.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        260.0,
        1000.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        250.0,
        949.7266235351562,
        120.0
      ],
      "bbox_max": [
        310.0,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        250.0,
        949.7266235351562,
        120.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9804636240005493,
        0.19670069217681885,
        0.0
      ],
      "plane_d": 48.41522216796875,
      "bbox_min": [
        190.0,
        820.0,
        120.0
      ],
      "bbox_max": [
        250.0,
        1000.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        221.82235717773438,
        859.5471801757812,
        120.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -303.1000061035156,
      "bbox_min": [
        190.0,
        820.0,
        120.0
      ],
      "bbox_max": [
        226.98284912109375,
        885.2699584960938,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        195.3977813720703,
        820.0,
        120.0
      ],
      "bbox_max": [
        221.82235717773438,
        859.5471801757812,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9804636240005493,
        0.19670069217681885,
        0.0
      ],
      "plane_d": 48.41522216796875,
      "bbox_min": [
        190.0,
        820.0,
        130.0
      ],
      "bbox_max": [
        250.0,
        1000.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        221.82235717773438,
        859.5471801757812,
        130.0
      ],
      "bbox_max": [
        250.0,
        949.7266235351562,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        221.82235717773438,
        859.5471801757812,
        130.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -303.1000061035156,
      "bbox_min": [
        190.0,
        820.0,
        130.0
      ],
      "bbox_max": [
        226.98284912109375,
        885.2699584960938,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        195.3977813720703,
        820.0,
        130.0
      ],
      "bbox_max": [
        221.82235717773438,
        859.5471801757812,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        254.03262329101562,
        970.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        254.03262329101562,
        980.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        260.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1110.0,
        340.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        440.0,
        980.0,
        190.0
      ],
      "bbox_max": [
        450.0,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        -0.0,
        -0.9284767508506775
      ],
      "plane_d": 272.97216796875,
      "bbox_min": [
        254.03262329101562,
        980.0,
        190.0
      ],
      "bbox_max": [
        260.0,
        1240.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        254.03262329101562,
        980.0,
        190.0
      ],
      "bbox_max": [
        260.0,
        980.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "bbox_max": [
        254.03265380859375,
        1240.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        -0.0,
        -0.9284767508506775
      ],
      "plane_d": 272.97216796875,
      "bbox_min": [
        210.0,
        820.0,
        140.0
      ],
      "bbox_max": [
        254.03265380859375,
        1240.0,
        370.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        210.0,
        820.0,
        192.38694763183594
      ],
      "bbox_max": [
        254.03262329101562,
        980.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        210.0,
        820.0,
        210.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        370.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        210.0,
        841.853759765625,
        350.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        210.0,
        820.0,
        210.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        300.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        210.0,
        841.853759765625,
        210.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        210.0,
        820.0,
        280.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        224.19573974609375,
        820.0,
        280.0
      ],
      "bbox_max": [
        241.07882690429688,
        881.3681640625,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        210.0,
        820.0,
        280.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        210.0,
        841.853759765625,
        280.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        210.0,
        820.0,
        140.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        210.0,
        841.853759765625,
        140.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "bbox_max": [
        210.0,
        841.853759765625,
        370.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        195.3977813720703,
        820.0,
        160.0
      ],
      "bbox_max": [
        210.0,
        841.853759765625,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -159.99998474121094,
      "bbox_min": [
        195.3977813720703,
        820.0,
        160.0
      ],
      "bbox_max": [
        210.0,
        841.853759765625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        60.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        230.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        0.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        10.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        230.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": 796.7407836914062,
      "bbox_min": [
        10.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        10.0,
        1430.0,
        230.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        60.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        0.0,
        1240.0,
        80.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -165.0,
      "bbox_min": [
        0.0,
        1240.0,
        80.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -693.3753051757812,
      "bbox_min": [
        0.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        10.0,
        1265.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -693.3753051757812,
      "bbox_min": [
        0.0,
        1250.0,
        165.0
      ],
      "bbox_max": [
        10.0,
        1265.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        60.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1050.0,
        60.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        0.0,
        1000.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.32059618830680847,
        0.0,
        0.9472159743309021
      ],
      "plane_d": -69.65680694580078,
      "bbox_min": [
        0.0,
        1050.0,
        82.0
      ],
      "bbox_max": [
        90.0,
        1240.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        25.0,
        1210.0,
        82.0
      ],
      "bbox_max": [
        90.0,
        1210.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1050.0,
        82.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1050.0,
        104.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1050.0,
        126.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        9.500479698181152,
        842.9404907226562,
        155.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        110.0,
        949.7265625,
        175.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        175.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -702.5145263671875,
      "bbox_min": [
        9.500479698181152,
        842.9404907226562,
        155.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        9.500479698181152,
        842.9404907226562,
        175.0
      ],
      "bbox_max": [
        84.7259750366211,
        901.519287109375,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8381732702255249,
        0.5454040765762329,
        0.0
      ],
      "plane_d": -430.18701171875,
      "bbox_min": [
        64.65245056152344,
        888.1065673828125,
        155.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9825752973556519,
        0.18586482107639313,
        0.0
      ],
      "plane_d": -77.78153228759766,
      "bbox_min": [
        98.74483489990234,
        940.49951171875,
        155.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        175.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 23276,
      "centroid": [
        -325.0,
        1143.5,
        402.0
      ],
      "bbox_min": [
        -329.5,
        1140.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        402.0
      ],
      "dimensions_source": {
        "span_x": 9.0,
        "span_y": 7.0,
        "height_z": 0.0,
        "door_width": 9.0,
        "door_depth": 7.0,
        "leaf_depth": 7.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -329.5,
          1140.0,
          402.0
        ],
        [
          -320.5,
          1147.0,
          402.0
        ],
        [
          -329.5,
          1147.0,
          402.0
        ],
        [
          -320.5,
          1140.0,
          402.0
        ]
      ],
      "plane_distance": 402.0,
      "authentic_texture": "hotmarbwallwh-t_h"
    }
  ],
  "tutorial_messages": []
}